import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const TextSubscript20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.54 4.12c.2.18.23.5.05.7L9.16 10l4.08 4.77c-.18.29-.34.63-.42 1.04L8.5 10.77l-4.34 5.06a.5.5 0 1 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23l4.33-5.06a.5.5 0 0 1 .7-.05ZM15.58 12c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98-.21.36-.5.63-.79.86l-.42.3-.06.05-.34.24c-.32.24-.55.47-.67.75h2.1a.5.5 0 1 1 0 1H14.3a.54.54 0 0 1-.05 0 .5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28c.24-.19.42-.37.55-.58.25-.43.19-.73.07-.92a.89.89 0 0 0-.76-.37Z",
    fill: primaryFill
  }));
};

export const TextSubscript20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSubscript20RegularIcon, 'TextSubscript20Regular');

const TextSubscript24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.76 5.65a1 1 0 0 0-1.52-1.3L10 10.46 4.76 4.35a1 1 0 1 0-1.52 1.3L8.68 12l-5.44 6.35a1 1 0 0 0 1.52 1.3L10 13.54l5.07 5.91c.15-.83.52-1.47.94-1.97L11.31 12l5.45-6.35Zm1.98 9.1c-.4 0-.74.36-.74.77a1 1 0 1 1-2 0 2.78 2.78 0 0 1 5.1-1.54c.54.84.54 1.92-.06 2.94-.3.52-.72.9-1.1 1.2-.2.16-.39.3-.57.42l-.08.06a16.88 16.88 0 0 0-.83.65h2a1 1 0 0 1 0 2H17a1 1 0 0 1-1-1c0-1.52.9-2.37 1.66-2.94l.48-.35.08-.05.48-.35c.3-.24.5-.44.62-.66.27-.46.18-.71.1-.83a.81.81 0 0 0-.68-.32Z",
    fill: primaryFill
  }));
};

export const TextSubscript24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSubscript24FilledIcon, 'TextSubscript24Filled');

const TextSubscript24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.49 4.43c.31.27.35.74.08 1.06L10.99 12l5.03 5.87c-.3.41-.55.9-.68 1.51L10 13.15 4.57 19.5a.75.75 0 0 1-1.14-.98L9.01 12 3.43 5.49a.75.75 0 0 1 1.14-.98L10 10.85l5.43-6.34a.75.75 0 0 1 1.06-.08Zm1.26 11.1c0-.54.44-1.03.99-1.03.4 0 .73.2.89.43.14.21.22.57-.1 1.1a2.7 2.7 0 0 1-.68.72l-.49.37-.07.05-.48.34c-.74.56-1.56 1.34-1.56 2.74 0 .41.34.75.75.75h3.45a.75.75 0 0 0 0-1.5h-2.51c.16-.28.42-.52.78-.8l.43-.3.08-.06c.18-.13.37-.26.55-.41.38-.3.76-.66 1.05-1.14.56-.95.55-1.92.06-2.67a2.53 2.53 0 0 0-4.64 1.4.75.75 0 0 0 1.5 0Z",
    fill: primaryFill
  }));
};

export const TextSubscript24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSubscript24RegularIcon, 'TextSubscript24Regular');

const TextSuperscript16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 2.5a.25.25 0 1 1 .5 0c0 .1-.02.17-.03.2a.36.36 0 0 1-.09.12 7.96 7.96 0 0 1-.35.26h-.01l-.2.13a2.76 2.76 0 0 0-1.32 2.29c0 .41.34.75.75.75h2a.75.75 0 0 0 0-1.5h-.93a1.98 1.98 0 0 1 .45-.37c.18-.1.46-.29.67-.5.33-.32.56-.77.56-1.38a1.75 1.75 0 1 0-3.5 0 .75.75 0 0 0 1.5 0Zm-2.01 1.21a3.5 3.5 0 0 0-.49 1.76L7.5 8l3.56 4a.75.75 0 0 1-1.12 1L6.5 9.13 3.06 13a.75.75 0 1 1-1.12-1L5.5 8 1.94 4a.75.75 0 1 1 1.12-1L6.5 6.87 9.85 3.1c.09.23.22.44.39.61Z",
    fill: primaryFill
  }));
};

export const TextSuperscript16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript16FilledIcon, 'TextSuperscript16Filled');

const TextSuperscript16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2.5a.5.5 0 0 1 1 0c0 .26-.08.4-.19.5-.1.1-.2.17-.35.26l-.24.15C11.36 4 11 4.77 11 5.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-1.4a1.8 1.8 0 0 1 .81-.84c.17-.11.42-.27.6-.45.29-.29.49-.67.49-1.21a1.5 1.5 0 0 0-3 0 .5.5 0 0 0 1 0Zm-2 2c0-.5.12-1.01.36-1.48a.5.5 0 0 0-.23.15L6.5 7.25 2.87 3.17a.5.5 0 0 0-.74.66L5.83 8l-3.7 4.17a.5.5 0 0 0 .74.66L6.5 8.75l3.63 4.08a.5.5 0 1 0 .74-.66L7.17 8l2.86-3.22A1.5 1.5 0 0 1 10 4.5Z",
    fill: primaryFill
  }));
};

export const TextSuperscript16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript16RegularIcon, 'TextSuperscript16Regular');

const TextSuperscript20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.33 3.25c-.3 0-.58.29-.58.61a.75.75 0 0 1-1.5 0 2.12 2.12 0 0 1 3.88-1.17c.42.64.42 1.46-.04 2.24-.23.4-.55.69-.84.92l-.44.32-.06.05-.33.23c-.14.1-.25.2-.35.3h1.62a.75.75 0 0 1 0 1.5h-2.64a.76.76 0 0 1-.05 0 .75.75 0 0 1-.75-.75c0-1.16.69-1.8 1.27-2.25L14.9 5l.06-.04.37-.28c.23-.18.38-.34.48-.5.21-.36.14-.57.08-.66a.64.64 0 0 0-.55-.26ZM9.5 10l2.85-3.33c.13-.56.39-1 .67-1.36a1.75 1.75 0 0 1-.68-.93L8.5 8.85 4.35 4A.75.75 0 1 0 3.22 5L7.52 10l-4.3 5.01a.75.75 0 1 0 1.13.98l4.15-4.84L12.64 16a.75.75 0 1 0 1.14-.98L9.48 10Z",
    fill: primaryFill
  }));
};

export const TextSuperscript20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript20FilledIcon, 'TextSuperscript20Filled');

const TextSuperscript20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.58 3c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98-.21.36-.5.63-.79.86l-.42.3-.06.05-.34.24c-.32.24-.55.47-.67.75h2.1a.5.5 0 1 1 0 1H14.24a.5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28c.24-.19.42-.37.55-.58.25-.43.19-.73.07-.92a.89.89 0 0 0-.76-.37ZM12.8 4.22c.09.35.3.66.58.86L9.16 10l4.43 5.17a.5.5 0 1 1-.76.66L8.5 10.77l-4.34 5.06a.5.5 0 0 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23l4.3-5Z",
    fill: primaryFill
  }));
};

export const TextSuperscript20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript20RegularIcon, 'TextSuperscript20Regular');

const TextSuperscript24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.74 3.75c-.4 0-.74.36-.74.77a1 1 0 1 1-2 0 2.78 2.78 0 0 1 5.1-1.54c.54.84.54 1.92-.06 2.94-.3.52-.72.9-1.1 1.2-.2.16-.39.3-.57.42l-.08.06-.42.3c-.16.13-.3.24-.41.35h2a1 1 0 0 1 0 2H17a1 1 0 0 1-1-1c0-1.52.9-2.37 1.66-2.94l.48-.35.08-.05.48-.35c.3-.24.5-.44.62-.66.27-.46.18-.71.1-.83a.81.81 0 0 0-.68-.32ZM11.32 12l4.4-5.13c.13-.2.27-.38.42-.54A2 2 0 0 1 15 4.63l-5 5.83-5.24-6.11a1 1 0 1 0-1.52 1.3L8.68 12l-5.44 6.35a1 1 0 0 0 1.52 1.3L10 13.54l5.24 6.11a1 1 0 0 0 1.52-1.3L11.32 12Z",
    fill: primaryFill
  }));
};

export const TextSuperscript24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript24FilledIcon, 'TextSuperscript24Filled');

const TextSuperscript24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.74 3.5c-.55 0-.99.5-.99 1.02a.75.75 0 0 1-1.5 0 2.53 2.53 0 0 1 4.64-1.4c.49.75.5 1.72-.06 2.67-.29.48-.67.85-1.05 1.14-.18.15-.37.28-.55.41l-.08.06-.43.3c-.36.28-.62.52-.78.8h2.51a.75.75 0 0 1 0 1.5H17a.75.75 0 0 1-.75-.75c0-1.4.82-2.18 1.56-2.74l.48-.34.07-.05.5-.37c.3-.24.53-.47.68-.72.3-.53.23-.89.09-1.1a1.06 1.06 0 0 0-.9-.43Zm-3.48 1.21c.06.56.38 1.04.85 1.32L10.99 12l5.58 6.51a.75.75 0 1 1-1.14.98L10 13.15 4.57 19.5a.75.75 0 0 1-1.14-.98L9.01 12 3.43 5.49a.75.75 0 1 1 1.14-.98L10 10.85l5.26-6.14Z",
    fill: primaryFill
  }));
};

export const TextSuperscript24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextSuperscript24RegularIcon, 'TextSuperscript24Regular');

const TextT12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 2.75c0-.41.34-.75.75-.75h6c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5H6.5v5h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5H5v-5H3.5v.75a.75.75 0 0 1-1.5 0v-1.5Z",
    fill: primaryFill
  }));
};

export const TextT12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT12FilledIcon, 'TextT12Filled');

const TextT12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 2.5c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5V4a.5.5 0 0 1-1 0V3H6v6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H5V3H3v1a.5.5 0 0 1-1 0V2.5Z",
    fill: primaryFill
  }));
};

export const TextT12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT12RegularIcon, 'TextT12Regular');

const TextT16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 2.75c0-.41.34-.75.75-.75h9c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V3.5h-3v9h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H7v-9H4v.75a.75.75 0 0 1-1.5 0v-1.5Z",
    fill: primaryFill
  }));
};

export const TextT16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT16FilledIcon, 'TextT16Filled');

const TextT16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V3H8v10h1a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1h1V3H4v1.5a.5.5 0 0 1-1 0v-2Z",
    fill: primaryFill
  }));
};

export const TextT16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT16RegularIcon, 'TextT16Regular');

const TextT20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.75c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0V4.5h-3.5v11h1.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5H9v-11H5.5v.75a.75.75 0 0 1-1.5 0v-1.5Z",
    fill: primaryFill
  }));
};

export const TextT20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT20FilledIcon, 'TextT20Filled');

const TextT20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0V4h-4v12h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H9V4H5v1.5a.5.5 0 0 1-1 0v-2Z",
    fill: primaryFill
  }));
};

export const TextT20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT20RegularIcon, 'TextT20Regular');

const TextT24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 5a1 1 0 0 1 1-1h12.5a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V6H13v12h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V6H6.75v1a1 1 0 0 1-2 0V5Z",
    fill: primaryFill
  }));
};

export const TextT24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT24FilledIcon, 'TextT24Filled');

const TextT24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.75c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v2a.75.75 0 0 1-1.5 0V5.5h-4.75v13h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-13H6.5v1.25a.75.75 0 0 1-1.5 0v-2Z",
    fill: primaryFill
  }));
};

export const TextT24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT24RegularIcon, 'TextT24Regular');

const TextT28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V6h-6v16h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V6H7v2a1 1 0 0 1-2 0V5Z",
    fill: primaryFill
  }));
};

export const TextT28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT28FilledIcon, 'TextT28Filled');

const TextT28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.75c0-.41.34-.75.75-.75h16.5c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0V5.5h-6.75v17h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-17H6.5v2.75a.75.75 0 0 1-1.5 0v-3.5Z",
    fill: primaryFill
  }));
};

export const TextT28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT28RegularIcon, 'TextT28Regular');

const TextT32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5.25C6 4.56 6.56 4 7.25 4h17.5c.69 0 1.25.56 1.25 1.25v3.5a1.25 1.25 0 1 1-2.5 0V6.5h-6.25v19h1.5a1.25 1.25 0 1 1 0 2.5h-5.5a1.25 1.25 0 1 1 0-2.5h1.5v-19H8.5v2.25a1.25 1.25 0 1 1-2.5 0v-3.5Z",
    fill: primaryFill
  }));
};

export const TextT32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT32FilledIcon, 'TextT32Filled');

const TextT32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6h-7v20h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V6H8v3a1 1 0 0 1-2 0V5Z",
    fill: primaryFill
  }));
};

export const TextT32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT32RegularIcon, 'TextT32Regular');

const TextT48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 9.5c0-.83.67-1.5 1.5-1.5h25c.83 0 1.5.67 1.5 1.5v4a1.5 1.5 0 0 1-3 0V11h-9.5v26h3a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1 0-3h3V11H13v2.5a1.5 1.5 0 0 1-3 0v-4Z",
    fill: primaryFill
  }));
};

export const TextT48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT48FilledIcon, 'TextT48Filled');

const TextT48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 9.25c0-.69.56-1.25 1.25-1.25h25.5c.69 0 1.25.56 1.25 1.25V14a1.25 1.25 0 1 1-2.5 0v-3.5H25.25v27h3.5a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5h3.5v-27H12.5V14a1.25 1.25 0 1 1-2.5 0V9.25Z",
    fill: primaryFill
  }));
};

export const TextT48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextT48RegularIcon, 'TextT48Regular');

const TextTTag16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4.75v-1a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0V4.5h1.75v7H7A.75.75 0 0 0 7 13h2a.75.75 0 0 0 0-1.5h-.25v-7h1.75v.25a.75.75 0 0 0 1.5 0ZM4.25 6.69a.75.75 0 0 0-1.06.06L1.19 9a.75.75 0 0 0 0 1l2 2.25a.75.75 0 0 0 1.06.06.75.75 0 0 0 .06-1.06L2.75 9.5l1.56-1.75a.75.75 0 0 0-.06-1.06Zm8.56.06 2 2.25c.25.29.25.71 0 1l-2 2.25a.75.75 0 1 1-1.12-1l1.56-1.75-1.56-1.75a.75.75 0 1 1 1.12-1Z",
    fill: primaryFill
  }));
};

export const TextTTag16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextTTag16FilledIcon, 'TextTTag16Filled');

const TextTTag16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0V4H8.5v8H9a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1h.5V4H5v.5a.5.5 0 0 1-1 0v-1Zm.35 3.15c.2.2.2.5 0 .7L2.21 9.5l2.14 2.15a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0Zm10.5 2.5-2.5-2.5a.5.5 0 0 0-.7.7l2.14 2.15-2.14 2.15a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const TextTTag16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextTTag16RegularIcon, 'TextTTag16Regular');

const TextUnderline16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 13.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM4.75 2c.41 0 .75.34.75.75V8a2.5 2.5 0 1 0 5 0V2.75a.75.75 0 0 1 1.5 0V8a4 4 0 1 1-8 0V2.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const TextUnderline16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline16FilledIcon, 'TextUnderline16Filled');

const TextUnderline16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2c.28 0 .5.22.5.5V8c0 1.62 1.38 3 3 3s3-1.38 3-3V2.5a.5.5 0 0 1 1 0V8c0 2.18-1.82 4-4 4-2.18 0-4-1.82-4-4V2.5c0-.28.22-.5.5-.5ZM4 13.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextUnderline16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline16RegularIcon, 'TextUnderline16Regular');

const TextUnderline20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 3.75a.75.75 0 0 0-1.5 0V9c0 1.37.34 2.74 1.16 3.78A4.67 4.67 0 0 0 10 14.5c1.7 0 3-.65 3.84-1.72A6.09 6.09 0 0 0 15 9V3.75a.75.75 0 0 0-1.5 0V9a4.6 4.6 0 0 1-.84 2.85C12.13 12.53 11.3 13 10 13c-1.3 0-2.13-.47-2.66-1.15A4.6 4.6 0 0 1 6.5 9V3.75ZM5.75 15.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z",
    fill: primaryFill
  }));
};

export const TextUnderline20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline20FilledIcon, 'TextUnderline20Filled');

const TextUnderline20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3.5a.5.5 0 0 0-1 0v6.45A5.02 5.02 0 0 0 10 15c2.77 0 5-2.26 5-5.05V3.5a.5.5 0 0 0-1 0v6.45C14 12.2 12.2 14 10 14s-4-1.8-4-4.05V3.5Zm-1 13c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextUnderline20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline20RegularIcon, 'TextUnderline20Regular');

const TextUnderline24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5a1 1 0 0 1 2 0v6c0 3.46 1.32 5 4.25 5 2.93 0 4.25-1.54 4.25-5v-6a1 1 0 1 1 2 0v6c0 4.54-2.18 7-6.25 7-4.08 0-6.25-2.46-6.25-7v-6ZM7 21a1 1 0 1 1 0-2h10.5a1 1 0 1 1 0 2H7Z",
    fill: primaryFill
  }));
};

export const TextUnderline24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline24FilledIcon, 'TextUnderline24Filled');

const TextUnderline24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 19h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6-10.5Zm10.5-15c.38 0 .7.28.74.65l.01.1v6c0 4.4-2.06 6.75-6 6.75-3.86 0-5.91-2.26-6-6.47V4.75a.75.75 0 0 1 1.5-.1v6.1C7.5 14.35 8.93 16 12 16c2.98 0 4.43-1.56 4.5-4.98V4.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const TextUnderline24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderline24RegularIcon, 'TextUnderline24Regular');

const TextUnderlineDouble20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.97 2.98c.52.25.91.74 1.17 1.46a.75.75 0 1 1-1.4.51c-.18-.47-.35-.59-.44-.63-.12-.06-.27-.07-.58-.07a.69.69 0 0 0-.5.17c-.12.1-.22.27-.3.5a2.81 2.81 0 0 0-.17.88c0 .41 0 .9.16 1.3.08.18.17.32.3.42.11.1.3.2.6.23.08 0 .28 0 .48-.07a.8.8 0 0 0 .46-.45.75.75 0 0 1 1.37.61c-.63 1.42-2.03 1.45-2.48 1.4a2.58 2.58 0 0 1-1.4-.56c-.35-.3-.58-.68-.72-1.04a5 5 0 0 1-.27-1.8v-.08a3.36 3.36 0 0 1 .03-.4c.03-.26.1-.61.23-.97.14-.36.35-.77.72-1.09.37-.34.87-.55 1.49-.55h.03c.28 0 .75 0 1.22.23Zm-11.58.27A.75.75 0 0 0 4 3.23l-1.94 5a.75.75 0 1 0 1.4.54l.1-.27h2.11l.1.25a.75.75 0 0 0 1.4-.5l-1.77-5ZM5.13 7h-1l.53-1.34L5.13 7ZM8 3.5v5c0 .41.34.75.75.75h1.75c.24 0 .73-.04 1.2-.3.52-.3.92-.87.92-1.7 0-.43-.1-.8-.28-1.12a1.7 1.7 0 0 0-.29-.35c.15-.27.24-.62.24-1.02 0-.41-.08-.77-.25-1.08a1.69 1.69 0 0 0-.66-.67c-.46-.26-.95-.26-1.12-.26H8.75A.75.75 0 0 0 8 3.5Zm2.5 4.25h-1v-1H10.44c.19 0 .38.01.51.08.05.02.08.05.1.08.03.04.07.13.07.33 0 .17-.04.26-.06.3a.3.3 0 0 1-.12.1.96.96 0 0 1-.44.11Zm-.88-2.5H9.5v-1h.75c.16 0 .3.01.4.07a.2.2 0 0 1 .08.08c.02.04.06.15.06.36 0 .18-.03.27-.06.3a.25.25 0 0 1-.1.1.76.76 0 0 1-.35.09h-.66Zm-8.12 7c0-.41.34-.75.75-.75h15.5a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1-.75-.75Zm.75 3.25a.75.75 0 0 0 0 1.5h15.5a.75.75 0 0 0 0-1.5H2.25Z",
    fill: primaryFill
  }));
};

export const TextUnderlineDouble20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderlineDouble20FilledIcon, 'TextUnderlineDouble20Filled');

const TextUnderlineDouble20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.94 3c.21 0 .4.14.47.33l1.77 5a.5.5 0 0 1-.94.34L6 8H3.73l-.26.68a.5.5 0 1 1-.94-.36l1.94-5A.5.5 0 0 1 4.94 3Zm-.02 1.94L4.12 7h1.53l-.73-2.06Zm12.49-.41c-.25-.69-.6-1.1-1.06-1.33-.4-.2-.83-.2-1.1-.2h-.03c-.55 0-1 .19-1.33.49-.32.29-.52.65-.64.99A4.06 4.06 0 0 0 13 5.77v.05c0 .39 0 1.09.25 1.73.13.33.33.67.66.93.32.27.74.45 1.25.5.42.05 1.67.02 2.23-1.24a.5.5 0 1 0-.9-.4c-.3.64-.94.68-1.22.65a1.34 1.34 0 0 1-.73-.28 1.26 1.26 0 0 1-.36-.52A3.89 3.89 0 0 1 14 5.8V5.8a1.78 1.78 0 0 1 .02-.28c.03-.2.07-.44.16-.68.1-.25.22-.45.38-.6a.94.94 0 0 1 .66-.23c.3 0 .5 0 .7.1.15.08.36.25.55.77a.5.5 0 1 0 .94-.34Zm-5.94 1.3c.2-.26.32-.62.32-1.07 0-.38-.07-.7-.22-.96a1.44 1.44 0 0 0-.56-.57c-.4-.23-.84-.23-1-.23H8.5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1.75c.22 0 .66-.03 1.07-.27.45-.26.8-.74.8-1.49 0-.38-.09-.7-.25-.98a1.45 1.45 0 0 0-.4-.42Zm-.95-1.73c.07.04.13.1.18.18a1 1 0 0 1 .1.48c0 .4-.16.54-.28.62-.17.1-.38.12-.5.12H9V4h1c.16 0 .36.01.52.1ZM9.36 6.5h.83c.18 0 .43 0 .62.1.1.05.16.1.2.18.06.09.1.22.1.46 0 .38-.14.54-.3.62-.18.11-.42.14-.56.14H9V6.5h.36ZM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z",
    fill: primaryFill
  }));
};

export const TextUnderlineDouble20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderlineDouble20RegularIcon, 'TextUnderlineDouble20Regular');

const TextUnderlineDouble24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.2 4.97a3.21 3.21 0 0 0-1.56-1.92c-.61-.3-1.24-.3-1.6-.3H19c-.8 0-1.47.28-1.96.72-.48.43-.77.96-.94 1.43a5.62 5.62 0 0 0-.35 1.8v.09c0 .5 0 1.47.35 2.36.19.48.49.97.96 1.36.49.4 1.1.65 1.83.73.6.07 2.43.03 3.27-1.82a1 1 0 0 0-1.82-.82c-.16.34-.38.5-.6.58-.25.09-.51.09-.63.08-.4-.05-.62-.17-.77-.3a1.3 1.3 0 0 1-.38-.54 4.7 4.7 0 0 1-.21-1.67 2.46 2.46 0 0 1 .03-.34c.03-.24.08-.53.19-.8.1-.3.24-.5.4-.64a.9.9 0 0 1 .63-.22c.4 0 .6.02.76.1.1.05.33.2.55.8a1 1 0 1 0 1.88-.68ZM14.5 6.71c.2-.36.32-.8.32-1.33 0-.54-.1-1.01-.33-1.42-.22-.41-.53-.7-.86-.88a2.96 2.96 0 0 0-1.45-.33H10a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2.38c.3 0 .96-.04 1.58-.37a2.4 2.4 0 0 0 1.29-2.25c0-.56-.12-1.05-.37-1.46-.11-.18-.23-.33-.37-.46Zm-1.85-1.88c.03.01.06.04.08.08a1 1 0 0 1 .09.47.8.8 0 0 1-.08.39.31.31 0 0 1-.12.12.98.98 0 0 1-.46.11H11V4.75h1.16c.22 0 .4.01.5.08ZM12.17 8h.2c.26 0 .5.01.67.1.07.03.1.06.13.1.03.05.08.17.08.43 0 .2-.05.3-.07.34a.4.4 0 0 1-.16.14c-.2.1-.47.14-.64.14H11V8h1.17ZM5.03 2.75a1 1 0 0 1 .93.67l2.3 6.5a1 1 0 1 1-1.88.66l-.19-.53H3.65l-.22.56a1 1 0 1 1-1.86-.72l2.51-6.5a1 1 0 0 1 .95-.64Zm-.05 3.88-.56 1.42h1.06l-.5-1.42ZM1.5 15a1 1 0 0 1 1-1h19a1 1 0 1 1 0 2h-19a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h19a1 1 0 1 0 0-2h-19Z",
    fill: primaryFill
  }));
};

export const TextUnderlineDouble24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderlineDouble24FilledIcon, 'TextUnderlineDouble24Filled');

const TextUnderlineDouble24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.53 3.27c.61.3 1.1.87 1.43 1.79a.75.75 0 1 1-1.42.5c-.23-.64-.5-.85-.67-.94-.22-.1-.47-.12-.87-.12-.38 0-.62.12-.8.28-.2.17-.35.43-.47.73a3.87 3.87 0 0 0-.23 1.23v.01c0 .53 0 1.2.23 1.76.1.27.25.49.45.65.19.16.47.3.9.34.35.04 1.13-.02 1.49-.8a.75.75 0 1 1 1.36.62c-.77 1.7-2.46 1.74-3.01 1.68a3.15 3.15 0 0 1-1.7-.68 3.04 3.04 0 0 1-.89-1.26A6.28 6.28 0 0 1 16 6.78V6.7a4.09 4.09 0 0 1 .04-.51c.04-.32.12-.76.29-1.2.17-.45.43-.94.87-1.33.45-.4 1.05-.66 1.8-.66h.04c.36 0 .93 0 1.49.27ZM5.28 3c.31 0 .59.2.7.5l2.3 6.5a.75.75 0 0 1-1.41.5l-.34-.95h-2.7l-.38.97a.75.75 0 0 1-1.4-.54l2.52-6.5c.11-.3.4-.48.7-.48Zm-.04 2.9L4.4 8.06H6L5.24 5.9Zm9.34-.52c0 .57-.15 1.03-.39 1.38.18.14.34.32.47.54.23.36.34.8.34 1.33a2.15 2.15 0 0 1-1.16 2.03 3.2 3.2 0 0 1-1.46.34H9.75a.75.75 0 0 1-.75-.75v-6.5c0-.41.34-.75.75-.75h2.43c.22 0 .8 0 1.34.3.29.16.57.41.76.78.2.36.3.8.3 1.3Zm-2.42-.88H10.5v1.75h1.66c.15 0 .4-.03.6-.15a.56.56 0 0 0 .2-.2c.06-.1.12-.26.12-.52 0-.32-.06-.5-.12-.59a.44.44 0 0 0-.18-.18c-.17-.1-.4-.11-.62-.11Zm.22 5c.18 0 .5-.03.75-.17.12-.06.2-.13.26-.22a.88.88 0 0 0 .11-.48c0-.3-.06-.46-.12-.55a.52.52 0 0 0-.22-.2 1.81 1.81 0 0 0-.78-.13H10.5V9.5h1.88ZM2 15.25c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Zm.75 4.25a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75Z",
    fill: primaryFill
  }));
};

export const TextUnderlineDouble24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextUnderlineDouble24RegularIcon, 'TextUnderlineDouble24Regular');

const TextWholeWord20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 15.75v.5A1.75 1.75 0 0 1 17.25 18H2.75A1.75 1.75 0 0 1 1 16.25v-.5a.75.75 0 1 1 1.5 0v.5a.25.25 0 0 0 .25.25h14.5a.25.25 0 0 0 .25-.25v-.5a.75.75 0 1 1 1.5 0ZM3.83 10.38a4.17 4.17 0 0 1 2.53-.61c.37.02.74.07 1.1.16a.97.97 0 0 0-.55-.76c-.4-.18-.83-.26-1.26-.23-.37 0-.73.08-1.07.23a.75.75 0 1 1-.67-1.34c.53-.25 1.1-.38 1.69-.4.69-.03 1.37.1 1.99.4A2.69 2.69 0 0 1 9 10.46v4.04a.75.75 0 1 1-1.5.06 3.73 3.73 0 0 1-2.95.56 2.61 2.61 0 0 1-.72-4.74Zm1.11 3.3a2.92 2.92 0 0 0 2.56-1V11.5a4.5 4.5 0 0 0-1.22-.23 2.68 2.68 0 0 0-1.62.36 1.11 1.11 0 0 0 .28 2.05Zm6.06.82V4a.75.75 0 1 1 1.5 0v4.66A2.7 2.7 0 0 1 14.25 8a3.28 3.28 0 0 1 3 3.5 3.28 3.28 0 0 1-3 3.5c-.64 0-1.26-.24-1.75-.66v.16a.75.75 0 1 1-1.5 0Zm1.75-3a1.8 1.8 0 0 0 1.5 2 1.8 1.8 0 0 0 1.5-2 1.8 1.8 0 0 0-1.5-2 1.8 1.8 0 0 0-1.5 2Z",
    fill: primaryFill
  }));
};

export const TextWholeWord20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWholeWord20FilledIcon, 'TextWholeWord20Filled');

const TextWholeWord20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 15a.5.5 0 0 0 .5-.5v-.4a2.76 2.76 0 0 0 2 .9 3.28 3.28 0 0 0 3-3.5A3.28 3.28 0 0 0 14 8a2.77 2.77 0 0 0-2 .9V4a.5.5 0 0 0-1 0v10.5a.5.5 0 0 0 .5.5ZM14 9a2.29 2.29 0 0 1 2 2.5 2.29 2.29 0 0 1-2 2.5 2.29 2.29 0 0 1-2-2.5A2.29 2.29 0 0 1 14 9Zm-9.13 5.88a3.72 3.72 0 0 0 3.13-.8v.42a.5.5 0 0 0 1 0v-4.04a2.45 2.45 0 0 0-1.28-2.4 3.88 3.88 0 0 0-1.86-.37c-.55.01-1.09.14-1.58.36a.5.5 0 0 0 .44.9c.37-.17.77-.25 1.17-.26.48-.03.95.06 1.39.26A1.35 1.35 0 0 1 8 10.27a5.73 5.73 0 0 0-1.4-.25 3.92 3.92 0 0 0-2.38.56 2.36 2.36 0 0 0 .65 4.3Zm-.1-3.46a2.93 2.93 0 0 1 1.78-.4c.5.02.98.13 1.45.3v1.47a3.23 3.23 0 0 1-2.87 1.13 1.36 1.36 0 0 1-.35-2.5ZM19 16v.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 16.5V16a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 1 1 0Z",
    fill: primaryFill
  }));
};

export const TextWholeWord20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWholeWord20RegularIcon, 'TextWholeWord20Regular');

const TextWordCount20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.98 14.54c-.26.27-.55.51-.86.7a.5.5 0 1 1-.54-.83A3.33 3.33 0 0 0 3 12.62a.5.5 0 0 1 .99.11v5.77a.5.5 0 0 1-1 0v-3.96Zm4.6-1.3c-.62 0-1.09.53-1.09 1.06a.5.5 0 0 1-1 0 2.1 2.1 0 0 1 2.1-2.07c.72 0 1.42.33 1.81.91.41.61.43 1.41-.06 2.21-.24.4-.58.71-.91.97l-.5.35-.08.05-.4.28c-.43.32-.74.6-.88 1h2.6a.5.5 0 0 1 0 1H5.98a.5.5 0 0 1-.5-.5c0-1.17.7-1.82 1.37-2.3l.43-.3.07-.05.46-.33c.29-.22.52-.44.67-.69.31-.51.24-.89.08-1.13a1.18 1.18 0 0 0-.98-.47Zm4.48.25a.92.92 0 0 0-.28.43.5.5 0 1 1-.96-.28c.08-.27.25-.62.6-.9.34-.3.83-.5 1.49-.5 1.32 0 2.1.93 2.1 1.8 0 .35-.06.87-.43 1.32a1.8 1.8 0 0 1-.22.22 1.65 1.65 0 0 1 .65 1.34 2 2 0 0 1-.68 1.62c-.42.35-.95.46-1.42.46-.45 0-.89-.07-1.27-.3-.38-.24-.65-.6-.81-1.09a.5.5 0 1 1 .95-.32c.1.3.24.46.39.55.15.1.38.16.74.16.33 0 .6-.08.79-.23.16-.14.31-.38.31-.84 0-.2-.05-.32-.11-.41a.78.78 0 0 0-.32-.24c-.3-.13-.68-.16-.94-.16a.5.5 0 0 1 0-1c.71 0 1.02-.22 1.16-.4.16-.19.21-.45.21-.68 0-.28-.28-.8-1.1-.8-.44 0-.7.12-.85.25ZM2 9.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.25Zm0-5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25Zm14 10c0-.41.34-.75.75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWordCount20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWordCount20FilledIcon, 'TextWordCount20Filled');

const TextWordCount20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5ZM7.6 13c-.62 0-1.1.55-1.1 1.14a.5.5 0 0 1-1 0 2.14 2.14 0 0 1 3.91-1.2c.4.63.43 1.45-.05 2.27-.25.41-.58.73-.92 1l-.5.37-.07.05-.4.3c-.44.32-.76.64-.9 1.07h2.6a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5c0-1.2.7-1.87 1.36-2.38l.43-.3.07-.06c.16-.11.32-.22.46-.34.3-.23.52-.45.67-.72.32-.54.25-.95.08-1.21A1.16 1.16 0 0 0 7.6 13Zm4.48.27a.99.99 0 0 0-.29.46.5.5 0 1 1-.96-.28c.08-.26.25-.63.59-.93.34-.3.84-.52 1.5-.52 1.34 0 2.1.98 2.1 1.86 0 .36-.06.9-.43 1.36-.07.09-.15.17-.24.25a1.66 1.66 0 0 1 .67 1.4c0 .72-.24 1.28-.67 1.65-.42.36-.95.48-1.43.48-.46 0-.9-.08-1.28-.32a2 2 0 0 1-.8-1.12.5.5 0 1 1 .95-.3c.1.32.24.49.4.58.15.1.38.16.73.16.32 0 .6-.08.78-.24.17-.14.32-.4.32-.9a.73.73 0 0 0-.12-.44.79.79 0 0 0-.31-.25c-.3-.14-.68-.17-.94-.17a.5.5 0 1 1 0-1c.7 0 1.01-.22 1.16-.4.16-.21.21-.49.21-.74 0-.32-.3-.86-1.1-.86-.43 0-.69.13-.84.27Zm-9.06 1.1a4.8 4.8 0 0 1-.85.73.5.5 0 1 1-.56-.83 3.46 3.46 0 0 0 1.42-1.88s.11-.39.46-.39c.5 0 .53.5.53.5v6a.5.5 0 0 1-1 0v-4.14Zm13 .13c0-.28.21-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextWordCount20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWordCount20RegularIcon, 'TextWordCount20Regular');

const TextWordCount24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm16 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-3.96-.87a.5.5 0 0 0-.14.22 1 1 0 1 1-1.93-.52c.1-.33.3-.79.7-1.17.43-.4 1.04-.66 1.8-.66A2.44 2.44 0 0 1 17 17.36c0 .39-.07 1.02-.47 1.59l.1.12c.24.37.37.8.37 1.3 0 .83-.27 1.53-.81 2.02-.53.46-1.17.61-1.72.61-.5 0-1.03-.09-1.51-.4a2.5 2.5 0 0 1-.98-1.4 1 1 0 0 1 1.91-.59c.08.26.16.3.18.32.03.02.12.07.4.07.22 0 .34-.06.39-.1.03-.03.14-.14.14-.54 0-.12-.03-.16-.03-.17 0 0-.03-.04-.1-.07a1.6 1.6 0 0 0-.66-.12 1 1 0 1 1 0-2c.28 0 .45-.05.54-.09a.35.35 0 0 0 .14-.1c.07-.09.11-.24.11-.45a.36.36 0 0 0-.1-.21c-.07-.07-.19-.15-.43-.15-.28 0-.39.08-.43.13Zm-6.23.5c0-.15.07-.33.18-.46.1-.12.23-.17.34-.17.23 0 .4.11.48.24.06.1.14.32-.09.73-.1.19-.27.37-.52.58l-.42.32-.06.05c-.13.1-.28.2-.42.32-.69.54-1.49 1.35-1.49 2.76a1 1 0 0 0 1 1H9.83a1 1 0 1 0 0-2H8.31l.23-.2.37-.27.07-.06c.16-.11.33-.24.5-.39.34-.28.72-.65 1-1.14.52-.95.52-1.96.03-2.75A2.56 2.56 0 0 0 8.33 15c-1.55 0-2.52 1.4-2.52 2.64a1 1 0 0 0 2 0Zm-5.26 1.39a1 1 0 0 1-1.13-1.66 2.97 2.97 0 0 0 1.15-1.56 1 1 0 0 1 1.98.2v6a1 1 0 1 1-2 0v-2.98Z",
    fill: primaryFill
  }));
};

export const TextWordCount24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWordCount24FilledIcon, 'TextWordCount24Filled');

const TextWordCount24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75Zm0 6.5c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Zm17 6.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm-16.58-.01c.2-.14.41-.3.6-.48v3.99a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.48-.16c-.13.58-.7 1.39-1.46 1.9a.75.75 0 0 0 .84 1.25ZM8 17.52c0-.52.44-1.02.99-1.02.4 0 .73.2.89.43.13.21.22.57-.1 1.1a2.7 2.7 0 0 1-.68.72l-.49.37-.07.05-.48.34c-.74.56-1.56 1.34-1.56 2.74 0 .41.34.75.75.75h3.45a.75.75 0 0 0 0-1.5H8.2c.16-.28.42-.52.78-.8l.43-.3.08-.06c.18-.13.37-.26.55-.41.38-.3.76-.66 1.05-1.14.56-.95.55-1.92.06-2.67a2.53 2.53 0 0 0-4.64 1.4.75.75 0 0 0 1.5 0Zm6.47-.38c.03-.11.1-.27.25-.4.13-.11.36-.24.78-.24.76 0 1 .5 1 .73 0 .24-.05.49-.19.66-.11.14-.38.36-1.1.36a.75.75 0 0 0 0 1.5c.27 0 .65.04.93.17.13.06.22.13.27.2.04.06.09.17.09.36 0 .48-.15.7-.28.8-.15.14-.4.22-.72.22-.36 0-.57-.06-.7-.14-.1-.07-.23-.2-.34-.53a.75.75 0 0 0-1.42.47c.18.57.5 1.03.97 1.33.45.28.98.37 1.49.37a2.6 2.6 0 0 0 1.69-.56c.52-.45.81-1.12.81-1.96a2.07 2.07 0 0 0-.63-1.52l.11-.14c.44-.55.52-1.19.52-1.6 0-1.07-.93-2.22-2.5-2.22a2.6 2.6 0 0 0-1.77.62c-.4.35-.61.78-.7 1.1a.75.75 0 1 0 1.44.42Z",
    fill: primaryFill
  }));
};

export const TextWordCount24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWordCount24RegularIcon, 'TextWordCount24Regular');

const TextWrap16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Zm0 4a.75.75 0 0 0 0 1.5h9.5a1.25 1.25 0 1 1 0 2.5h-1.69l.22-.22a.75.75 0 1 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22h1.69a2.75 2.75 0 1 0 0-5.5h-9.5ZM2 11.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWrap16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap16FilledIcon, 'TextWrap16Filled');

const TextWrap16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 4c0-.28.22-.5.5-.5h10a2.5 2.5 0 0 1 0 5H9.7l.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.79a1.5 1.5 0 0 0 0-3h-10a.5.5 0 0 1-.5-.5ZM6 11a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1H6Z",
    fill: primaryFill
  }));
};

export const TextWrap16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap16RegularIcon, 'TextWrap16Regular');

const TextWrap20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.25c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.25Zm0 5c0-.41.34-.75.75-.75h13a3.25 3.25 0 0 1 0 6.5h-3.4l.23.27a.75.75 0 0 1-1.16.96l-1.25-1.5a.75.75 0 0 1 0-.96l1.25-1.5a.75.75 0 0 1 1.16.96l-.23.27h3.4a1.75 1.75 0 1 0 0-3.5h-13A.75.75 0 0 1 2 9.25Zm0 5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWrap20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap20FilledIcon, 'TextWrap20Filled');

const TextWrap20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5H16a3 3 0 1 1 0 6h-4.3l.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65H16a2 2 0 1 0 0-4H2.5a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextWrap20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap20RegularIcon, 'TextWrap20Regular');

const TextWrap24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H3Zm12.41 0H19a2 2 0 1 0 0-4H3a1 1 0 1 1 0-2h16a4 4 0 0 1 0 8h-3.59l.3.3a1 1 0 0 1-1.42 1.4l-2-2a1 1 0 0 1 0-1.4l2-2a1 1 0 0 1 1.42 1.4l-.3.3Z",
    fill: primaryFill
  }));
};

export const TextWrap24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap24FilledIcon, 'TextWrap24Filled');

const TextWrap24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75Zm0 6.5a.75.75 0 0 0 0 1.5H19a2.5 2.5 0 0 1 0 5h-4.44l.72-.72a.75.75 0 1 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72H19a4 4 0 0 0 0-8H2.75ZM2 18.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWrap24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrap24RegularIcon, 'TextWrap24Regular');

const TextWrapOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m11.8 12.5 2.35 2.35a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L2.39 3.1a.75.75 0 0 0 .36 1.41h1.04L6.3 7H2.75a.75.75 0 0 0 0 1.5h5.04l1.58 1.57-1.15 1.15c-.3.3-.3.77 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22h1.23ZM9.11 7l1.5 1.5h1.63a1.25 1.25 0 0 1 .67 2.3L14 11.87A2.74 2.74 0 0 0 12.25 7H9.12Zm-4-4 1.5 1.5h6.63a.75.75 0 0 0 0-1.5H5.12ZM2 11.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWrapOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff16FilledIcon, 'TextWrapOff16Filled');

const TextWrapOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.15 14.85 11.29 12H9.71l.64.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7L9.29 10l-2-2H2.5a.5.5 0 0 1 0-1h3.8l-3-3h-.8a.5.5 0 0 1-.18-.97L1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7ZM10.12 8l-1-1h3.38a2.5 2.5 0 0 1 1.27 4.65l-.74-.74A1.5 1.5 0 0 0 12.5 8h-2.38Zm-4-4-1-1h8.38a.5.5 0 0 1 0 1H6.12ZM6 11a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1H6Z",
    fill: primaryFill
  }));
};

export const TextWrapOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff16RegularIcon, 'TextWrapOff16Regular');

const TextWrapOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.15 2.15c.2-.2.5-.2.7 0l15 15a.5.5 0 0 1-.7.7L14.29 15h-1.94l.23.27a.75.75 0 0 1-1.16.96l-1.25-1.5a.75.75 0 0 1 0-.96l1.25-1.5a.75.75 0 0 1 .07-.07L9.3 10H2.75a.75.75 0 0 1 0-1.5h5.04L4.3 5H2.75a.75.75 0 0 1 0-1.5h.04l-.64-.65a.5.5 0 0 1 0-.7Zm8.47 6.35h5.13a3.25 3.25 0 0 1 1.16 6.29l-1.29-1.29h.13a1.75 1.75 0 1 0 0-3.5h-3.63l-1.5-1.5ZM7.12 5l-1.5-1.5h11.63a.75.75 0 0 1 0 1.5H7.12Zm-4.37 8.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z",
    fill: primaryFill
  }));
};

export const TextWrapOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff20FilledIcon, 'TextWrapOff20Filled');

const TextWrapOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L3.29 4H2.5a.5.5 0 0 0 0 1h1.8l4 4H2.5a.5.5 0 0 0 0 1h6.8l2.52 2.53a.5.5 0 0 0-.17.12l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65h2.58l2.86 2.85a.5.5 0 0 0 .7-.7l-15-15ZM13.3 14h-1.58l.64-.65a.5.5 0 0 0 .12-.17l.82.82Zm-2.17-5 1 1H16a2 2 0 0 1 .12 4l.84.84A3 3 0 0 0 16 9h-4.88Zm-5-5 1 1H17.5a.5.5 0 0 0 0-1H6.12ZM2 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextWrapOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff20RegularIcon, 'TextWrapOff20Regular');

const TextWrapOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06L3.94 5H3a1 1 0 0 0 0 2h2.94l4 4H3a1 1 0 1 0 0 2h8.94l2.32 2.32-1.97 1.97a1 1 0 0 0 0 1.42l2 2a1 1 0 0 0 1.42-1.42l-.3-.29h2.53l2.78 2.78a.75.75 0 0 0 1.06-1.06L3.28 2.22ZM14.18 11H19a4 4 0 0 1 2.39 7.2l-1.45-1.44A2 2 0 0 0 19 13h-2.82l-2-2Zm-4-4-2-2H21a1 1 0 1 1 0 2H10.18ZM2 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
    fill: primaryFill
  }));
};

export const TextWrapOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff24FilledIcon, 'TextWrapOff24Filled');

const TextWrapOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06L3.94 5H2.75a.75.75 0 0 0 0 1.5h2.69l5 5H2.75a.75.75 0 0 0 0 1.5h9.19l3.03 3.03a.75.75 0 0 0-.75.19l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72h3.88l2.28 2.28a.75.75 0 0 0 1.06-1.06L3.28 2.22ZM16.94 18h-2.38l.72-.72c.2-.2.27-.5.19-.75L16.94 18ZM19 11.5h-4.32l1.5 1.5H19a2.5 2.5 0 0 1 1.6 4.42l1.06 1.06A3.99 3.99 0 0 0 19 11.5ZM8.18 5l1.5 1.5h11.57a.75.75 0 0 0 0-1.5H8.18ZM2 18.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TextWrapOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextWrapOff24RegularIcon, 'TextWrapOff24Regular');

const Textbox16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Zm1 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Zm0 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const Textbox16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox16FilledIcon, 'Textbox16Filled');

const Textbox16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm-1-7A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Z",
    fill: primaryFill
  }));
};

export const Textbox16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox16RegularIcon, 'Textbox16Regular');

const Textbox20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM6 6.75c0-.41.32-.75.7-.75h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75Zm0 3c0-.41.32-.75.7-.75h3.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75ZM6.7 12h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75Z",
    fill: primaryFill
  }));
};

export const Textbox20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox20FilledIcon, 'Textbox20Filled');

const Textbox20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9C4 4.67 4.67 4 5.5 4Z",
    fill: primaryFill
  }));
};

export const Textbox20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox20RegularIcon, 'Textbox20Regular');

const Textbox24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75Zm-6.75 5.75a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h7.6Zm-7.5 4h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h.1Zm10.5-8a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6Z",
    fill: primaryFill
  }));
};

export const Textbox24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox24FilledIcon, 'Textbox24Filled');

const Textbox24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5Zm0 1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25Zm-4 7h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5Zm-7.5 4h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h.1Zm10.5-8H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5Z",
    fill: primaryFill
  }));
};

export const Textbox24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Textbox24RegularIcon, 'Textbox24Regular');

const TextboxAlignBottom20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9ZM6.7 14h6.6c.38 0 .7-.34.7-.75s-.32-.75-.7-.75H6.7c-.38 0-.7.34-.7.75s.32.75.7.75Zm0-3h6.6c.38 0 .7-.34.7-.75s-.32-.75-.7-.75H6.7c-.38 0-.7.34-.7.75s.32.75.7.75Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottom20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottom20FilledIcon, 'TextboxAlignBottom20Filled');

const TextboxAlignBottom20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 10a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Zm0 3h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Zm3.5 1.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9ZM5.5 16h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottom20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottom20RegularIcon, 'TextboxAlignBottom20Regular');

const TextboxAlignBottom24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5ZM6.75 13.5h-.1a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5H6.75Zm10.5 3H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottom24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottom24FilledIcon, 'TextboxAlignBottom24Filled');

const TextboxAlignBottom24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 13.5h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h.1Zm10.5 3H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5ZM21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75ZM5.75 4.5h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottom24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottom24RegularIcon, 'TextboxAlignBottom24Regular');

const TextboxAlignBottomRotate9020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm6.5 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-.5-.5ZM7 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottomRotate9020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottomRotate9020FilledIcon, 'TextboxAlignBottomRotate9020Filled');

const TextboxAlignBottomRotate9020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 5c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5ZM7 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottomRotate9020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottomRotate9020RegularIcon, 'TextboxAlignBottomRotate9020Regular');

const TextboxAlignBottomRotate9024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 18.25A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5ZM10.5 6.75v-.1a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1V6.75Zm-3 10.5V6.65a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottomRotate9024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottomRotate9024FilledIcon, 'TextboxAlignBottomRotate9024Filled');

const TextboxAlignBottomRotate9024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 6.75v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v.1Zm-3 10.5V6.65a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1ZM18.25 21A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5ZM19.5 5.75v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25Z",
    fill: primaryFill
  }));
};

export const TextboxAlignBottomRotate9024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignBottomRotate9024RegularIcon, 'TextboxAlignBottomRotate9024Regular');

const TextboxAlignCenter20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9Zm-10.3 2h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75Zm1 3h4.6c.38 0 .7.34.7.75s-.32.75-.7.75H7.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75Z",
    fill: primaryFill
  }));
};

export const TextboxAlignCenter20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignCenter20FilledIcon, 'TextboxAlignCenter20Filled');

const TextboxAlignCenter20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9Zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5ZM6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm1 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignCenter20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignCenter20RegularIcon, 'TextboxAlignCenter20Regular');

const TextboxAlignCenter24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5ZM7 10h-.14c-.48.06-.86.37-.86.75 0 .41.45.75 1 .75h10.14c.48-.06.86-.37.86-.75 0-.41-.45-.75-1-.75H7Zm8.33 3H8.57c-.32.06-.57.37-.57.75 0 .41.3.75.67.75h6.76c.32-.06.57-.37.57-.75 0-.41-.3-.75-.67-.75Z",
    fill: primaryFill
  }));
};

export const TextboxAlignCenter24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignCenter24FilledIcon, 'TextboxAlignCenter24Filled');

const TextboxAlignCenter24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 10h10c.55 0 1 .34 1 .75 0 .38-.38.7-.86.74l-.14.01H7c-.55 0-1-.34-1-.75 0-.38.38-.7.86-.74L7 10Zm8.33 3H8.57c-.32.06-.57.37-.57.75 0 .41.3.75.67.75h6.76c.32-.06.57-.37.57-.75 0-.41-.3-.75-.67-.75ZM21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75ZM5.75 4.5h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25Z",
    fill: primaryFill
  }));
};

export const TextboxAlignCenter24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignCenter24RegularIcon, 'TextboxAlignCenter24Regular');

const TextboxAlignMiddle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9ZM6 8.25c0 .41.32.75.7.75h6.6c.38 0 .7-.34.7-.75s-.32-.75-.7-.75H6.7c-.38 0-.7.34-.7.75Zm.7 2.25c-.38 0-.7.34-.7.75s.32.75.7.75h6.6c.38 0 .7-.34.7-.75s-.32-.75-.7-.75H6.7Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddle20FilledIcon, 'TextboxAlignMiddle20Filled');

const TextboxAlignMiddle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm8-8A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9Zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddle20RegularIcon, 'TextboxAlignMiddle20Regular');

const TextboxAlignMiddle24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5ZM7 10h-.14c-.48.06-.86.37-.86.75 0 .41.45.75 1 .75h10.14c.48-.06.86-.37.86-.75 0-.41-.45-.75-1-.75H7Zm10 3H6.86c-.48.06-.86.37-.86.75 0 .41.45.75 1 .75h10.14c.48-.06.86-.37.86-.75 0-.41-.45-.75-1-.75Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddle24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddle24FilledIcon, 'TextboxAlignMiddle24Filled');

const TextboxAlignMiddle24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 10h10c.55 0 1 .34 1 .75 0 .38-.38.7-.86.74l-.14.01H7c-.55 0-1-.34-1-.75 0-.38.38-.7.86-.74L7 10Zm10 3H6.86c-.48.06-.86.37-.86.75 0 .41.45.75 1 .75h10.14c.48-.06.86-.37.86-.75 0-.41-.45-.75-1-.75Zm4-7.25A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75ZM5.75 4.5h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddle24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddle24RegularIcon, 'TextboxAlignMiddle24Regular');

const TextboxAlignMiddleRotate9020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm8.5 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-.5-.5ZM9 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddleRotate9020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddleRotate9020FilledIcon, 'TextboxAlignMiddleRotate9020Filled');

const TextboxAlignMiddleRotate9020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 5c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5ZM9 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddleRotate9020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddleRotate9020RegularIcon, 'TextboxAlignMiddleRotate9020Regular');

const TextboxAlignMiddleRotate9024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 18.25A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5ZM14 7v-.14c-.06-.48-.37-.86-.75-.86-.41 0-.75.45-.75 1v10.14c.06.48.37.86.75.86.41 0 .75-.45.75-1V7Zm-3 10V6.86c-.06-.48-.37-.86-.75-.86-.41 0-.75.45-.75 1v10.14c.06.48.37.86.75.86.41 0 .75-.45.75-1Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddleRotate9024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddleRotate9024FilledIcon, 'TextboxAlignMiddleRotate9024Filled');

const TextboxAlignMiddleRotate9024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 7v10c0 .55-.34 1-.75 1-.38 0-.7-.38-.74-.86L12.5 17V7c0-.55.34-1 .75-1 .38 0 .7.38.74.86L14 7Zm-3 10V6.86c-.06-.48-.37-.86-.75-.86-.41 0-.75.45-.75 1v10.14c.06.48.37.86.75.86.41 0 .75-.45.75-1Zm7.25 4A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5ZM19.5 5.75v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25Z",
    fill: primaryFill
  }));
};

export const TextboxAlignMiddleRotate9024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignMiddleRotate9024RegularIcon, 'TextboxAlignMiddleRotate9024Regular');

const TextboxAlignTop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM6.7 6h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75S6.32 6 6.7 6Zm0 3h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75S6.32 9 6.7 9Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTop20FilledIcon, 'TextboxAlignTop20Filled');

const TextboxAlignTop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM6.5 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm8-6A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9Zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTop20RegularIcon, 'TextboxAlignTop20Regular');

const TextboxAlignTop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5ZM7 7.48l-.14.01c-.48.05-.86.36-.86.74 0 .42.45.75 1 .75h10.14c.48-.05.86-.37.86-.75 0-.41-.45-.75-1-.75H7Zm10 3H7l-.14.01c-.48.05-.86.36-.86.74 0 .42.45.75 1 .75h10.14c.48-.05.86-.37.86-.75 0-.41-.45-.75-1-.75Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTop24FilledIcon, 'TextboxAlignTop24Filled');

const TextboxAlignTop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75ZM5.75 4.5h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25Zm1 3h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h.1Zm10.5 3H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTop24RegularIcon, 'TextboxAlignTop24Regular');

const TextboxAlignTopRotate9020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm5.5 2c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5Zm3 0c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTopRotate9020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTopRotate9020FilledIcon, 'TextboxAlignTopRotate9020Filled');

const TextboxAlignTopRotate9020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 5c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5Zm-2.5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTopRotate9020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTopRotate9020RegularIcon, 'TextboxAlignTopRotate9020Regular');

const TextboxAlignTopRotate9024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 18.25A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5ZM16.52 7l-.01-.14c-.05-.48-.36-.86-.74-.86-.42 0-.75.45-.75 1v10.14c.05.48.37.86.75.86.41 0 .75-.45.75-1V7Zm-3 10V7l-.01-.14c-.05-.48-.36-.86-.74-.86-.42 0-.75.45-.75 1v10.14c.05.48.37.86.75.86.41 0 .75-.45.75-1Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTopRotate9024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTopRotate9024FilledIcon, 'TextboxAlignTopRotate9024Filled');

const TextboxAlignTopRotate9024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 21A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5ZM19.5 5.75v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25Zm-3 1v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v.1Zm-3 10.5V6.65a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1Z",
    fill: primaryFill
  }));
};

export const TextboxAlignTopRotate9024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxAlignTopRotate9024RegularIcon, 'TextboxAlignTopRotate9024Regular');

const TextboxMore20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h1.25A2.25 2.25 0 0 1 11 15.97a2.25 2.25 0 0 1 4 0 2.25 2.25 0 0 1 1.99-1.22l.01-.25v-9ZM6 6.75c0-.41.32-.75.7-.75h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75Zm0 3c0-.41.32-.75.7-.75h3.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75ZM6.7 12h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75Zm3.55 5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const TextboxMore20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxMore20FilledIcon, 'TextboxMore20Filled');

const TextboxMore20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM6.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM6 12.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM14.5 3A2.5 2.5 0 0 1 17 5.5v9l-.01.25c-.4 0-.77.1-1.09.29.07-.17.1-.35.1-.54v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h1.48c-.15.3-.23.64-.23 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9Zm-4.25 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const TextboxMore20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxMore20RegularIcon, 'TextboxMore20Regular');

const TextboxMore24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v12.3a2.51 2.51 0 0 0-2.94 1.9c0 .03-.03.05-.06.05a.06.06 0 0 1-.06-.05 2.5 2.5 0 0 0-4.88 0c0 .03-.03.05-.06.05a.06.06 0 0 1-.06-.05A2.5 2.5 0 0 0 8.05 21h-2.3A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5ZM15 12.25a.75.75 0 0 0-.75-.75h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0 .65-.75Zm2.25 3.25H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5ZM18 8.25a.75.75 0 0 0-.75-.75H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0 .65-.75ZM12 20.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: primaryFill
  }));
};

export const TextboxMore24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxMore24FilledIcon, 'TextboxMore24Filled');

const TextboxMore24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h2.3a2.51 2.51 0 0 1 .16-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.46a2.5 2.5 0 0 1 1.5-.16V5.75ZM6.75 11.5h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h.1Zm10.5 4H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5Zm-10.5-8h10.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h.1Zm5.25 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: primaryFill
  }));
};

export const TextboxMore24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxMore24RegularIcon, 'TextboxMore24Regular');

const TextboxRotate9020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9ZM7.5 6.7v6.6c0 .38-.34.7-.75.7S6 13.68 6 13.3V6.7c0-.38.34-.7.75-.7s.75.32.75.7ZM9.75 6c.41 0 .75.32.75.7v3.6c0 .38-.34.7-.75.7S9 10.68 9 10.3V6.7c0-.38.34-.7.75-.7Zm3 0c.41 0 .75.32.75.7v6.6c0 .38-.34.7-.75.7s-.75-.32-.75-.7V6.7c0-.38.34-.7.75-.7Z",
    fill: primaryFill
  }));
};

export const TextboxRotate9020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxRotate9020FilledIcon, 'TextboxRotate9020Filled');

const TextboxRotate9020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm-3 0a.5.5 0 1 0-1 0v4a.5.5 0 0 0 1 0v-4Zm-3 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm10 8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9Zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5Z",
    fill: primaryFill
  }));
};

export const TextboxRotate9020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxRotate9020RegularIcon, 'TextboxRotate9020Regular');

const TextboxRotate9024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 21A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5Zm-5.75-6.75a.75.75 0 0 1-1.5.1v-7.6a.75.75 0 0 1 1.5-.1v7.6Zm-4-7.5v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v.1Zm8 10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v10.6Z",
    fill: primaryFill
  }));
};

export const TextboxRotate9024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxRotate9024FilledIcon, 'TextboxRotate9024Filled');

const TextboxRotate9024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 18.25A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v12.5Zm-1.5 0V5.75c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25Zm-7-4v-7.6a.75.75 0 0 0-1.5.1v7.6a.75.75 0 0 0 1.5-.1Zm-4-7.5v10.5a.75.75 0 0 1-1.5.1V6.75a.75.75 0 0 1 1.5-.1v.1Zm8 10.5V6.65a.75.75 0 0 0-1.5.1v10.6a.75.75 0 0 0 1.5-.1Z",
    fill: primaryFill
  }));
};

export const TextboxRotate9024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxRotate9024RegularIcon, 'TextboxRotate9024Regular');

const TextboxSettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1a5.48 5.48 0 0 1-.5-3.5H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75h2.9c.29-.56.67-1.07 1.13-1.5H6.7c-.4 0-.71-.34-.71-.75S6.32 9 6.7 9H14.36a5.63 5.63 0 0 1 2.65.6V5.5ZM6 6.75c0-.41.32-.75.7-.75h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75Zm6.07 4.7a2 2 0 0 1-1.44 2.47l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const TextboxSettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxSettings20FilledIcon, 'TextboxSettings20Filled');

const TextboxSettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h2.7c.1-.35.24-.68.4-1H6.5Zm-1 4h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5Zm6.57-4.56a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const TextboxSettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxSettings20RegularIcon, 'TextboxSettings20Regular');

const TextboxSettings24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 5.75A2.75 2.75 0 0 0 18.25 3H5.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h6.27a6.47 6.47 0 0 1-1-4H6.75a.75.75 0 0 1-.1-1.5H11.3c.3-.95.83-1.8 1.5-2.5H6.75a.75.75 0 0 1-.1-1.5h7.6c.16 0 .31.05.44.14a6.47 6.47 0 0 1 6.31.38V5.75ZM17.25 7.5a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5h10.6Zm-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43c.2.57.5 1.1.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5.18 5.18 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18c.36-.47.65-1 .85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43c-.2-.58-.5-1.1-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5.17 5.17 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18c-.36.47-.65 1-.85 1.57Zm5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19Z",
    fill: primaryFill
  }));
};

export const TextboxSettings24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxSettings24FilledIcon, 'TextboxSettings24Filled');

const TextboxSettings24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3A2.75 2.75 0 0 1 21 5.75v6.27c-.46-.3-.97-.53-1.5-.7V5.74c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h5.56c.18.53.42 1.04.71 1.5H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h12.5Zm-4 8.5c.16 0 .31.05.44.14-.71.34-1.34.8-1.88 1.36H6.75a.75.75 0 0 1-.1-1.5h7.6Zm-7.5 4h4.56c-.15.48-.25.98-.3 1.5H6.76a.75.75 0 0 1-.1-1.5h.1Zm10.5-8H6.65a.75.75 0 0 0 .1 1.5h10.6a.75.75 0 0 0-.1-1.5Zm-4.75 8.13.45.43a2 2 0 0 1 0 2.88l-.45.43c.2.57.5 1.1.85 1.57l.6-.18a2 2 0 0 1 2.52 1.45l.17.72a5.18 5.18 0 0 0 1.72 0l.17-.72a2 2 0 0 1 2.52-1.45l.6.18c.36-.47.65-1 .85-1.57l-.45-.43a2 2 0 0 1 0-2.88l.45-.43c-.2-.58-.5-1.1-.85-1.57l-.6.18a2 2 0 0 1-2.52-1.45l-.17-.72a5.17 5.17 0 0 0-1.72 0l-.17.72a2 2 0 0 1-2.52 1.45l-.6-.18c-.36.47-.65 1-.85 1.57Zm5 3.37c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19Z",
    fill: primaryFill
  }));
};

export const TextboxSettings24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextboxSettings24RegularIcon, 'TextboxSettings24Regular');

const Thinking20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.7 2.64A4 4 0 0 1 10 2a3.56 3.56 0 0 1 3.52 2.1c.33.7.43 1.44.46 1.92.65.05 1.31.2 1.86.56C16.56 7.06 17 7.85 17 9c0 1.17-.44 1.97-1.16 2.44-.69.45-1.56.56-2.34.56h-7c-.79 0-1.66-.13-2.34-.58C3.44 10.94 3 10.15 3 9s.44-1.94 1.16-2.42c.55-.36 1.2-.51 1.86-.56.03-.48.13-1.21.46-1.92.25-.53.63-1.06 1.21-1.46ZM10 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: primaryFill
  }));
};

export const Thinking20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Thinking20FilledIcon, 'Thinking20Filled');

const Thinking20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a3.55 3.55 0 0 0-3.52 2.1c-.33.7-.43 1.44-.46 1.92-.65.05-1.31.2-1.86.56C3.44 7.06 3 7.85 3 9s.44 1.94 1.16 2.42c.68.45 1.55.58 2.34.58h7c.78 0 1.65-.11 2.34-.56C16.56 10.97 17 10.17 17 9c0-1.15-.44-1.94-1.16-2.42a3.84 3.84 0 0 0-1.86-.56 5.53 5.53 0 0 0-.46-1.92A3.56 3.56 0 0 0 10 2ZM7 6.5c0-.24 0-1.15.4-1.98.18-.4.46-.78.86-1.05A3 3 0 0 1 10 3a3 3 0 0 1 1.74.47c.4.27.68.65.87 1.05.39.83.39 1.74.39 1.98 0 .28.22.5.5.5.71 0 1.34.12 1.79.42.4.27.71.73.71 1.58 0 .89-.31 1.34-.71 1.6-.44.3-1.07.4-1.79.4h-7c-.71 0-1.34-.12-1.79-.42C4.31 10.31 4 9.85 4 9c0-.85.3-1.31.71-1.58C5.16 7.12 5.8 7 6.5 7a.5.5 0 0 0 .5-.5ZM8 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-4.5 2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z",
    fill: primaryFill
  }));
};

export const Thinking20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Thinking20RegularIcon, 'Thinking20Regular');

const Thinking24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm5.5-3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM12 2a5.41 5.41 0 0 1 5.33 4.47h.08a3.76 3.76 0 1 1 0 7.53H6.6a3.76 3.76 0 1 1 0-7.53h.08A5.41 5.41 0 0 1 12 2Z",
    fill: primaryFill
  }));
};

export const Thinking24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Thinking24FilledIcon, 'Thinking24Filled');

const Thinking24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM9.5 15a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11.82 2a5.41 5.41 0 0 1 5.33 4.47h.09a3.76 3.76 0 1 1 0 7.53H6.4a3.76 3.76 0 1 1 0-7.53h.08A5.41 5.41 0 0 1 11.82 2Zm0 1.5a3.93 3.93 0 0 0-3.91 3.73.7.7 0 0 1-.7.65h-.7a2.31 2.31 0 1 0 0 4.62h10.63a2.31 2.31 0 1 0 0-4.62h-.7a.7.7 0 0 1-.69-.65 3.93 3.93 0 0 0-3.92-3.73Z",
    fill: primaryFill
  }));
};

export const Thinking24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Thinking24RegularIcon, 'Thinking24Regular');

const ThumbDislike16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.1 4.62a3.5 3.5 0 0 0-4.38-2.73L3.77 3.27a2 2 0 0 0-1.43 1.56l-.23 1.2c-.16.87.46 1.64 1.16 1.93.25.1.55.25.85.46a8.22 8.22 0 0 1 3.02 3.92l.28.7c.14.38.28.73.41 1 .11.23.25.46.42.63.19.19.44.33.75.33.36 0 .67-.12.91-.34.24-.2.4-.48.5-.76.22-.55.29-1.25.3-1.9a14.73 14.73 0 0 0-.13-2h.51a2.5 2.5 0 0 0 2.46-2.96l-.46-2.42Z",
    fill: primaryFill
  }));
};

export const ThumbDislike16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike16FilledIcon, 'ThumbDislike16Filled');

const ThumbDislike16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m10.58 10 .05.45a11 11 0 0 1-.02 2.68c-.07.44-.2.88-.44 1.23-.25.38-.64.64-1.17.64-.52 0-.83-.37-1.02-.7-.2-.31-.36-.75-.54-1.2l-.01-.03c-.55-1.4-1.3-3.31-3.3-4.65-.31-.2-.6-.36-.86-.46-.7-.3-1.32-1.06-1.16-1.94l.23-1.2a2 2 0 0 1 1.43-1.55l4.95-1.38a3.5 3.5 0 0 1 4.37 2.73l.46 2.42A2.5 2.5 0 0 1 11.09 10h-.51Zm1.53-5.2a2.5 2.5 0 0 0-3.13-1.94L4.03 4.23a1 1 0 0 0-.71.78l-.22 1.2c-.06.28.16.66.55.82.31.13.66.31 1.03.55 2.28 1.53 3.13 3.7 3.67 5.11l.01.02c.2.5.33.85.47 1.08A.73.73 0 0 0 9 14c.14 0 .25-.05.35-.2.12-.18.22-.46.28-.83a10.06 10.06 0 0 0-.08-3.12l-.03-.2-.01-.05V9.6A.5.5 0 0 1 10 9h1.09a1.5 1.5 0 0 0 1.47-1.78l-.45-2.42Z",
    fill: primaryFill
  }));
};

export const ThumbDislike16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike16RegularIcon, 'ThumbDislike16Regular');

const ThumbDislike20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.48 18.3c-.8.83-2.09.38-2.43-.6-.28-.8-.64-1.77-1-2.48C8 13.1 7.38 11.9 5.67 10.37c-.23-.2-.52-.36-.84-.49-1.13-.44-2.2-1.61-1.91-3l.35-1.77a2.5 2.5 0 0 1 1.8-1.92l5.6-1.53a4.5 4.5 0 0 1 5.6 3.54l.69 3.76A3 3 0 0 1 14 12.5h-.89l.01.05c.08.41.18.97.24 1.58.07.62.1 1.29.05 1.92a3.68 3.68 0 0 1-.5 1.73c-.11.16-.27.35-.44.52Z",
    fill: primaryFill
  }));
};

export const ThumbDislike20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike20FilledIcon, 'ThumbDislike20Filled');

const ThumbDislike20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.05 17.7c.34.98 1.63 1.43 2.43.6.17-.17.33-.36.44-.52.32-.48.45-1.12.5-1.73.05-.63.02-1.3-.05-1.92-.06-.6-.16-1.17-.24-1.58v-.05H14a3 3 0 0 0 2.95-3.54l-.69-3.76a4.5 4.5 0 0 0-5.6-3.54L5.06 3.2c-.92.25-1.62 1-1.8 1.92l-.35 1.77c-.28 1.39.78 2.56 1.9 3 .33.13.62.3.85.5 1.7 1.5 2.32 2.72 3.38 4.84.36.71.72 1.68 1 2.49Zm1.97-5.58v.04a14.2 14.2 0 0 1 .36 2.08c.06.58.09 1.18.04 1.73-.04.55-.15.98-.33 1.25-.06.1-.18.22-.33.39-.2.2-.63.16-.76-.23-.29-.82-.67-1.83-1.05-2.6-1.07-2.14-1.76-3.5-3.62-5.15-.34-.3-.74-.52-1.13-.68-.88-.34-1.45-1.14-1.3-1.87l.35-1.77c.11-.56.53-1 1.08-1.15l5.6-1.53a3.5 3.5 0 0 1 4.36 2.75l.68 3.76a2 2 0 0 1-1.96 2.36h-1.5a.5.5 0 0 0-.5.62Z",
    fill: primaryFill
  }));
};

export const ThumbDislike20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike20RegularIcon, 'ThumbDislike20Regular');

const ThumbDislike24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.06 14.18c.46 1.43.69 2.68.69 3.76 0 2.4-.94 4.24-2.5 4.24-.8 0-1.08-.45-1.38-1.54l-.27-1.02a264.6 264.6 0 0 0-.56-1.9l-2.87-4.49a5.88 5.88 0 0 0-2.85-2.32l-1.26-.48a1.75 1.75 0 0 1-1.09-1.97l.69-3.54c.16-.86.82-1.55 1.67-1.76l8.25-2.02a4.75 4.75 0 0 1 5.73 3.44l1.58 6.17a2.75 2.75 0 0 1-2.67 3.43h-3.16Z",
    fill: primaryFill
  }));
};

export const ThumbDislike24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike24FilledIcon, 'ThumbDislike24Filled');

const ThumbDislike24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 17.99c0 2.44-1.14 4.2-3 4.2-.98 0-1.35-.55-1.7-1.8l-.2-.77a267.17 267.17 0 0 0-.56-1.9l-2.87-4.49a5.88 5.88 0 0 0-2.85-2.32l-.47-.18a2.75 2.75 0 0 1-1.72-3.1l.4-2.08A3.25 3.25 0 0 1 5.95 3l7.63-1.87a4.75 4.75 0 0 1 5.73 3.44l1.42 5.55a3.25 3.25 0 0 1-3.15 4.05h-1.83c.5 1.64.75 2.9.75 3.8ZM4.6 7.92c-.11.6.21 1.19.78 1.4l.47.19a7.38 7.38 0 0 1 3.59 2.92l2.86 4.48c.1.14.16.3.2.46l.56 1.92.21.79a2 2 0 0 0 .22.6c.87 0 1.51-.98 1.51-2.7 0-.88-.33-2.33-.98-4.31a.75.75 0 0 1 .7-.99h2.86a1.75 1.75 0 0 0 1.7-2.18l-1.42-5.55a3.25 3.25 0 0 0-3.93-2.35L6.31 4.47c-.67.16-1.17.7-1.3 1.36l-.4 2.1Z",
    fill: primaryFill
  }));
};

export const ThumbDislike24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbDislike24RegularIcon, 'ThumbDislike24Regular');

const ThumbLike16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.58 1.05c-.75-.2-1.34.35-1.55.87-.24.6-.45 1.02-.7 1.53-.16.3-.33.65-.53 1.09-.48 1-.95 1.65-1.3 2.04a4.06 4.06 0 0 1-.5.49h-.02L3.11 8.19a2 2 0 0 0-.86 2.43l.52 1.38a2 2 0 0 0 1.28 1.2l5.35 1.69a2.5 2.5 0 0 0 3.15-1.68l1.36-4.65A2 2 0 0 0 12 6h-1.38l.2-.74c.13-.56.24-1.2.23-1.74-.01-.5-.06-1.02-.27-1.46-.22-.48-.6-.83-1.19-1Zm-4.6 6.03Z",
    fill: primaryFill
  }));
};

export const ThumbLike16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike16FilledIcon, 'ThumbLike16Filled');

const ThumbLike16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.03 1.92c.21-.52.8-1.08 1.55-.87.6.17.97.52 1.2 1 .2.44.25.96.26 1.46a7.5 7.5 0 0 1-.24 1.74c-.06.26-.12.51-.19.74h1.38a2 2 0 0 1 1.92 2.56l-1.36 4.65a2.5 2.5 0 0 1-3.15 1.68L4.05 13.2A2 2 0 0 1 2.77 12l-.52-1.4a2 2 0 0 1 .86-2.42l1.87-1.1.02-.01.1-.09c.1-.07.23-.2.4-.4.35-.39.82-1.03 1.3-2.04.2-.44.37-.78.53-1.1.25-.5.46-.92.7-1.52Zm-2.51 6-.02.01-1.88 1.11a1 1 0 0 0-.43 1.22l.52 1.38a1 1 0 0 0 .64.6l5.35 1.68c.8.26 1.65-.2 1.89-1l1.36-4.65A1 1 0 0 0 12 6.99H9.93a.5.5 0 0 1-.48-.67c.1-.28.26-.77.38-1.3.13-.54.22-1.08.2-1.5 0-.46-.05-.8-.16-1.05a.78.78 0 0 0-.56-.45c-.04-.02-.1-.01-.16.03a.54.54 0 0 0-.19.25c-.25.63-.5 1.11-.76 1.65-.16.3-.32.63-.5 1.01a9.52 9.52 0 0 1-1.45 2.28 5.06 5.06 0 0 1-.7.66l-.02.01-.01.01Zm-.54-.84Z",
    fill: primaryFill
  }));
};

export const ThumbLike16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike16RegularIcon, 'ThumbLike16Regular');

const ThumbLike20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.48 1.7c-.8-.83-2.09-.38-2.43.6-.28.8-.64 1.77-1 2.48C8 6.9 7.38 8.1 5.67 9.63c-.23.2-.52.36-.84.49-1.13.44-2.2 1.61-1.91 3l.35 1.77a2.5 2.5 0 0 0 1.8 1.92l5.6 1.52a4.5 4.5 0 0 0 5.6-3.53l.69-3.76A3 3 0 0 0 14 7.5h-.89l.01-.05c.08-.41.18-.97.24-1.59.07-.6.1-1.28.05-1.9a3.68 3.68 0 0 0-.5-1.74 4.16 4.16 0 0 0-.44-.52Z",
    fill: primaryFill
  }));
};

export const ThumbLike20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike20FilledIcon, 'ThumbLike20Filled');

const ThumbLike20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.05 2.3c.34-.98 1.63-1.43 2.43-.6.17.17.33.36.44.52.32.48.45 1.12.5 1.73.05.63.02 1.3-.05 1.91-.06.62-.16 1.18-.24 1.59v.05H14a3 3 0 0 1 2.95 3.54l-.69 3.76a4.5 4.5 0 0 1-5.6 3.53l-5.6-1.52a2.5 2.5 0 0 1-1.8-1.92l-.35-1.77c-.28-1.39.78-2.56 1.9-3 .33-.13.62-.3.85-.5 1.7-1.5 2.32-2.72 3.38-4.84.36-.71.72-1.68 1-2.49Zm1.97 5.58v-.04a13.7 13.7 0 0 0 .13-.58c.08-.4.17-.93.23-1.5.06-.58.09-1.18.04-1.73a2.73 2.73 0 0 0-.33-1.25 3.26 3.26 0 0 0-.33-.39c-.2-.2-.63-.16-.76.23-.29.82-.67 1.83-1.05 2.6-1.07 2.14-1.76 3.5-3.62 5.15-.34.3-.74.52-1.13.68-.88.34-1.45 1.14-1.3 1.87l.35 1.77c.11.56.53 1 1.08 1.15l5.6 1.53c1.98.54 4-.73 4.36-2.75l.68-3.76a2 2 0 0 0-1.96-2.36h-1.5a.5.5 0 0 1-.5-.62Z",
    fill: primaryFill
  }));
};

export const ThumbLike20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike20RegularIcon, 'ThumbLike20Regular');

const ThumbLike24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.06 9c.46-1.42.69-2.67.69-3.75 0-2.4-.94-4.25-2.5-4.25-.85 0-1.11.5-1.44 1.75a64.9 64.9 0 0 1-.77 2.72L8.17 9.95a5.88 5.88 0 0 1-2.85 2.33l-1.26.48c-.8.3-1.25 1.13-1.09 1.97l.69 3.54c.16.86.82 1.54 1.67 1.75l8.25 2.03a4.75 4.75 0 0 0 5.73-3.44l1.58-6.18A2.75 2.75 0 0 0 18.22 9h-3.16Z",
    fill: primaryFill
  }));
};

export const ThumbLike24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike24FilledIcon, 'ThumbLike24Filled');

const ThumbLike24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 5.2c0-2.44-1.14-4.2-3-4.2-1.03 0-1.39.6-1.75 2l-.15.57a268.49 268.49 0 0 1-.56 1.9L8.17 9.95a5.88 5.88 0 0 1-2.85 2.33l-.47.18a2.75 2.75 0 0 0-1.72 3.1l.4 2.08a3.25 3.25 0 0 0 2.42 2.54l7.63 1.87a4.75 4.75 0 0 0 5.73-3.44l1.42-5.55A3.25 3.25 0 0 0 17.58 9h-1.83c.5-1.63.75-2.89.75-3.8ZM4.6 15.27c-.11-.6.21-1.2.78-1.4l.47-.19a7.38 7.38 0 0 0 3.59-2.92l2.86-4.48c.1-.15.16-.3.2-.46a261.43 261.43 0 0 0 .7-2.43c.19-.73.28-.89.3-.89.86 0 1.5.99 1.5 2.7 0 .89-.33 2.34-.98 4.32-.17.48.2.98.7.98h2.86a1.75 1.75 0 0 1 1.7 2.19l-1.42 5.55a3.25 3.25 0 0 1-3.93 2.35l-7.62-1.87A1.75 1.75 0 0 1 5 17.35l-.4-2.08Z",
    fill: primaryFill
  }));
};

export const ThumbLike24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike24RegularIcon, 'ThumbLike24Regular');

const ThumbLike28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.12 1.12c-.88-.25-1.58.38-1.82.98l-.26.66c-2 5.1-3.83 9.74-8.6 12.16a2.96 2.96 0 0 0-1.66 3.09l.42 2.5a3.75 3.75 0 0 0 2.67 2.98l7.69 2.2a6.75 6.75 0 0 0 8.47-5.15l1.23-6.04a3.75 3.75 0 0 0-3.68-4.5h-2.17c.35-1.5.5-3.22.35-4.73-.18-1.77-.86-3.66-2.64-4.15Z",
    fill: primaryFill
  }));
};

export const ThumbLike28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike28FilledIcon, 'ThumbLike28Filled');

const ThumbLike28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.3 2.1c.24-.6.94-1.23 1.82-.98 1.78.5 2.46 2.38 2.64 4.15.16 1.51 0 3.23-.35 4.73h2.17a3.75 3.75 0 0 1 3.68 4.5l-1.23 6.04a6.75 6.75 0 0 1-8.47 5.15l-7.7-2.2A3.75 3.75 0 0 1 4.2 20.5L3.78 18a2.96 2.96 0 0 1 1.65-3.08c4.78-2.42 6.6-7.06 8.61-12.16l.26-.66Zm1.44.5a.24.24 0 0 0-.04.06l-.32.8c-1.94 4.95-3.97 10.12-9.27 12.8-.61.3-.94.93-.85 1.5l.42 2.5c.14.85.77 1.55 1.6 1.79l7.69 2.2c2.94.84 5.98-1 6.59-4l1.23-6.05c.28-1.4-.79-2.7-2.2-2.7h-3.15a.75.75 0 0 1-.72-.97c.47-1.54.72-3.49.55-5.1-.18-1.68-.74-2.62-1.51-2.86l-.02.02Z",
    fill: primaryFill
  }));
};

export const ThumbLike28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike28RegularIcon, 'ThumbLike28Regular');

const ThumbLike48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M28.23 1.99c-1.65-.49-2.96.71-3.39 1.88l-.67 1.86c-.84 2.31-1.45 4-2.3 5.72-2.64 5.4-6.03 9.62-12.35 12.53a5.61 5.61 0 0 0-3.2 6.52l1.23 4.43a7.25 7.25 0 0 0 5.3 5.1l14.06 3.38A9.25 9.25 0 0 0 38 36.85l3.34-12.22A5.25 5.25 0 0 0 36.26 18h-5.04a29.55 29.55 0 0 0 1.24-8.15 12.1 12.1 0 0 0-.87-4.76 5.32 5.32 0 0 0-3.36-3.1Z",
    fill: primaryFill
  }));
};

export const ThumbLike48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike48FilledIcon, 'ThumbLike48Filled');

const ThumbLike48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24.84 3.87c.43-1.17 1.74-2.37 3.39-1.88a5.32 5.32 0 0 1 3.36 3.1c.62 1.4.86 3.07.87 4.76.02 2.72-.52 5.71-1.24 8.15h5.04c3.46 0 5.98 3.3 5.07 6.63l-3.34 12.22a9.25 9.25 0 0 1-11.08 6.56l-14.07-3.37a7.25 7.25 0 0 1-5.3-5.1L6.33 30.5a5.61 5.61 0 0 1 3.2-6.52c6.32-2.9 9.7-7.13 12.36-12.53.84-1.71 1.45-3.41 2.29-5.72l.67-1.86Zm2.59.54a.65.65 0 0 0-.24.32l-.65 1.8c-.84 2.32-1.51 4.18-2.42 6.02-2.83 5.77-6.58 10.5-13.56 13.7-1.46.67-2.22 2.2-1.84 3.58l1.24 4.43a4.75 4.75 0 0 0 3.47 3.35l14.07 3.37a6.75 6.75 0 0 0 8.08-4.79l3.33-12.22a2.75 2.75 0 0 0-2.65-3.47H29.5a1.25 1.25 0 0 1-1.18-1.68 27.78 27.78 0 0 0 1.64-8.95 9.66 9.66 0 0 0-.65-3.76c-.42-.93-1-1.49-1.8-1.72h-.01c-.01 0-.04 0-.07.02Z",
    fill: primaryFill
  }));
};

export const ThumbLike48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ThumbLike48RegularIcon, 'ThumbLike48Regular');

const TicketDiagonal16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.98 1.35a1.4 1.4 0 0 0-1.94.04L1.43 8.01a1.4 1.4 0 0 0 0 1.98l.92.93c.35.34.85.26 1.14.06a1.1 1.1 0 0 1 1.53 1.53c-.2.3-.28.8.07 1.14l.9.9a1.4 1.4 0 0 0 2-.03l6.6-7a1.4 1.4 0 0 0-.07-2l-.88-.81a.84.84 0 0 0-.73-.2c-.23.04-.44.16-.6.33-.2.22-.49.36-.8.36a1.1 1.1 0 0 1-.82-1.85c.16-.16.26-.39.28-.62a.84.84 0 0 0-.26-.7l-.73-.68Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal16FilledIcon, 'TicketDiagonal16Filled');

const TicketDiagonal16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.44 1.94a.6.6 0 0 0-.83.02L1.99 8.58a.6.6 0 0 0 0 .84l.93.93h.02a.2.2 0 0 0 .1-.03A1.9 1.9 0 0 1 6 11.9c0 .39-.12.75-.32 1.05a.2.2 0 0 0-.03.11v.02l.9.9a.6.6 0 0 0 .87 0l6.6-7.02a.6.6 0 0 0-.04-.85l-.88-.81h-.05c-.05 0-.1.04-.14.08a1.9 1.9 0 1 1-2.8-2.57c.03-.04.06-.1.06-.15a.11.11 0 0 0 0-.05l-.73-.67Zm-1.4-.55a1.4 1.4 0 0 1 1.94-.04l.73.67c.22.2.28.48.26.71-.02.23-.12.46-.28.63a1.1 1.1 0 1 0 1.62 1.49c.16-.18.37-.3.6-.34.23-.04.5 0 .73.2l.88.81c.58.53.61 1.42.08 2l-6.6 7a1.4 1.4 0 0 1-2.01.03l-.9-.9c-.35-.35-.27-.85-.07-1.14a1.1 1.1 0 0 0-1.53-1.53c-.3.2-.8.28-1.14-.06l-.92-.93a1.4 1.4 0 0 1 0-1.98L8.04 1.4Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal16RegularIcon, 'TicketDiagonal16Regular');

const TicketDiagonal20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.74 2.53a1.75 1.75 0 0 0-2.48 0l-7.73 7.73c-.69.69-.69 1.8 0 2.48l.77.77c.41.4.99.34 1.35.14a1.25 1.25 0 0 1 1.7 1.7c-.2.36-.27.94.14 1.34l.77.78c.68.68 1.8.68 2.48 0l7.73-7.73c.68-.69.68-1.8 0-2.48l-.78-.77c-.4-.4-.98-.34-1.34-.14a1.25 1.25 0 0 1-1.7-1.7c.2-.36.27-.94-.14-1.34l-.77-.78Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal20FilledIcon, 'TicketDiagonal20Filled');

const TicketDiagonal20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.03 3.24a.75.75 0 0 0-1.06 0l-7.73 7.73c-.3.3-.3.77 0 1.06l.77.77.03.01c.04 0 .08 0 .13-.04a2.25 2.25 0 0 1 3.05 3.05.27.27 0 0 0-.03.14v.03l.78.77c.3.3.77.3 1.06 0l7.73-7.73c.3-.3.3-.77 0-1.06L16 7.19h-.03c-.03 0-.08 0-.13.03a2.24 2.24 0 0 1-3.33-1.97c0-.39.1-.76.28-1.08l.03-.13V4l-.78-.77Zm-1.77-.71c.69-.68 1.8-.68 2.48 0l.77.78c.41.4.34.98.14 1.34a1.25 1.25 0 0 0 1.7 1.7c.36-.2.94-.27 1.35.14l.77.77c.68.69.68 1.8 0 2.48l-7.73 7.73c-.68.68-1.8.68-2.48 0l-.77-.78c-.4-.4-.34-.98-.14-1.34a1.25 1.25 0 0 0-1.7-1.7c-.36.2-.94.27-1.34-.14l-.78-.77a1.75 1.75 0 0 1 0-2.48l7.73-7.73Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal20RegularIcon, 'TicketDiagonal20Regular');

const TicketDiagonal24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.6 2.53a2.25 2.25 0 0 0-3.2 0l-9.87 9.88c-.88.88-.88 2.3 0 3.18l1.17 1.17c.51.51 1.23.42 1.66.16a1.25 1.25 0 0 1 1.71 1.71c-.25.44-.34 1.16.17 1.67l1.17 1.17c.88.88 2.3.88 3.18 0l9.88-9.88c.88-.88.88-2.3 0-3.18L20.3 7.24c-.51-.51-1.23-.42-1.66-.16a1.25 1.25 0 0 1-1.71-1.71c.25-.44.34-1.16-.17-1.67L15.6 2.53Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal24FilledIcon, 'TicketDiagonal24Filled');

const TicketDiagonal24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.53 3.6a.75.75 0 0 0-1.06 0l-9.88 9.87c-.3.3-.3.77 0 1.06l1.07 1.07A2.74 2.74 0 0 1 8.75 18c0 .49-.13.94-.35 1.34l1.07 1.07c.3.3.77.3 1.06 0l9.88-9.88c.3-.3.3-.77 0-1.06L19.34 8.4A2.74 2.74 0 0 1 15.25 6c0-.49.13-.94.35-1.34l-1.07-1.07Zm-2.12-1.07c.88-.88 2.3-.88 3.18 0l1.17 1.17c.51.51.42 1.23.16 1.66a1.25 1.25 0 0 0 1.71 1.71c.44-.25 1.16-.34 1.67.17l1.17 1.17c.88.88.88 2.3 0 3.18l-9.88 9.88c-.88.88-2.3.88-3.18 0L7.24 20.3c-.51-.51-.42-1.23-.16-1.66a1.25 1.25 0 0 0-1.71-1.71c-.44.25-1.16.34-1.67-.17L2.53 15.6a2.25 2.25 0 0 1 0-3.18l9.88-9.88Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal24RegularIcon, 'TicketDiagonal24Regular');

const TicketDiagonal28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.58 2.91a2.56 2.56 0 0 0-3.71-.1L2.8 14.9c-1.03 1.03-1 2.7.07 3.69l1.38 1.27c.71.66 1.69.52 2.29.27a1.67 1.67 0 0 1 2.22 2.05c-.2.62-.27 1.6.44 2.26l1.02.95c1 .93 2.56.9 3.54-.06L25.29 14a2.56 2.56 0 0 0 .1-3.54l-1.07-1.2c-.64-.7-1.6-.66-2.2-.49a1.67 1.67 0 0 1-2-2.22c.23-.58.36-1.53-.27-2.23l-1.27-1.4Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal28FilledIcon, 'TicketDiagonal28Filled');

const TicketDiagonal28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.47 3.92a1.06 1.06 0 0 0-1.54-.04L3.86 15.95c-.42.42-.41 1.12.03 1.53l1.38 1.27c.03.04.1.07.23.08.13 0 .3-.03.47-.1a3.16 3.16 0 0 1 4.21 3.9c-.05.17-.07.34-.05.48.01.13.05.19.09.22l1.02.95c.42.38 1.06.37 1.47-.03l11.52-11.32c.41-.4.43-1.04.05-1.47l-1.08-1.19c-.03-.04-.09-.08-.21-.1-.13-.01-.3 0-.47.05A3.17 3.17 0 0 1 18.72 6c.07-.16.1-.33.09-.45 0-.13-.04-.2-.07-.23l-1.27-1.4Zm-2.6-1.1a2.56 2.56 0 0 1 3.71.1l1.27 1.4c.63.7.5 1.65.26 2.23a1.66 1.66 0 0 0 1.56 2.28c.15 0 .3-.02.45-.06.6-.17 1.56-.2 2.2.5l1.07 1.19a2.56 2.56 0 0 1-.1 3.54L13.76 25.32c-.98.96-2.53.99-3.54.06l-1.02-.95c-.71-.66-.64-1.64-.45-2.26a1.67 1.67 0 0 0-2.21-2.05c-.6.25-1.58.4-2.3-.27l-1.37-1.27a2.56 2.56 0 0 1-.07-3.7L14.87 2.83Z",
    fill: primaryFill
  }));
};

export const TicketDiagonal28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketDiagonal28RegularIcon, 'TicketDiagonal28Regular');

const TicketHorizontal20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 6v1.5a.5.5 0 0 1-.5.5 2 2 0 1 0 0 4c.28 0 .5.22.5.5V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1.5c0-.28.22-.5.5-.5a2 2 0 1 0 0-4 .5.5 0 0 1-.5-.5V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z",
    fill: primaryFill
  }));
};

export const TicketHorizontal20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketHorizontal20FilledIcon, 'TicketHorizontal20Filled');

const TicketHorizontal20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 5c.83 0 1.5.67 1.5 1.5V8a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3c.28 0 .5.22.5.5v1.5c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5V12c0-.28.22-.5.5-.5a1.5 1.5 0 0 0 0-3A.5.5 0 0 1 2 8V6.5C2 5.67 2.67 5 3.5 5h13Zm.5 1.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1-.16-4.86l.16-.04V6.5Z",
    fill: primaryFill
  }));
};

export const TicketHorizontal20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketHorizontal20RegularIcon, 'TicketHorizontal20Regular');

const TicketHorizontal24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.75 5c.7 0 1.25.56 1.25 1.25v2.26c0 .4-.3.72-.7.75a2.75 2.75 0 0 0 0 5.48c.4.03.7.36.7.75v2.26c0 .69-.56 1.25-1.25 1.25H3.25C2.56 19 2 18.44 2 17.75v-2.26c0-.4.3-.72.7-.75a2.75 2.75 0 0 0 0-5.48.75.75 0 0 1-.7-.75V6.25C2 5.56 2.56 5 3.25 5h17.5Z",
    fill: primaryFill
  }));
};

export const TicketHorizontal24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketHorizontal24FilledIcon, 'TicketHorizontal24Filled');

const TicketHorizontal24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.25 5c.97 0 1.75.78 1.75 1.75v2.26c0 .4-.3.72-.69.75a2.25 2.25 0 0 0 0 4.48c.4.03.69.36.69.75v2.26c0 .97-.78 1.75-1.75 1.75H3.75C2.78 19 2 18.22 2 17.25v-2.26c0-.4.3-.72.69-.75a2.25 2.25 0 0 0 0-4.48A.75.75 0 0 1 2 9V6.75C2 5.78 2.78 5 3.75 5h16.5Zm.25 3.38V6.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25v1.63a3.75 3.75 0 0 1 0 7.24v1.63c0 .14.11.25.25.25h16.5c.14 0 .25-.11.25-.25v-1.63a3.75 3.75 0 0 1-.19-7.18l.19-.06Z",
    fill: primaryFill
  }));
};

export const TicketHorizontal24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TicketHorizontal24RegularIcon, 'TicketHorizontal24Regular');

const TimeAndWeather20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Zm-5 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM10 8.5a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1V8.5Zm0 7.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5ZM2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7l-1 1Zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7Zm-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7l-1-1Zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7Z",
    fill: primaryFill
  }));
};

export const TimeAndWeather20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimeAndWeather20FilledIcon, 'TimeAndWeather20Filled');

const TimeAndWeather20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Zm-.5 6a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1V8.5Zm0-3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM6.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5ZM2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7l-1 1Zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7Zm-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7l-1-1Zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7Z",
    fill: primaryFill
  }));
};

export const TimeAndWeather20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimeAndWeather20RegularIcon, 'TimeAndWeather20Regular');

const TimeAndWeather24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 18.53a1 1 0 0 1 .99.89v1.57a1 1 0 0 1-1.99.11v-1.57a1 1 0 0 1 1-1Zm6.03-1.93 1.03 1.03a1 1 0 0 1-1.41 1.41l-1.03-1.03a1 1 0 0 1 1.41-1.41Zm-10.66 0a1 1 0 0 1 0 1.41l-1.03 1.03a1 1 0 0 1-1.41-1.41l1.03-1.03a1 1 0 0 1 1.41 0Zm4.64-10.13a5.52 5.52 0 1 1 0 11.05 5.52 5.52 0 0 1 0-11.05ZM11.25 9c-.38 0-.7.28-.74.65l-.01.1v3.1c.05.34.32.6.65.65h2.2c.33-.05.6-.31.64-.64l.01-.1v-.1a.75.75 0 0 0-.65-.65H12V9.64a.75.75 0 0 0-.75-.65Zm9.73 2.02a1 1 0 0 1 .11 2h-1.57a1 1 0 0 1-.11-2h1.57Zm-16.5-.03a1 1 0 0 1 .12 2H3.02a1 1 0 0 1-.11-2h1.57Zm1.77-6.12.1.09 1.02 1.03a1 1 0 0 1-1.32 1.5l-.09-.09-1.03-1.03a1 1 0 0 1 1.32-1.5Zm12.81.09a1 1 0 0 1 .09 1.32l-.09.1-1.03 1.02a1 1 0 0 1-1.5-1.32l.09-.1 1.03-1.02a1 1 0 0 1 1.41 0ZM12 2a1 1 0 0 1 1 .89v1.57a1 1 0 0 1-2 .12V3a1 1 0 0 1 1-1Z",
    fill: primaryFill
  }));
};

export const TimeAndWeather24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimeAndWeather24FilledIcon, 'TimeAndWeather24Filled');

const TimeAndWeather24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 19.01c.38 0 .69.28.74.65v1.6a.75.75 0 0 1-1.49.1v-1.6c0-.41.33-.75.75-.75Zm6.02-2.07L19.08 18a.75.75 0 0 1-1.06 1.06L16.96 18a.75.75 0 1 1 1.06-1.06Zm-10.99 0c.3.29.3.77 0 1.06l-1.06 1.06A.75.75 0 1 1 4.91 18l1.06-1.06c.3-.3.77-.3 1.06 0ZM12 6.47a5.53 5.53 0 1 1 0 11.05 5.53 5.53 0 0 1 0-11.05Zm0 1.5a4.03 4.03 0 1 0 0 8.05 4.03 4.03 0 0 0 0-8.05ZM11.25 9c.38 0 .7.28.74.65l.01.1V12h1.25c.38 0 .7.29.74.65v.1c0 .38-.27.7-.64.75h-2.1a.75.75 0 0 1-.74-.64l-.01-.1V9.74c0-.41.34-.75.75-.75Zm10 2.27a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6Zm-17-.03a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6Zm1.64-6.37.08.07L7.03 6a.75.75 0 0 1-.97 1.13l-.09-.07L4.91 6a.75.75 0 0 1 .98-1.13Zm13.19.07c.26.27.29.68.07.98l-.07.08-1.06 1.06a.75.75 0 0 1-1.14-.97l.08-.09 1.06-1.06c.3-.3.77-.3 1.06 0ZM12 2c.38 0 .7.28.74.65l.01.1v1.5a.75.75 0 0 1-1.5.1v-1.6c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const TimeAndWeather24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimeAndWeather24RegularIcon, 'TimeAndWeather24Regular');

const TimePicker20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.47 2.17a.75.75 0 0 0-.94 0L6.78 4.42a.75.75 0 0 0 .94 1.16L10 3.72l2.28 1.86a.75.75 0 1 0 .94-1.16l-2.75-2.25Zm2.75 13.41-2.75 2.25a.75.75 0 0 1-.94 0l-2.75-2.25a.75.75 0 0 1 .94-1.16L10 16.28l2.28-1.86a.75.75 0 1 1 .94 1.16Zm-2.47-6.83a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8ZM6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8ZM2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Z",
    fill: primaryFill
  }));
};

export const TimePicker20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimePicker20FilledIcon, 'TimePicker20Filled');

const TimePicker20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.32 2.12a.5.5 0 0 0-.64 0l-3 2.5a.5.5 0 1 0 .64.76L10 3.15l2.68 2.23a.5.5 0 0 0 .64-.76l-3-2.5Zm3 13.26-3 2.5a.5.5 0 0 1-.64 0l-3-2.5a.5.5 0 1 1 .64-.76L10 16.85l2.68-2.23a.5.5 0 0 1 .64.76Zm-2.57-6.63a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8ZM6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8ZM2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Z",
    fill: primaryFill
  }));
};

export const TimePicker20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimePicker20RegularIcon, 'TimePicker20Regular');

const TimePicker24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.62 2.22a1 1 0 0 0-1.24 0l-3.75 3a1 1 0 1 0 1.24 1.56L12 4.28l3.13 2.5a1 1 0 0 0 1.24-1.56l-3.75-3ZM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9ZM2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25Zm-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0v-1.5Zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Zm5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9ZM21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.38 7.53 4-3.25a1 1 0 0 0-1.26-1.56L12 19.96l-3.37-2.74a1 1 0 1 0-1.26 1.56l4 3.25c.37.3.9.3 1.26 0Z",
    fill: primaryFill
  }));
};

export const TimePicker24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimePicker24FilledIcon, 'TimePicker24Filled');

const TimePicker24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.47 2.17a.75.75 0 0 0-.94 0l-4 3.25a.75.75 0 1 0 .94 1.16L12 3.72l3.53 2.86a.75.75 0 1 0 .94-1.16l-4-3.25ZM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9ZM2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25Zm-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0v-1.5Zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Zm5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9ZM21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.22 7.33 4-3.25a.75.75 0 1 0-.94-1.16L12 20.28l-3.53-2.86a.75.75 0 0 0-.94 1.16l4 3.25c.27.23.67.23.94 0Z",
    fill: primaryFill
  }));
};

export const TimePicker24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimePicker24RegularIcon, 'TimePicker24Regular');

const Timeline20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9Zm0 8c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM17 12.44a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88ZM16.5 3c.28 0 .5.22.5.5v4.04a3.02 3.02 0 0 0-1 0V3.5c0-.28.22-.5.5-.5Zm0 10.5c-.17 0-.34-.01-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04c-.16.03-.33.04-.5.04Z",
    fill: primaryFill
  }));
};

export const Timeline20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timeline20FilledIcon, 'Timeline20Filled');

const Timeline20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-4Zm.5 6.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM3 12.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-4Zm14-.06a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88ZM16.5 3c.28 0 .5.22.5.5v4.04a3.02 3.02 0 0 0-1 0V3.5c0-.28.22-.5.5-.5Zm0 10.5c-.17 0-.34-.01-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04c-.16.03-.33.04-.5.04Z",
    fill: primaryFill
  }));
};

export const Timeline20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timeline20RegularIcon, 'Timeline20Regular');

const Timeline24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75h11.5ZM21 14.9v5.35a.75.75 0 0 1-1.5.1V14.91a3 3 0 0 0 1.5-.01Zm-.75-4.8a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8Zm-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.75h11.65Zm5 0c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const Timeline24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timeline24FilledIcon, 'Timeline24Filled');

const Timeline24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75h11.5ZM21 14.9v5.35a.75.75 0 0 1-1.5.1V14.91a3 3 0 0 0 1.5-.01Zm-5.75-.4H3.75a.25.25 0 0 0-.25.25v4.5c0 .14.11.25.25.25h11.5c.14 0 .25-.11.25-.25v-4.5a.25.25 0 0 0-.25-.25Zm5-4.4a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8Zm-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.74L3.75 3h11.5Zm0 1.5H3.69a.25.25 0 0 0-.2.25v4.5c0 .14.12.25.26.25h11.5c.13 0 .25-.11.25-.25v-4.5a.25.25 0 0 0-.25-.25Zm5-1.5c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const Timeline24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timeline24RegularIcon, 'Timeline24Regular');

const Timer1020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM16.43 10c-.98.02-1.86.44-2.48 1.1a1.5 1.5 0 0 0-1.92-1.02l-1.5.5A1.5 1.5 0 0 0 11 13.5v4.34A7.03 7.03 0 0 1 2.5 11a7 7 0 0 1 13.93-1ZM9 10.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0v4Zm5 3a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0v-3Zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5Zm-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0v-7Z",
    fill: primaryFill
  }));
};

export const Timer1020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer1020FilledIcon, 'Timer1020Filled');

const Timer1020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM9 6.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4ZM9.5 18c.51 0 1.02-.06 1.5-.16V16.8a6.01 6.01 0 1 1 4.44-6.65c.31-.1.65-.15.99-.16a7 7 0 1 0-6.93 8Zm4.5-4.5a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0v-3Zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5Zm-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0v-7Z",
    fill: primaryFill
  }));
};

export const Timer1020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer1020RegularIcon, 'Timer1020Regular');

const Timer1024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5a8.5 8.5 0 0 1 8.38 7.05 4.28 4.28 0 0 0-4.38 2.2v-.5a1.75 1.75 0 0 0-2.3-1.66l-.95.32V8.65a.75.75 0 0 0-1.5 0V13.34a1.75 1.75 0 0 0 1.25 2.64v6c-.17.02-.33.02-.5.02a8.5 8.5 0 0 1 0-17Zm7.17.12.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Zm.44 10.64c.2.14.31.37.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.75.75 0 0 1 .68.1Zm1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-3.5Zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75Z",
    fill: primaryFill
  }));
};

export const Timer1024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer1024FilledIcon, 'Timer1024Filled');

const Timer1024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5a8.5 8.5 0 0 1 8.38 7.05 4.28 4.28 0 0 0-1.52.04 7 7 0 1 0-6.36 8.4v1.5L12 22a8.5 8.5 0 0 1 0-17Zm.75 7.4V8.66a.75.75 0 0 0-1.5.1v4.59c.21-.34.54-.61.95-.75l.55-.18Zm6.4-7.29.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Zm.44 10.64c.2.14.31.37.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.75.75 0 0 1 .68.1Zm1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-3.5Zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75Z",
    fill: primaryFill
  }));
};

export const Timer1024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer1024RegularIcon, 'Timer1024Regular');

const Timer12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 0a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM1 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4 1a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm5.85-3.65a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l1 1c.2.2.2.5 0 .7Z",
    fill: primaryFill
  }));
};

export const Timer12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer12FilledIcon, 'Timer12Filled');

const Timer12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 3 .5Zm2 7a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3ZM5.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM2 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm8.15-2.65a.5.5 0 1 0 .7-.7l-1-1a.5.5 0 1 0-.7.7l1 1Z",
    fill: primaryFill
  }));
};

export const Timer12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer12RegularIcon, 'Timer12Regular');

const Timer16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM7.5 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-10c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5Zm4.95-2.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7l-1.4-1.4Z",
    fill: primaryFill
  }));
};

export const Timer16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer16FilledIcon, 'Timer16Filled');

const Timer16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM7.5 5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm6 4a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-.05-6.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7l-1.4-1.4Z",
    fill: primaryFill
  }));
};

export const Timer16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer16RegularIcon, 'Timer16Regular');

const Timer20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM16.5 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM9 6.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0Z",
    fill: primaryFill
  }));
};

export const Timer20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer20FilledIcon, 'Timer20Filled');

const Timer20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm0 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z",
    fill: primaryFill
  }));
};

export const Timer20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer20RegularIcon, 'Timer20Regular');

const Timer24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 3c-.38 0-.7.28-.74.65l-.01.1v4.6a.75.75 0 0 0 1.5 0V8.65A.75.75 0 0 0 12 8Zm7.17-2.88.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z",
    fill: primaryFill
  }));
};

export const Timer24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer24FilledIcon, 'Timer24Filled');

const Timer24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM12 8c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-4.6c0-.41.34-.75.75-.75Zm7.15-2.89.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z",
    fill: primaryFill
  }));
};

export const Timer24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer24RegularIcon, 'Timer24Regular');

const Timer28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM4 16a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm10.75-5.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm6.47-4.03c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06Z",
    fill: primaryFill
  }));
};

export const Timer28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer28FilledIcon, 'Timer28Filled');

const Timer28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM14 9.5c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75ZM14 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM5.5 16a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0Zm16.78-9.78a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-1.5-1.5Z",
    fill: primaryFill
  }));
};

export const Timer28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer28RegularIcon, 'Timer28Regular');

const Timer220FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Zm1.29 6.2A3.5 3.5 0 0 0 12 13.5c0 .7.47 1.27 1.1 1.45A3.49 3.49 0 0 0 12 17.5v.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87ZM9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v5Zm6.5-.5a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5Z",
    fill: primaryFill
  }));
};

export const Timer220Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer220FilledIcon, 'Timer220Filled');

const Timer220RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM9 6.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm3 11.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87 3.5 3.5 0 0 0-1.03-.13 6 6 0 1 0-3.23 6.37A3.5 3.5 0 0 0 12 17.5v.04ZM15.5 11a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5Z",
    fill: primaryFill
  }));
};

export const Timer220Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer220RegularIcon, 'Timer220Regular');

const Timer224FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21c0-1.31.6-2.48 1.53-3.26A1.75 1.75 0 0 1 15 16.25a4.25 4.25 0 0 1 5.4-4.1Zm-9.14-3.51a.75.75 0 0 1 1.48 0l.01.1v4.6a.75.75 0 0 1-1.5 0V8.65Zm8-3.47-.09-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2l-1.15-1ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5Z",
    fill: primaryFill
  }));
};

export const Timer224Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer224FilledIcon, 'Timer224Filled');

const Timer224RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21c0-.56.1-1.09.3-1.58a7 7 0 1 1 3.54-7.65 4.3 4.3 0 0 1 1.55.14Zm-7.66-3.51a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6Zm6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21l-1.16-.97ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5Z",
    fill: primaryFill
  }));
};

export const Timer224Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer224RegularIcon, 'Timer224Regular');

const Timer32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm15 16a12 12 0 1 1-24 0 12 12 0 0 1 24 0Zm-11-6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Zm8.3-5.7a1 1 0 0 1 1.4 0l2 2a1 1 0 1 1-1.4 1.4l-2-2a1 1 0 0 1 0-1.4Z",
    fill: primaryFill
  }));
};

export const Timer32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer32FilledIcon, 'Timer32Filled');

const Timer32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm3 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm12 7a12 12 0 1 1-24 0 12 12 0 0 1 24 0Zm-2 0a10 10 0 1 0-20 0 10 10 0 0 0 20 0Zm.7-11.7a1 1 0 1 0-1.4 1.4l2 2a1 1 0 1 0 1.4-1.4l-2-2Z",
    fill: primaryFill
  }));
};

export const Timer32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer32RegularIcon, 'Timer32Regular');

const Timer320FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Zm1.29 6.2a3.7 3.7 0 0 0-.95-.13 4.47 4.47 0 0 0-2.74.97l-.25.2v.01a1.5 1.5 0 0 0 1.63 2.48 2.49 2.49 0 0 0-.04 2.62l-.04.03a1.5 1.5 0 0 0-2.05 1.23 7 7 0 1 1 4.44-7.41ZM9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v5Zm4.84 1.21.03-.02a2.57 2.57 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25 0 .28-.17.58-.51.84-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41.34.26.51.56.51.84 0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3.37 3.37 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a3.68 3.68 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4.35 4.35 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73Z",
    fill: primaryFill
  }));
};

export const Timer320Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer320FilledIcon, 'Timer320Filled');

const Timer320RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm0 12c.88 0 1.73-.16 2.5-.46l.01-.07a1.5 1.5 0 0 1 .45-1.25A6 6 0 1 1 15.42 10a3.8 3.8 0 0 1 1.03.12A7 7 0 1 0 9.5 18Zm4.34-5.29.03-.02a2.57 2.57 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25 0 .28-.17.58-.51.84-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41.34.26.51.56.51.84 0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3.37 3.37 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a3.68 3.68 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4.35 4.35 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73Z",
    fill: primaryFill
  }));
};

export const Timer320Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer320RegularIcon, 'Timer320Regular');

const Timer324FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.45 15.92c.53.6 1.37.74 2.06.4a2.99 2.99 0 0 0 0 3.35 1.75 1.75 0 0 0-2.5 1.78 8.5 8.5 0 1 1 5.38-9.3c-.37-.1-.76-.15-1.14-.15a5.47 5.47 0 0 0-3.35 1.19 5.53 5.53 0 0 0-.28.22l-.02.02-.01.01a1.75 1.75 0 0 0-.14 2.48Zm-4.2-7.27V13.35a.75.75 0 0 0 1.5 0V8.65a.75.75 0 0 0-1.5 0Zm8-3.47-.08-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2l-1.15-1ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4.1 4.1 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02a3.08 3.08 0 0 1 .23-.18c.15-.1.36-.25.62-.4.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a5.58 5.58 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a2.96 2.96 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.38 0-.27-.17-.6-.56-.9a2.48 2.48 0 0 0-1.44-.47.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const Timer324Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer324FilledIcon, 'Timer324Filled');

const Timer324RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.4 12.15a8.5 8.5 0 1 0-5.39 9.3 1.75 1.75 0 0 1 .65-1.98 7 7 0 1 1 3.18-7.45 4.68 4.68 0 0 1 1.55.13Zm-7.66-3.5a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6Zm6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21l-1.16-.97ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4.1 4.1 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02a3.08 3.08 0 0 1 .23-.18c.15-.1.36-.25.62-.4.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a5.58 5.58 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a2.96 2.96 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.38 0-.27-.17-.6-.56-.9a2.48 2.48 0 0 0-1.44-.47.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const Timer324Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer324RegularIcon, 'Timer324Regular');

const Timer48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.25 5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5ZM7 27a17 17 0 1 1 34 0 17 17 0 0 1-34 0Zm15.75-.25a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0v9.5Zm13.62-16.38a1.25 1.25 0 0 1 1.76 0l2.5 2.5a1.25 1.25 0 0 1-1.76 1.76l-2.5-2.5a1.25 1.25 0 0 1 0-1.76Z",
    fill: primaryFill
  }));
};

export const Timer48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer48FilledIcon, 'Timer48Filled');

const Timer48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25Zm4.75 20.5a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0v9.5ZM24 10a17 17 0 1 0 0 34 17 17 0 0 0 0-34ZM9.5 27a14.5 14.5 0 1 1 29 0 14.5 14.5 0 0 1-29 0Zm28.63-16.63a1.25 1.25 0 1 0-1.76 1.76l2.5 2.5a1.25 1.25 0 0 0 1.76-1.76l-2.5-2.5Z",
    fill: primaryFill
  }));
};

export const Timer48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Timer48RegularIcon, 'Timer48Regular');

const TimerOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33ZM10 10.71l-1-1v1.79a.5.5 0 0 0 1 0v-.8Zm0-4.21v1.38l5.92 5.92A7 7 0 0 0 6.7 4.58L9 6.88V6.5a.5.5 0 0 1 1 0Zm-3-4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71Z",
    fill: primaryFill
  }));
};

export const TimerOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimerOff20FilledIcon, 'TimerOff20Filled');

const TimerOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33Zm9.16 9.16L10 10.7v.79a.5.5 0 0 1-1 0V9.7L5.67 6.39A5.99 5.99 0 0 0 9.5 17c1.86 0 3.52-.85 4.62-2.17ZM9 6.5v.38l1 1V6.5a.5.5 0 0 0-1 0Zm6.5 4.5a6 6 0 0 1-.35 2.03l.77.77A7 7 0 0 0 6.7 4.58l.77.77A5.99 5.99 0 0 1 15.5 11Zm-8-9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Z",
    fill: primaryFill
  }));
};

export const TimerOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimerOff20RegularIcon, 'TimerOff20Regular');

const TimerOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07L3.28 2.22Zm9.34 11.46a.75.75 0 0 1-1.36-.33l-.01-.1v-.94l1.37 1.37Zm.13-4.93v.82l7.13 7.13A8.5 8.5 0 0 0 8.8 5.62l2.63 2.63a.75.75 0 0 1 1.3.4l.01.1Zm6.42-3.63.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z",
    fill: primaryFill
  }));
};

export const TimerOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimerOff24FilledIcon, 'TimerOff24Filled');

const TimerOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07L3.28 2.22Zm13.88 16a7 7 0 1 1-9.89-9.89l3.98 3.98v1.04a.75.75 0 0 0 1.37.33l4.54 4.55Zm-5.72-9.97 1.31 1.32V8.65a.75.75 0 0 0-1.31-.4ZM19 13.5a7 7 0 0 1-.3 2.02l1.18 1.18A8.5 8.5 0 0 0 8.8 5.62L9.97 6.8A7 7 0 0 1 19 13.5Zm.15-8.39.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z",
    fill: primaryFill
  }));
};

export const TimerOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TimerOff24RegularIcon, 'TimerOff24Regular');

const ToggleLeft16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 4a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8h6Zm-6 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: primaryFill
  }));
};

export const ToggleLeft16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft16FilledIcon, 'ToggleLeft16Filled');

const ToggleLeft16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm10-2a4 4 0 0 0-4-4H5a4 4 0 1 0 0 8h6a4 4 0 0 0 4-4Zm-4-3a3 3 0 1 1 0 6H5a3 3 0 0 1 0-6h6Z",
    fill: primaryFill
  }));
};

export const ToggleLeft16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft16RegularIcon, 'ToggleLeft16Regular');

const ToggleLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6a4 4 0 0 1 0 8H6a4 4 0 0 1 0-8h8Zm-8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: primaryFill
  }));
};

export const ToggleLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft20FilledIcon, 'ToggleLeft20Filled');

const ToggleLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12-2a4 4 0 0 0-4-4H6a4 4 0 1 0 0 8h8a4 4 0 0 0 4-4Zm-4-3a3 3 0 1 1 0 6H6a3 3 0 1 1 0-6h8Z",
    fill: primaryFill
  }));
};

export const ToggleLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft20RegularIcon, 'ToggleLeft20Regular');

const ToggleLeft24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7a5 5 0 0 1 0 10H7A5 5 0 0 1 7 7h10Zm-9.75 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: primaryFill
  }));
};

export const ToggleLeft24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft24FilledIcon, 'ToggleLeft24Filled');

const ToggleLeft24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 14.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM22 12a5 5 0 0 0-5-5H7a5 5 0 0 0 0 10h10a5 5 0 0 0 5-5Zm-5-3.5a3.5 3.5 0 1 1 0 7H7a3.5 3.5 0 1 1 0-7h10Z",
    fill: primaryFill
  }));
};

export const ToggleLeft24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft24RegularIcon, 'ToggleLeft24Regular');

const ToggleLeft28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a6 6 0 0 1 6-6h12a6 6 0 0 1 0 12H8a6 6 0 0 1-6-6Zm7 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: primaryFill
  }));
};

export const ToggleLeft28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft28FilledIcon, 'ToggleLeft28Filled');

const ToggleLeft28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8 8a6 6 0 0 0 0 12h12a6 6 0 0 0 0-12H8Zm-4.5 6A4.5 4.5 0 0 1 8 9.5h12a4.5 4.5 0 1 1 0 9H8A4.5 4.5 0 0 1 3.5 14Z",
    fill: primaryFill
  }));
};

export const ToggleLeft28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft28RegularIcon, 'ToggleLeft28Regular');

const ToggleLeft48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 24a10 10 0 0 1 10-10h20a10 10 0 0 1 0 20H14A10 10 0 0 1 4 24Zm5.5 0a5 5 0 1 0 10 0 5 5 0 0 0-10 0Z",
    fill: primaryFill
  }));
};

export const ToggleLeft48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft48FilledIcon, 'ToggleLeft48Filled');

const ToggleLeft48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 24a5 5 0 1 1 10 0 5 5 0 0 1-10 0ZM4 24a10 10 0 0 1 10-10h20a10 10 0 0 1 0 20H14A10 10 0 0 1 4 24Zm10-7.5a7.5 7.5 0 0 0 0 15h20a7.5 7.5 0 0 0 0-15H14Z",
    fill: primaryFill
  }));
};

export const ToggleLeft48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleLeft48RegularIcon, 'ToggleLeft48Regular');

const ToggleMultiple16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1a3 3 0 0 0 0 6h6a3 3 0 1 0 0-6H5Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 8a3 3 0 0 0 0 6h6a3 3 0 1 0 0-6H5Zm6 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple16FilledIcon, 'ToggleMultiple16Filled');

const ToggleMultiple16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a3 3 0 0 1 3-3h6a3 3 0 1 1 0 6H5a3 3 0 0 1-3-3Zm3-2a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4H5Zm6 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-9-1a3 3 0 0 1 3-3h6a3 3 0 1 1 0 6H5a3 3 0 0 1-3-3Zm3-2a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4H5Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple16RegularIcon, 'ToggleMultiple16Regular');

const ToggleMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A3.5 3.5 0 0 1 6.5 2h7a3.5 3.5 0 1 1 0 7h-7A3.5 3.5 0 0 1 3 5.5Zm5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM6.5 11a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7h-7Zm7 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple20FilledIcon, 'ToggleMultiple20Filled');

const ToggleMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-5 0A3.5 3.5 0 0 0 6.5 9h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 5.5ZM6.5 3h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5Zm7 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3 14.5A3.5 3.5 0 0 0 6.5 18h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 14.5ZM6.5 12h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple20RegularIcon, 'ToggleMultiple20Regular');

const ToggleMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A4.5 4.5 0 0 1 6.5 2h11a4.5 4.5 0 1 1 0 9h-11A4.5 4.5 0 0 1 2 6.5Zm4.5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 4.5a4.5 4.5 0 1 0 0 9h11a4.5 4.5 0 1 0 0-9h-11Zm13 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple24FilledIcon, 'ToggleMultiple24Filled');

const ToggleMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-6.5h11a4.5 4.5 0 1 1 0 9h-11a4.5 4.5 0 0 1 0-9Zm11 1.5h-11a3 3 0 0 0 0 6h11a3 3 0 1 0 0-6Zm0 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2 17.5A4.5 4.5 0 0 1 6.5 13h11a4.5 4.5 0 1 1 0 9h-11A4.5 4.5 0 0 1 2 17.5Zm4.5-3a3 3 0 1 0 0 6h11a3 3 0 1 0 0-6h-11Z",
    fill: primaryFill
  }));
};

export const ToggleMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleMultiple24RegularIcon, 'ToggleMultiple24Regular');

const ToggleRight16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8H5Zm6 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: primaryFill
  }));
};

export const ToggleRight16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight16FilledIcon, 'ToggleRight16Filled');

const ToggleRight16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H5a4 4 0 0 1-4-4Zm4-3a3 3 0 0 0 0 6h6a3 3 0 1 0 0-6H5Z",
    fill: primaryFill
  }));
};

export const ToggleRight16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight16RegularIcon, 'ToggleRight16Regular');

const ToggleRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6a4 4 0 1 0 0 8h8a4 4 0 0 0 0-8H6Zm8 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: primaryFill
  }));
};

export const ToggleRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight20FilledIcon, 'ToggleRight20Filled');

const ToggleRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2 10a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H6a4 4 0 0 1-4-4Zm4-3a3 3 0 0 0 0 6h8a3 3 0 1 0 0-6H6Z",
    fill: primaryFill
  }));
};

export const ToggleRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight20RegularIcon, 'ToggleRight20Regular');

const ToggleRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7Zm9.75 7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const ToggleRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight24FilledIcon, 'ToggleRight24Filled');

const ToggleRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM2 12a5 5 0 0 1 5-5h10a5 5 0 0 1 0 10H7a5 5 0 0 1-5-5Zm5-3.5a3.5 3.5 0 1 0 0 7h10a3.5 3.5 0 1 0 0-7H7Z",
    fill: primaryFill
  }));
};

export const ToggleRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight24RegularIcon, 'ToggleRight24Regular');

const ToggleRight28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M26 14a6 6 0 0 0-6-6H8a6 6 0 0 0 0 12h12a6 6 0 0 0 6-6Zm-7 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z",
    fill: primaryFill
  }));
};

export const ToggleRight28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight28FilledIcon, 'ToggleRight28Filled');

const ToggleRight28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 17a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm1-9a6 6 0 0 1 0 12H8A6 6 0 0 1 8 8h12Zm4.5 6A4.5 4.5 0 0 0 20 9.5H8a4.5 4.5 0 1 0 0 9h12a4.5 4.5 0 0 0 4.5-4.5Z",
    fill: primaryFill
  }));
};

export const ToggleRight28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight28RegularIcon, 'ToggleRight28Regular');

const ToggleRight48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M44 24a10 10 0 0 0-10-10H14a10 10 0 0 0 0 20h20a10 10 0 0 0 10-10Zm-5.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    fill: primaryFill
  }));
};

export const ToggleRight48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight48FilledIcon, 'ToggleRight48Filled');

const ToggleRight48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M38.5 24a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm5.5 0a10 10 0 0 0-10-10H14a10 10 0 0 0 0 20h20a10 10 0 0 0 10-10Zm-10-7.5a7.5 7.5 0 0 1 0 15H14a7.5 7.5 0 0 1 0-15h20Z",
    fill: primaryFill
  }));
};

export const ToggleRight48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToggleRight48RegularIcon, 'ToggleRight48Regular');

const Toolbox12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5C3 2.67 3.67 2 4.5 2h3C8.33 2 9 2.67 9 3.5V4h.5c.83 0 1.5.67 1.5 1.5V7H8v-.5a.5.5 0 0 0-1 0V7H5v-.5a.5.5 0 0 0-1 0V7H1V5.5C1 4.67 1.67 4 2.5 4H3v-.5ZM4.5 3a.5.5 0 0 0-.5.5V4h4v-.5a.5.5 0 0 0-.5-.5h-3ZM11 8H8v.5a.5.5 0 0 1-1 0V8H5v.5a.5.5 0 0 1-1 0V8H1v1.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V8Z",
    fill: primaryFill
  }));
};

export const Toolbox12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox12FilledIcon, 'Toolbox12Filled');

const Toolbox12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5.5C1 4.67 1.67 4 2.5 4H3v-.5C3 2.67 3.67 2 4.5 2h3C8.33 2 9 2.67 9 3.5V4h.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 1 9.5v-4ZM9.5 5h-7a.5.5 0 0 0-.5.5V7h2v-.5a.5.5 0 0 1 1 0V7h2v-.5a.5.5 0 0 1 1 0V7h2V5.5a.5.5 0 0 0-.5-.5ZM7 8H5v.5a.5.5 0 0 1-1 0V8H2v1.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V8H8v.5a.5.5 0 0 1-1 0V8ZM4 3.5V4h4v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
    fill: primaryFill
  }));
};

export const Toolbox12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox12RegularIcon, 'Toolbox12Regular');

const Toolbox16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.5v1H4c-.83 0-1.5.67-1.5 1.5v1H5v-.5a.5.5 0 0 1 1 0V8h4v-.5a.5.5 0 0 1 1 0V8h2.5V7c0-.83-.67-1.5-1.5-1.5h-1v-1c0-.83-.66-1.5-1.5-1.5h-3C5.69 3 5 3.67 5 4.5ZM6.5 4h3c.28 0 .5.22.5.5v1H6v-1c0-.28.23-.5.5-.5Zm7 5H11v.5a.5.5 0 0 1-1 0V9H6v.5a.5.5 0 0 1-1 0V9H2.5v2c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V9Z",
    fill: primaryFill
  }));
};

export const Toolbox16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox16FilledIcon, 'Toolbox16Filled');

const Toolbox16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.5V5H4a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1v-.5c0-.83-.66-1.5-1.5-1.5h-3C5.69 3 5 3.67 5 4.5ZM6.5 4h3c.28 0 .5.22.5.5V5H6v-.5c0-.28.23-.5.5-.5ZM4 6h8a1 1 0 0 1 1 1v1h-2v-.5a.5.5 0 0 0-1 0V8H6v-.5a.5.5 0 0 0-1 0V8H3V7a1 1 0 0 1 1-1Zm6 3v.5a.5.5 0 0 0 1 0V9h2v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9h2v.5a.5.5 0 0 0 1 0V9h4Z",
    fill: primaryFill
  }));
};

export const Toolbox16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox16RegularIcon, 'Toolbox16Regular');

const Toolbox20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5V6H4a2 2 0 0 0-2 2v2h4v-.5a.5.5 0 0 1 1 0v.5h6v-.5a.5.5 0 0 1 1 0v.5h4V8a2 2 0 0 0-2-2h-2V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5ZM7.5 4h5c.28 0 .5.22.5.5V6H7V4.5c0-.28.22-.5.5-.5ZM18 11h-4v.5a.5.5 0 1 1-1 0V11H7v.5a.5.5 0 0 1-1 0V11H2v4c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-4Z",
    fill: primaryFill
  }));
};

export const Toolbox20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox20FilledIcon, 'Toolbox20Filled');

const Toolbox20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5V6H4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5ZM7.5 4h5c.28 0 .5.22.5.5V6H7V4.5c0-.28.22-.5.5-.5ZM4 7h12a1 1 0 0 1 1 1v2h-3v-.5a.5.5 0 0 0-1 0v.5H7v-.5a.5.5 0 0 0-1 0v.5H3V8a1 1 0 0 1 1-1Zm9 4v.5a.5.5 0 0 0 1 0V11h3v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h3v.5a.5.5 0 0 0 1 0V11h6Z",
    fill: primaryFill
  }));
};

export const Toolbox20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox20RegularIcon, 'Toolbox20Regular');

const Toolbox24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 6.25V7H4.25C3.01 7 2 8 2 9.25v2.25h4.5v-.75a.75.75 0 0 1 1.5 0v.75h8v-.75a.75.75 0 0 1 1.5 0v.75H22V9.25C22 8.01 21 7 19.75 7H17v-.75C17 5.01 16 4 14.75 4h-5.5C8.01 4 7 5.01 7 6.25Zm2.25-.75h5.5c.41 0 .75.34.75.75V7h-7v-.75c0-.41.34-.75.75-.75ZM22 13h-4.5v1.25a.75.75 0 0 1-1.5 0V13H8v1.25a.75.75 0 0 1-1.5 0V13H2v4.75C2 18.99 3 20 4.25 20h15.5c1.24 0 2.25-1.01 2.25-2.25V13Z",
    fill: primaryFill
  }));
};

export const Toolbox24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox24FilledIcon, 'Toolbox24Filled');

const Toolbox24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 6.25V7H4.25C3.01 7 2 8 2 9.25v8.5C2 18.99 3 20 4.25 20h15.5c1.24 0 2.25-1.01 2.25-2.25v-8.5C22 8.01 21 7 19.75 7H17v-.75C17 5.01 16 4 14.75 4h-5.5C8.01 4 7 5.01 7 6.25Zm2.25-.75h5.5c.41 0 .75.34.75.75V7h-7v-.75c0-.41.34-.75.75-.75ZM7 8.5h12.75c.41 0 .75.34.75.75v2.25h-3v-.75a.75.75 0 0 0-1.5 0v.75H8v-.75a.75.75 0 0 0-1.5 0v.75h-3V9.25c0-.41.34-.75.75-.75H7Zm9 4.5v1.25a.75.75 0 0 0 1.5 0V13h3v4.75c0 .41-.34.75-.75.75H4.25a.75.75 0 0 1-.75-.75V13h3v1.25a.75.75 0 0 0 1.5 0V13h8Z",
    fill: primaryFill
  }));
};

export const Toolbox24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox24RegularIcon, 'Toolbox24Regular');

const Toolbox28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 6.25V8H4.25C3.01 8 2 9 2 10.25V14h5.5v-1.25a.75.75 0 0 1 1.5 0V14h10v-1.25a.75.75 0 0 1 1.5 0V14H26v-3.75C26 9 25 8 23.75 8H20V6.25C20 5 19 4 17.75 4h-7.5C9.01 4 8 5 8 6.25Zm2.25-.75h7.5c.42 0 .75.33.75.75V8h-9V6.25c0-.42.34-.75.75-.75ZM26 15.5h-5.5v1.25a.75.75 0 0 1-1.5 0V15.5H9v1.25a.75.75 0 0 1-1.5 0V15.5H2v6.25C2 22.99 3 24 4.25 24h19.5C25 24 26 22.99 26 21.75V15.5Z",
    fill: primaryFill
  }));
};

export const Toolbox28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox28FilledIcon, 'Toolbox28Filled');

const Toolbox28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 6.25V8H4.25C3.01 8 2 9 2 10.25v11.5C2 22.99 3 24 4.25 24h19.5C25 24 26 22.99 26 21.75v-11.5C26 9 25 8 23.75 8H20V6.25C20 5 19 4 17.75 4h-7.5C9.01 4 8 5 8 6.25Zm2.25-.75h7.5c.42 0 .75.33.75.75V8h-9V6.25c0-.42.34-.75.75-.75Zm-6 4h19.5c.42 0 .75.33.75.75V14h-4v-1.25a.75.75 0 0 0-1.5 0V14H9v-1.25a.75.75 0 0 0-1.5 0V14h-4v-3.75c0-.42.34-.75.75-.75Zm14.76 6v1.25a.75.75 0 0 0 1.5 0V15.5h4v6.25c0 .41-.34.75-.76.75H4.25a.75.75 0 0 1-.75-.75V15.5h4v1.25a.75.75 0 0 0 1.5 0V15.5h10Z",
    fill: primaryFill
  }));
};

export const Toolbox28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Toolbox28RegularIcon, 'Toolbox28Regular');

const TooltipQuote20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2V4Zm3.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A4.97 4.97 0 0 0 7 5.5a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A4.97 4.97 0 0 0 10 5.5a.5.5 0 0 0-.5-.5h-1Zm-2.98 9H2.5a.5.5 0 0 0 0 1h3.56l-.54-1Zm3.41 1h8.57a.5.5 0 0 0 0-1H9.48l-.55 1ZM2 17.5c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TooltipQuote20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TooltipQuote20FilledIcon, 'TooltipQuote20Filled');

const TooltipQuote20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A4.97 4.97 0 0 0 7 5.5a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .8.4c-.2.67-.5 1.1-.65 1.25a.5.5 0 1 0 .7.7A4.97 4.97 0 0 0 10 5.5a.5.5 0 0 0-.5-.5h-1ZM2 4c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9.42l-1.48 2.74a.5.5 0 0 1-.88 0L5.56 12H4a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1.86c.18 0 .35.1.44.26l1.2 2.2 1.18-2.2a.5.5 0 0 1 .44-.26H11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4ZM2.5 14h3.02l.54 1H2.5a.5.5 0 0 1 0-1Zm15 1H8.93l.55-1h8.02a.5.5 0 0 1 0 1Zm-15 2a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1h-10Z",
    fill: primaryFill
  }));
};

export const TooltipQuote20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TooltipQuote20RegularIcon, 'TooltipQuote20Regular');

const TooltipQuote24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.25 2C3.01 2 2 3 2 4.25v7.5C2 12.99 3 14 4.25 14h1.94l1.9 3.6a.75.75 0 0 0 1.32 0l1.9-3.6h1.94c1.24 0 2.25-1 2.25-2.25v-7.5c0-1.24-1-2.25-2.25-2.25h-9ZM5.5 6.25c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75 0 2.15-1.29 3.6-1.72 4.03a.75.75 0 1 1-1.06-1.06c.2-.2.61-.66.91-1.33a.75.75 0 0 1-1.13-.64v-1Zm4 0c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75 0 2.15-1.29 3.6-1.72 4.03a.75.75 0 1 1-1.06-1.06c.2-.2.61-.66.91-1.33a.75.75 0 0 1-1.13-.64v-1ZM2.75 16.5h3.63l.79 1.5H2.75a.75.75 0 0 1 0-1.5Zm18.5 1.5H10.33l.8-1.5h10.12a.75.75 0 0 1 0 1.5ZM2 21.25c0-.41.34-.75.75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const TooltipQuote24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TooltipQuote24FilledIcon, 'TooltipQuote24Filled');

const TooltipQuote24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 5.5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.13.64c-.3.67-.71 1.13-.91 1.33a.75.75 0 1 0 1.06 1.06A5.85 5.85 0 0 0 8.5 6.25a.75.75 0 0 0-.75-.75h-1.5Zm4 0a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.13.64c-.3.67-.71 1.13-.91 1.33a.75.75 0 1 0 1.06 1.06 5.85 5.85 0 0 0 1.72-4.03.75.75 0 0 0-.75-.75h-1.5ZM2 4.25C2 3.01 3 2 4.25 2h9c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-1.94l-1.9 3.6a.75.75 0 0 1-1.32 0L6.19 14H4.25C3.01 14 2 13 2 11.75v-7.5Zm2.25-.75a.75.75 0 0 0-.75.75v7.5c0 .41.34.75.75.75h2.4c.27 0 .53.15.66.4l1.44 2.74 1.44-2.74c.13-.25.39-.4.67-.4h2.39c.41 0 .75-.34.75-.75v-7.5a.75.75 0 0 0-.75-.75h-9Zm2.13 13H2.75a.75.75 0 0 0 0 1.5h4.42l-.8-1.5Zm3.95 1.5h10.92a.75.75 0 0 0 0-1.5H11.12l-.79 1.5Zm-7.58 2.5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-12Z",
    fill: primaryFill
  }));
};

export const TooltipQuote24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TooltipQuote24RegularIcon, 'TooltipQuote24Regular');

const TopSpeed20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 3.54a6.5 6.5 0 0 0-3.3 1.36l.83.82a.75.75 0 0 1-1.06 1.06l-.83-.82A6.39 6.39 0 0 0 3.57 9h1.68a.75.75 0 0 1 0 1.5H3.53a6.65 6.65 0 0 0 2.06 4.2.75.75 0 0 1-1.03 1.1A8.11 8.11 0 0 1 2 9.94C2 5.55 5.59 2 10 2a7.97 7.97 0 0 1 5.47 13.8.75.75 0 0 1-1.02-1.1 6.58 6.58 0 0 0 2.03-4.2h-1.73a.75.75 0 0 1 0-1.5h1.68a6.48 6.48 0 0 0-5.68-5.46v1.21a.75.75 0 0 1-1.5 0v-1.2Zm4.2 2.27a.5.5 0 0 1 .75.63l-.12.2a343.95 343.95 0 0 1-2.2 3.82 30.11 30.11 0 0 1-.65 1.01 1.5 1.5 0 0 1-2.28-1.94c.07-.09.2-.2.34-.33l.56-.48a123.93 123.93 0 0 1 3.42-2.77l.18-.14Z",
    fill: primaryFill
  }));
};

export const TopSpeed20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TopSpeed20FilledIcon, 'TopSpeed20Filled');

const TopSpeed20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.42 4.7A6.97 6.97 0 0 1 9.5 3.03V4.5a.5.5 0 0 0 1 0V3.02A7 7 0 0 1 16.93 9H15a.5.5 0 0 0 0 1h2c0 2-.86 3.9-2.21 5.17a.5.5 0 0 0 .69.73A8.17 8.17 0 0 0 18 10a8 8 0 1 0-13.44 5.9.5.5 0 0 0 .69-.73A7.2 7.2 0 0 1 3 10h2a.5.5 0 1 0 0-1H3.07c.2-1.36.78-2.6 1.64-3.58l1.44 1.43a.5.5 0 0 0 .7-.7L5.42 4.7Zm8.03 1.1a.5.5 0 0 1 .75.64l-.12.2a343.95 343.95 0 0 1-2.2 3.82 30.11 30.11 0 0 1-.65 1.01 1.5 1.5 0 0 1-2.28-1.94c.07-.09.2-.2.34-.33l.56-.48a123.93 123.93 0 0 1 3.42-2.77l.18-.14Z",
    fill: primaryFill
  }));
};

export const TopSpeed20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TopSpeed20RegularIcon, 'TopSpeed20Regular');

const TopSpeed24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3.56V5a1 1 0 1 0 2 0V3.56A8.5 8.5 0 0 1 20.44 11H19a1 1 0 1 0 0 2h1.44a8.5 8.5 0 0 1-2.24 4.74.75.75 0 1 0 1.1 1.02A9.92 9.92 0 0 0 22 12a10 10 0 0 0-20 0 9.92 9.92 0 0 0 2.7 6.76.75.75 0 1 0 1.1-1.02A8.5 8.5 0 0 1 3.56 13H5a1 1 0 1 0 0-2H3.56c.19-1.6.82-3.06 1.76-4.26l.97.97a1 1 0 0 0 1.42-1.42l-.97-.97A8.46 8.46 0 0 1 11 3.56Zm5.76 3.07a.65.65 0 0 0-.8.02l-.23.18a396.1 396.1 0 0 0-4.21 3.6 37.86 37.86 0 0 0-1.1 1.05c-.66.8-.52 1.98.3 2.62.83.64 2.03.5 2.68-.3a37.18 37.18 0 0 0 .78-1.3 152.48 152.48 0 0 0 2.62-4.85l.13-.24a.61.61 0 0 0-.17-.78Z",
    fill: primaryFill
  }));
};

export const TopSpeed24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TopSpeed24FilledIcon, 'TopSpeed24Filled');

const TopSpeed24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.54 5.48a8.46 8.46 0 0 1 4.71-1.95v1.72a.75.75 0 0 0 1.5 0V3.53a8.5 8.5 0 0 1 7.74 7.97h-1.74a.75.75 0 0 0 0 1.5h1.7a8.45 8.45 0 0 1-3.17 5.67.75.75 0 0 0 .94 1.16A9.93 9.93 0 0 0 22 12a10 10 0 1 0-16.23 7.83.75.75 0 0 0 .96-1.16A8.66 8.66 0 0 1 3.56 13h1.69a.75.75 0 0 0 0-1.5H3.51c.11-1.88.84-3.6 1.97-4.96l1.24 1.24a.75.75 0 0 0 1.06-1.06L6.54 5.48Zm10.22 1.15a.65.65 0 0 0-.8.02l-.23.18a396.1 396.1 0 0 0-4.21 3.6 37.86 37.86 0 0 0-1.1 1.05c-.66.8-.52 1.98.3 2.62.83.64 2.03.5 2.68-.3a37.18 37.18 0 0 0 .78-1.3 152.48 152.48 0 0 0 2.62-4.85l.13-.24a.61.61 0 0 0-.17-.78Z",
    fill: primaryFill
  }));
};

export const TopSpeed24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TopSpeed24RegularIcon, 'TopSpeed24Regular');

const Translate16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 3.27c.41.08.67.48.59.88l-.06.28c.41-.08.84-.2 1.3-.37a.75.75 0 0 1 .54 1.4c-.74.29-1.43.44-2.08.52l-.04.54a6 6 0 0 1 1.14.01.75.75 0 0 1 1.46.13v.04a1.62 1.62 0 0 1 .01.18v.02a2.9 2.9 0 0 1 1.8 2.4c.09 1.33-.84 2.54-2.55 3.18a.75.75 0 0 1-.53-1.4c1.33-.5 1.61-1.23 1.58-1.68-.03-.3-.2-.65-.56-.92-.06.25-.13.52-.23.83a3.2 3.2 0 0 1-1.52 1.8.75.75 0 0 1-1.27.49c-.52.1-1.09.1-1.6-.07a2 2 0 0 1-1.3-1.3c-.42-1.31.37-2.43 1.4-3.05.2-.12.42-.22.65-.31 0-.28.03-.55.05-.84a15.8 15.8 0 0 1-1-.08.75.75 0 0 1 .16-1.5c.34.04.69.07 1.04.09l.14-.7c.08-.4.48-.66.89-.57ZM9.7 8.5c-.66.41-.8.9-.69 1.27.06.17.16.28.35.34.16.05.38.07.64.05-.13-.58-.23-1.12-.3-1.66Zm1.7 1.03c.21-.2.37-.42.44-.64l.23-.87a4.46 4.46 0 0 0-.9 0c.04.5.12.99.23 1.5ZM4.7 6.05a2.5 2.5 0 0 0-1.58.16.75.75 0 0 1-.73-1.31 3.97 3.97 0 0 1 2.67-.31A2.38 2.38 0 0 1 7 7v4a.75.75 0 0 1-1.48.18 3.6 3.6 0 0 1-2.51.19 2.3 2.3 0 0 1-1.5-1.72 2.6 2.6 0 0 1 .11-1.58c.24-.54.69-.94 1.29-1.24.37-.19.8-.26 1.17-.29a6.63 6.63 0 0 1 1.35.05.72.72 0 0 0-.14-.23 1.15 1.15 0 0 0-.6-.31Zm.8 2.07a7.98 7.98 0 0 0-1.3-.08c-.28.02-.48.07-.6.13-.4.2-.54.38-.6.5-.05.14-.08.34 0 .68.04.22.2.5.52.6.3.11.91.14 1.98-.4V8.12Z",
    fill: primaryFill
  }));
};

export const Translate16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate16FilledIcon, 'Translate16Filled');

const Translate16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.49 4.1a.5.5 0 1 0-.98-.2l-.19.95c-.44.02-.87.01-1.29-.02a.5.5 0 0 0-.07 1c.4.03.8.04 1.21.03-.05.4-.08.78-.1 1.14a3.73 3.73 0 0 0-1.83 1.67c-.4.8-.36 1.73.2 2.3.38.39.92.43 1.4.32.21-.04.43-.13.65-.24l.04.13a.5.5 0 1 0 .94-.35l-.12-.38a5.13 5.13 0 0 0 1.56-2.91c.1.03.2.06.28.1.44.19.7.52.81.91.2.77-.22 1.92-1.68 2.48a.5.5 0 1 0 .36.94c1.83-.7 2.65-2.31 2.29-3.68a2.36 2.36 0 0 0-1.38-1.57 2.91 2.91 0 0 0-.6-.18V6.5a.5.5 0 0 0-1-.02c-.28.02-.58.07-.9.15l.1-.83c.66-.07 1.32-.17 1.92-.31a.5.5 0 0 0-.23-.98c-.48.12-1 .2-1.53.26l.14-.66ZM9.13 9.12c.16-.31.45-.66.91-.96.01.75.08 1.38.18 1.9-.22.14-.42.23-.6.27-.3.06-.43 0-.47-.05-.17-.18-.29-.6-.02-1.16ZM11.9 7.5c-.15.7-.44 1.29-.79 1.74a11.6 11.6 0 0 1-.07-1.55 5.26 5.26 0 0 1 .86-.2ZM5.5 4.8a3.7 3.7 0 0 0-2.73.25l-.01.01h-.01a.5.5 0 0 0 .5.88.93.93 0 0 1 .13-.07 2.77 2.77 0 0 1 1.83-.11c.4.12.58.34.67.6.08.23.1.48.11.76-.19-.04-.41-.07-.65-.1a3.9 3.9 0 0 0-2.37.35c-1.46.9-1.25 3.18.46 3.7.76.24 1.5.06 2.07-.18l.5-.25V11a.5.5 0 1 0 1 0V7.44c0-.38 0-.92-.17-1.4A1.9 1.9 0 0 0 5.49 4.8ZM6 8.14v1.34a5.9 5.9 0 0 1-.9.48c-.46.2-.94.3-1.38.16-.84-.26-.98-1.43-.23-1.9.4-.24 1.07-.28 1.74-.2.3.03.57.08.77.12Z",
    fill: primaryFill
  }));
};

export const Translate16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate16RegularIcon, 'Translate16Regular');

const Translate20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.42 4.02a.75.75 0 1 0-1.4-.54c-.14.37-.29.83-.4 1.24-.61.04-1.22.04-1.82 0a.75.75 0 0 0-.1 1.5c.51.03 1.03.04 1.53.02-.12.56-.21 1.08-.27 1.55a5.27 5.27 0 0 0-2.62 2.52c-.51 1.12-.48 2.45.32 3.26.54.55 1.32.6 2 .46.43-.09.9-.28 1.34-.55l.03.06a.75.75 0 1 0 1.38-.58l-.22-.45a7.06 7.06 0 0 0 1.82-3.5c.66.28 1.11.75 1.33 1.24.22.5.23 1.09-.06 1.65-.28.57-.9 1.19-2.01 1.66a.75.75 0 0 0 .58 1.38 5.26 5.26 0 0 0 2.77-2.37 3.4 3.4 0 0 0 .09-2.93 4.04 4.04 0 0 0-2.54-2.18v-.03a.75.75 0 0 0-1.48-.2c-.36-.02-.74 0-1.14.06l.25-1.18c.75-.09 1.49-.22 2.2-.38a.75.75 0 1 0-.31-1.46c-.48.1-.97.2-1.45.27l.18-.52Zm-3.71 6.9c.2-.43.56-.9 1.12-1.32.01.55.07 1.02.16 1.44a6 6 0 0 0 .34 1.09c-.36.23-.7.38-1 .44-.41.09-.57-.02-.6-.05-.21-.22-.38-.8-.02-1.6Zm3.83-2.2a5.64 5.64 0 0 1-1.02 2.27 6.7 6.7 0 0 1-.17-2.13c.43-.1.82-.14 1.19-.14ZM5.98 5.2a4.92 4.92 0 0 0-3.93.5l-.02.02h-.01a.75.75 0 0 0 .85 1.24l.03-.02.14-.07a3.42 3.42 0 0 1 2.52-.22c.57.16.8.46.92.75.08.2.11.41.13.63-.44-.1-.94-.2-1.47-.22a4.5 4.5 0 0 0-3.18 1.01 2.8 2.8 0 0 0-.84 2.96c.3 1 1.1 1.9 2.3 2.15a4.4 4.4 0 0 0 2.64-.4l.56-.29v.01a.75.75 0 1 0 1.5 0V8.5c0-.37 0-1.02-.25-1.66A2.76 2.76 0 0 0 5.99 5.2Zm-.9 4.11c.55.03 1.08.15 1.54.28v1.88c-.3.22-.71.48-1.17.68-.64.29-1.24.41-1.72.31a1.55 1.55 0 0 1-1.17-1.1c-.15-.53-.02-1.06.37-1.39.63-.54 1.38-.69 2.14-.66Z",
    fill: primaryFill
  }));
};

export const Translate20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate20FilledIcon, 'Translate20Filled');

const Translate20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.17 4.03c.26.1.4.38.3.64-.12.34-.25.8-.35 1.2.57-.1 1.15-.21 1.77-.36a.5.5 0 1 1 .22.98c-.77.18-1.5.32-2.24.41-.1.46-.17.87-.22 1.25.47-.1.92-.14 1.35-.13V8a.5.5 0 0 1 1 0v.17a3.37 3.37 0 0 1 2.34 2.06c.62 1.66-.21 3.65-2.64 4.73a.5.5 0 1 1-.4-.92c2.07-.92 2.5-2.43 2.1-3.47a2.37 2.37 0 0 0-1.49-1.38 6.7 6.7 0 0 1-1.68 3.6c.08.18.17.35.23.53a.5.5 0 1 1-.93.37 5.08 5.08 0 0 0-.08-.21c-.42.3-.86.5-1.28.6-.58.14-1.2.07-1.64-.39-.64-.68-.69-1.83-.24-2.85a4.71 4.71 0 0 1 2.3-2.3c.05-.47.13-.98.24-1.55-.44.02-.89.01-1.36-.02a.5.5 0 1 1 .06-1c.53.04 1.03.04 1.53 0 .1-.42.3-1.14.47-1.64a.5.5 0 0 1 .64-.3ZM12.5 9.74c-.66.44-1.07.98-1.3 1.5-.35.8-.21 1.48.06 1.77.1.1.3.19.69.1.3-.07.68-.25 1.06-.55a5.85 5.85 0 0 1-.38-1.2c-.09-.46-.14-.99-.13-1.62Zm1.28 2.04c.54-.68.98-1.61 1.15-2.76a4.6 4.6 0 0 0-1.4.2 7.2 7.2 0 0 0 .08 1.94c.05.23.1.43.17.62ZM6.92 5.22a5.04 5.04 0 0 0-3.98.5h-.02v.01l.03.05c.29.42.22.33-.04-.05a.5.5 0 0 0 .57.83 1.44 1.44 0 0 1 .21-.12 4.04 4.04 0 0 1 2.95-.26c.71.2 1.03.59 1.19.98.15.38.17.8.18 1.17a8.73 8.73 0 0 0-1.93-.32 4.57 4.57 0 0 0-3.2 1 2.66 2.66 0 0 0-.81 2.84 2.97 2.97 0 0 0 2.25 2.08c.9.2 1.86-.07 2.64-.4.38-.18.74-.37 1.05-.56v.53a.5.5 0 1 0 1 0V8.45c0-.4 0-1.04-.26-1.67a2.66 2.66 0 0 0-1.83-1.56ZM6.04 9c.72.03 1.4.2 1.97.36v2.39c-.35.26-.87.59-1.45.85-.7.3-1.43.47-2.04.35a1.97 1.97 0 0 1-1.5-1.39c-.19-.66-.03-1.35.5-1.79.76-.63 1.65-.8 2.52-.77Z",
    fill: primaryFill
  }));
};

export const Translate20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate20RegularIcon, 'Translate20Regular');

const Translate24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.95 5.3a1 1 0 0 0-1.9-.6c-.13.39-.24.9-.33 1.34-.56.01-1.12 0-1.65-.04a1 1 0 1 0-.14 2c.46.03.93.05 1.42.05-.11.6-.19 1.17-.24 1.7a6.37 6.37 0 0 0-2.64 2.7c-.63 1.28-.7 2.85.24 3.88.67.73 1.7.75 2.5.58.32-.06.65-.17.98-.32a1 1 0 0 0 1.75-.93l-.04-.11a8.4 8.4 0 0 0 2.74-4.06c.28.25.5.55.65.86.29.6.34 1.27.1 1.91a3.49 3.49 0 0 1-1.84 1.85 1 1 0 0 0 .9 1.78 5.47 5.47 0 0 0 2.82-2.94 4.44 4.44 0 0 0-.17-3.46A4.75 4.75 0 0 0 20 9.33V9a1 1 0 0 0-1.97-.23c-.57-.04-1.17 0-1.8.14.05-.3.1-.63.17-.97.97-.09 1.94-.25 2.84-.47a1 1 0 0 0-.48-1.94c-.62.15-1.28.27-1.96.36l.15-.59Zm-3.68 8.02c.16-.34.41-.7.76-1.04a10.8 10.8 0 0 0 .43 2.45c-.24.11-.47.18-.67.23-.43.09-.59.02-.61 0-.17-.19-.34-.77.09-1.64Zm4.5-2.56a6.36 6.36 0 0 1-1.57 2.73 10.3 10.3 0 0 1-.18-2.43l.1-.04 1.64-.26Zm-1.66.26 1.66-.26c-.5-.03-1.05.05-1.66.26ZM7.54 6.3a6.34 6.34 0 0 0-4.46.33 1 1 0 0 0 .85 1.81 4.34 4.34 0 0 1 3.05-.22c.36.1.56.25.69.37.12.12.2.27.25.45.07.23.1.45.1.7a6.41 6.41 0 0 0-4.82.52 3.56 3.56 0 0 0-1.68 3.44 3.5 3.5 0 0 0 2.57 3.14 5.6 5.6 0 0 0 3.95-.55A1 1 0 0 0 10 16v-5.7c.02-.42.04-1.16-.16-1.84-.13-.44-.36-.9-.75-1.29-.4-.4-.91-.7-1.55-.88Zm-.42 5.29c.34.06.64.14.88.22V14c-.22.15-.53.34-.9.52-.8.38-1.68.6-2.47.38a1.5 1.5 0 0 1-1.12-1.38c-.06-.7.24-1.29.66-1.53a4.42 4.42 0 0 1 2.95-.41Z",
    fill: primaryFill
  }));
};

export const Translate24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate24FilledIcon, 'Translate24Filled');

const Translate24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.96 5.99a.75.75 0 0 0-1.42-.48c-.15.45-.3 1.04-.42 1.52-.74.02-1.45.01-2.07-.03a.75.75 0 1 0-.1 1.5c.56.04 1.19.05 1.84.04-.14.76-.24 1.44-.3 2.06a5.94 5.94 0 0 0-2.54 2.41c-.6 1.17-.66 2.56.21 3.44.57.59 1.4.64 2.13.49.4-.09.82-.25 1.24-.47l.02.04a.75.75 0 0 0 1.4-.52l-.17-.43a7.63 7.63 0 0 0 2.29-4.04c.63.3 1.07.83 1.27 1.4.23.61.22 1.3-.1 1.95-.3.63-.92 1.26-2 1.68a.75.75 0 1 0 .53 1.4 5.01 5.01 0 0 0 2.83-2.43 4.04 4.04 0 0 0-2.35-5.55v-.22a.75.75 0 0 0-1.5-.03c-.52 0-1.08.07-1.67.24.06-.45.15-.95.26-1.5 1.18-.09 2.36-.25 3.33-.48a.75.75 0 0 0-.34-1.46c-.77.18-1.7.32-2.64.4.09-.32.18-.66.27-.93Zm-3.68 7.72a4 4 0 0 1 1.15-1.3 7.83 7.83 0 0 0 .52 2.69c-.3.17-.63.3-.98.37-.48.1-.68 0-.74-.06-.24-.25-.4-.86.05-1.7Zm4.32-2.49c-.21.97-.7 2.02-1.42 2.85a8.62 8.62 0 0 1-.25-2.48l.34-.12c.48-.16.92-.23 1.33-.25ZM7.96 6.53c-2.24-.65-4 .15-4.57.47A.75.75 0 1 0 4.1 8.3c.4-.22 1.74-.83 3.43-.34.77.23 1.1.64 1.27 1.06.13.33.17.69.18 1.04a9.83 9.83 0 0 0-.92-.21 6.83 6.83 0 0 0-4.12.42 3.39 3.39 0 0 0-1.9 3.7 3.52 3.52 0 0 0 2.8 2.95A5.95 5.95 0 0 0 9 15.95v.3a.75.75 0 0 0 1.5 0v-5.79c0-.45 0-1.24-.3-1.99-.33-.83-1-1.58-2.24-1.94Zm-.15 4.8c.48.09.9.21 1.19.3v2.51a7.38 7.38 0 0 1-1.1.7c-.84.45-1.85.79-2.79.62a2.02 2.02 0 0 1-1.58-1.72 1.89 1.89 0 0 1 1.07-2.1 5.34 5.34 0 0 1 3.2-.3Z",
    fill: primaryFill
  }));
};

export const Translate24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Translate24RegularIcon, 'Translate24Regular');

const TranslateOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m11.1 11.8 3.05 3.05a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L3.8 4.5a3.6 3.6 0 0 0-1.4.4.75.75 0 0 0 .72 1.31c.32-.18 1-.3 1.58-.16.28.06.47.18.6.3.05.07.1.14.14.24a9.07 9.07 0 0 0-1.35-.05c-.37.03-.8.1-1.17.29-.6.3-1.05.7-1.29 1.24a2.6 2.6 0 0 0-.11 1.58c.12.6.56 1.4 1.5 1.72.68.24 1.52.2 2.5-.19A.75.75 0 0 0 7 11V7.7l.74.73a2.25 2.25 0 0 0-.15 1.8 2 2 0 0 0 1.3 1.29 3.1 3.1 0 0 0 1.59.07c.16.15.38.23.61.2ZM5.05 8.06c.16.01.3.04.44.06v1.43c-1.07.54-1.68.51-1.98.4a.8.8 0 0 1-.53-.6c-.07-.34-.04-.54.02-.67.05-.13.19-.31.58-.5.13-.07.33-.12.61-.14.27-.02.57-.01.86.02Zm9 1.34c.03.39-.18.98-1.08 1.46l1.09 1.09c1.03-.68 1.56-1.63 1.48-2.66a2.9 2.9 0 0 0-1.8-2.39l.01-.02a2.32 2.32 0 0 0 0-.18v-.03a.75.75 0 0 0-1.47-.14 6 6 0 0 0-1.14-.01c0-.18.02-.36.04-.54a8.42 8.42 0 0 0 2.08-.52.75.75 0 1 0-.54-1.4c-.46.18-.89.3-1.3.37l.06-.28a.75.75 0 1 0-1.47-.3l-.14.69-1.04-.08a.75.75 0 0 0-.16 1.49l1 .08-.05.84-.44.2 2.14 2.14c-.07-.4-.13-.8-.16-1.19.28-.03.59-.03.9 0l-.23.87c-.06.17-.16.35-.32.51l1.07 1.06c.3-.32.55-.7.68-1.15.1-.3.17-.58.23-.83.36.27.53.61.56.92Z",
    fill: primaryFill
  }));
};

export const TranslateOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff16FilledIcon, 'TranslateOff16Filled');

const TranslateOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.67 11.38a.5.5 0 0 1-.05-.05l-.23-.23c-.18.09-.37.15-.55.2-.48.1-1.02.06-1.4-.33-.52-.53-.59-1.36-.29-2.11L7 7.71V11a.5.5 0 0 1-1 0v-.36c-.16.09-.33.17-.5.24-.57.25-1.31.43-2.07.2-1.7-.53-1.92-2.81-.46-3.71a3.9 3.9 0 0 1 2.37-.35c.24.03.46.06.65.1 0-.16-.01-.31-.03-.46L5 5.7a2.74 2.74 0 0 0-1.75.23.5.5 0 0 1-.5-.86l.02-.02a1.93 1.93 0 0 1 .22-.1 3.77 3.77 0 0 1 .99-.27L1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7l-3.48-3.47Zm-1.06-1.06-.64-.64c-.01.27.07.48.18.6.04.03.17.1.46.04ZM6 8.14a7.5 7.5 0 0 0-.77-.12c-.67-.08-1.33-.04-1.74.2-.75.47-.61 1.64.23 1.9.44.13.92.04 1.39-.16.35-.14.65-.33.89-.48V8.14Zm8 .41c.18.66-.11 1.6-1.12 2.21l.72.72c1.18-.81 1.66-2.08 1.37-3.19a2.36 2.36 0 0 0-1.38-1.57 2.91 2.91 0 0 0-.6-.19V6.5a.5.5 0 0 0-1-.02c-.28.02-.58.07-.9.15l.1-.83c.66-.07 1.32-.17 1.92-.31a.5.5 0 0 0-.23-.98c-.48.12-1 .2-1.53.26l.14-.67a.5.5 0 1 0-.98-.2l-.19.95c-.44.02-.87.01-1.29-.02a.5.5 0 1 0-.07 1c.4.03.8.04 1.21.03-.05.4-.08.78-.1 1.14-.22.1-.43.22-.61.34l1.62 1.62c-.03-.38-.05-.8-.04-1.27a5.26 5.26 0 0 1 .86-.2 4.28 4.28 0 0 1-.68 1.6l.71.72c.46-.6.82-1.36.98-2.27.1.03.2.06.28.1.44.19.7.52.81.91Z",
    fill: primaryFill
  }));
};

export const TranslateOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff16RegularIcon, 'TranslateOff16Regular');

const TranslateOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L4.3 5.01a4.96 4.96 0 0 0-2.25.7l-.02.01h-.01a.75.75 0 0 0 .85 1.24l.03-.02.14-.07a3.42 3.42 0 0 1 2.52-.22c.57.16.8.46.92.75.08.2.11.41.13.63-.44-.1-.94-.2-1.47-.22a4.5 4.5 0 0 0-3.18 1.01 2.8 2.8 0 0 0-.84 2.96c.3 1 1.1 1.9 2.3 2.15a4.4 4.4 0 0 0 2.64-.4l.56-.29v.01a.75.75 0 1 0 1.5 0V8.83l1.3 1.3-.08.18c-.51 1.12-.48 2.45.32 3.26.54.55 1.32.6 2 .46.39-.08.8-.24 1.2-.47l4.29 4.3a.5.5 0 0 0 .7-.71l-15-15Zm8.89 10.3c-.14.05-.28.1-.4.12-.42.09-.58-.02-.61-.05-.18-.18-.33-.63-.15-1.24l1.16 1.16ZM5.07 9.3c.56.03 1.09.14 1.55.27v1.9c-.3.21-.71.47-1.17.67-.64.29-1.24.41-1.72.31a1.55 1.55 0 0 1-1.17-1.1c-.15-.53-.02-1.06.37-1.39.63-.54 1.38-.69 2.14-.66Zm6.76.29v.11l2.57 2.57A7.1 7.1 0 0 0 16.01 9c.66.3 1.11.76 1.33 1.25.22.5.23 1.09-.06 1.65-.26.52-.8 1.08-1.73 1.53l1.11 1.1a4.8 4.8 0 0 0 1.96-1.96 3.4 3.4 0 0 0 .09-2.93 4.04 4.04 0 0 0-2.54-2.18v-.03a.75.75 0 0 0-1.48-.2c-.36-.02-.74 0-1.14.06l.25-1.18c.75-.09 1.49-.22 2.2-.38a.75.75 0 1 0-.31-1.46c-.48.1-.97.2-1.45.27l.18-.52a.75.75 0 1 0-1.4-.54c-.14.37-.29.83-.4 1.24-.61.04-1.22.04-1.82 0a.75.75 0 0 0-.1 1.5c.51.03 1.03.04 1.53.02-.12.56-.21 1.08-.27 1.55-.48.23-.9.5-1.26.79l1.07 1.07.06-.05Zm2.7-.88a5.64 5.64 0 0 1-1 2.27 6.7 6.7 0 0 1-.17-2.13c.42-.1.81-.14 1.18-.14Z",
    fill: primaryFill
  }));
};

export const TranslateOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff20FilledIcon, 'TranslateOff20Filled');

const TranslateOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l2.27 2.28a5.1 5.1 0 0 0-1.48.58l-.02.02a.5.5 0 0 0 .56.83 1.44 1.44 0 0 1 .21-.12 3.9 3.9 0 0 1 1.62-.42L7.5 8.2c-.43-.1-.91-.18-1.42-.2a4.57 4.57 0 0 0-3.2 1 2.66 2.66 0 0 0-.81 2.84 2.97 2.97 0 0 0 2.25 2.08c.9.2 1.86-.07 2.64-.4.38-.18.74-.37 1.05-.56v.53a.5.5 0 1 0 1 0V9.7l1.23 1.24c-.4.99-.33 2.08.3 2.74.42.46 1.05.53 1.63.4.28-.07.58-.19.86-.35l4.12 4.11a.5.5 0 0 0 .7-.7l-15-15ZM12.3 13c-.12.05-.24.08-.34.1-.39.1-.6.01-.69-.09-.21-.23-.34-.69-.22-1.26L12.29 13ZM6.04 9c.72.04 1.4.2 1.97.37v2.39c-.35.26-.87.59-1.45.85-.7.3-1.43.47-2.04.35a1.97 1.97 0 0 1-1.5-1.39c-.19-.66-.03-1.35.5-1.79.76-.63 1.65-.81 2.52-.77Zm6.46.74.01.65 1.21 1.21a7.2 7.2 0 0 1-.2-2.38l.13-.04c.46-.12.89-.17 1.28-.16a5.85 5.85 0 0 1-1.1 2.7l.72.7A6.82 6.82 0 0 0 15.9 9.2c.77.26 1.28.8 1.5 1.38.34.94.04 2.25-1.54 3.18l.73.72c1.73-1.12 2.28-2.8 1.74-4.24A3.37 3.37 0 0 0 16 8.17V8a.5.5 0 1 0-1 0v.02c-.43-.01-.88.03-1.35.13.05-.38.13-.8.22-1.25a21.3 21.3 0 0 0 2.24-.41.5.5 0 1 0-.22-.98c-.62.15-1.2.27-1.77.35.1-.38.23-.85.35-1.2a.5.5 0 0 0-.94-.33c-.18.5-.37 1.22-.47 1.65-.5.03-1 .03-1.53 0a.5.5 0 1 0-.06 1c.47.02.92.03 1.36 0-.11.58-.2 1.1-.25 1.56-.44.22-.83.48-1.15.77l.7.7.37-.27Z",
    fill: primaryFill
  }));
};

export const TranslateOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff20RegularIcon, 'TranslateOff20Regular');

const TranslateOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.8 2.8c-.85.1-1.52.34-1.94.54a1 1 0 1 0 .85 1.81 4.34 4.34 0 0 1 3.32-.12l.65.65.02.07c.07.23.1.45.1.7a6.41 6.41 0 0 0-4.82.52 3.56 3.56 0 0 0-1.68 3.44 3.5 3.5 0 0 0 2.57 3.14 5.6 5.6 0 0 0 3.95-.55A1 1 0 0 0 10 16v-4.94l1.44 1.44c-.6 1.27-.66 2.81.27 3.83.67.73 1.7.75 2.5.58.32-.06.65-.17.98-.32a1 1 0 0 0 .75.4l4.78 4.8a.75.75 0 0 0 1.06-1.07L3.28 2.22Zm10.6 12.72-.09.02c-.43.09-.59.02-.61 0-.12-.13-.23-.43-.16-.88l.86.86Zm-6.76-3.36c.34.06.64.14.88.22V14c-.22.15-.53.34-.9.52-.8.38-1.68.6-2.47.38a1.5 1.5 0 0 1-1.12-1.38c-.06-.7.24-1.29.66-1.53a4.42 4.42 0 0 1 2.95-.41Zm13.27 2.68c-.2.53-.61 1.1-1.37 1.58l1.44 1.44a5.08 5.08 0 0 0 1.8-2.33 4.44 4.44 0 0 0-.16-3.46A4.75 4.75 0 0 0 20 9.33V9a1 1 0 0 0-1.97-.23c-.57-.04-1.17 0-1.8.14.05-.3.1-.63.17-.97.97-.09 1.94-.25 2.84-.47a1 1 0 1 0-.48-1.94c-.62.15-1.28.27-1.96.36l.15-.59a1 1 0 0 0-1.9-.6c-.13.39-.24.9-.33 1.34-.56.01-1.12 0-1.65-.04a1 1 0 1 0-.14 2c.46.03.93.05 1.42.04-.11.62-.19 1.18-.24 1.7-.26.15-.5.3-.72.47l2.7 2.7c-.07-.5-.1-1.1-.08-1.85l.1-.04 1.66-.26a6.35 6.35 0 0 1-1.35 2.48l1.42 1.42a8.37 8.37 0 0 0 1.8-3.17c.28.25.5.55.65.86.29.6.34 1.27.1 1.91Z",
    fill: primaryFill
  }));
};

export const TranslateOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff24FilledIcon, 'TranslateOff24Filled');

const TranslateOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 1 0-1.06 1.06L5.3 6.36c-.92.14-1.6.46-1.91.64A.75.75 0 1 0 4.1 8.3a4.54 4.54 0 0 1 2.64-.5l2.24 2.24v.02a9.84 9.84 0 0 0-.92-.21 6.83 6.83 0 0 0-4.12.42 3.39 3.39 0 0 0-1.9 3.7 3.52 3.52 0 0 0 2.8 2.95A5.95 5.95 0 0 0 9 15.95v.3a.75.75 0 0 0 1.5 0v-4.7l1.45 1.46c-.6 1.17-.66 2.56.21 3.44.57.59 1.4.64 2.13.49a4.6 4.6 0 0 0 1.16-.43l.25.25.04.04 4.98 4.98a.75.75 0 0 0 1.06-1.06L3.28 2.22Zm11.04 13.16-.35.1c-.48.1-.68-.02-.74-.07-.2-.2-.33-.64-.14-1.26l1.23 1.23ZM7.8 11.33c.48.09.9.21 1.19.3v2.51a7.38 7.38 0 0 1-1.1.7c-.84.45-1.85.79-2.79.62a2.02 2.02 0 0 1-1.58-1.72 1.89 1.89 0 0 1 1.07-2.1 5.34 5.34 0 0 1 3.2-.3Zm12.44 3.54c-.2.4-.53.82-1.03 1.17l1.07 1.07c.59-.45 1.02-1 1.3-1.59.5-1.02.53-2.14.16-3.12a4.04 4.04 0 0 0-2.5-2.43v-.22a.75.75 0 0 0-1.5-.03c-.52 0-1.08.07-1.67.24.06-.45.15-.95.26-1.5 1.18-.09 2.36-.25 3.33-.48a.75.75 0 0 0-.34-1.46c-.77.18-1.7.32-2.64.4.09-.32.18-.66.27-.93a.75.75 0 0 0-1.42-.48c-.15.45-.3 1.04-.42 1.52-.74.02-1.45.01-2.07-.03a.75.75 0 1 0-.1 1.5c.56.04 1.19.05 1.84.04-.14.76-.24 1.44-.3 2.06l-.45.26 1.91 1.9a9.92 9.92 0 0 1-.02-1.17l.34-.12c.48-.16.92-.23 1.33-.25a6.71 6.71 0 0 1-.96 2.24l1.07 1.07a7.74 7.74 0 0 0 1.36-3.01c.63.3 1.07.83 1.27 1.4.23.61.22 1.3-.1 1.95Z",
    fill: primaryFill
  }));
};

export const TranslateOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TranslateOff24RegularIcon, 'TranslateOff24Regular');

const Transmission20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a2 2 0 0 0-.5 3.94V9.5a.5.5 0 0 0 1 0V5.94A2 2 0 0 0 10 2ZM3 5a1 1 0 0 1 2 0v4c0 .28.22.5.5.5H8a.5.5 0 0 0 0-1H6V5a2 2 0 1 0-4 0v11a2 2 0 1 0 4 0v-3.5h2V16a2 2 0 1 0 4 0v-3h4.5c.83 0 1.5-.67 1.5-1.5V5a2 2 0 1 0-4 0v3.5h-2a.5.5 0 0 0 0 1h2.5A.5.5 0 0 0 15 9V5a1 1 0 1 1 2 0v6.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 0-.5.5V16a1 1 0 1 1-2 0v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4a1 1 0 1 1-2 0V5Z",
    fill: primaryFill
  }));
};

export const Transmission20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Transmission20FilledIcon, 'Transmission20Filled');

const Transmission20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a2 2 0 0 0-.5 3.94.5.5 0 0 0 0 .06v3.5a.5.5 0 0 0 1 0V6a.5.5 0 0 0 0-.06A2 2 0 0 0 10 2ZM9 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4 4a1 1 0 0 0-1 1v11a1 1 0 1 0 2 0v-4c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v4a1 1 0 1 0 2 0v-3.5c0-.28.22-.5.5-.5h5a.5.5 0 0 0 .5-.5V5a1 1 0 1 0-2 0v4a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h2V5a2 2 0 1 1 4 0v6.5c0 .83-.67 1.5-1.5 1.5H12v3a2 2 0 1 1-4 0v-3.5H6V16a2 2 0 1 1-4 0V5a2 2 0 1 1 4 0v3.5h2a.5.5 0 0 1 0 1H5.5A.5.5 0 0 1 5 9V5a1 1 0 0 0-1-1Z",
    fill: primaryFill
  }));
};

export const Transmission20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Transmission20RegularIcon, 'Transmission20Regular');

const Transmission24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a2.75 2.75 0 0 0-.75 5.4v3.85a.75.75 0 0 0 1.5 0V7.4A2.75 2.75 0 0 0 12 2ZM5.5 4A2.5 2.5 0 0 0 3 6.5v12a2.5 2.5 0 0 0 5 0V15h1.5v3.5a2.5 2.5 0 0 0 5 0V15H19a2 2 0 0 0 2-2V6.5a2.5 2.5 0 0 0-5 0V10h-2.25v1.5h3.75v-5a1 1 0 1 1 2 0V13a.5.5 0 0 1-.5.5h-6v5a1 1 0 1 1-2 0v-5H6.5v5a1 1 0 1 1-2 0v-12a1 1 0 0 1 2 0v5h3.75V10H8V6.5A2.5 2.5 0 0 0 5.5 4Z",
    fill: primaryFill
  }));
};

export const Transmission24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Transmission24FilledIcon, 'Transmission24Filled');

const Transmission24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a2.75 2.75 0 0 0-.75 5.4v3.85a.75.75 0 0 0 1.5 0V7.4A2.75 2.75 0 0 0 12 2Zm-1.25 2.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM3 6.5a2.5 2.5 0 0 1 5 0V10h2.25v1.5H6.5v-5a1 1 0 0 0-2 0v12a1 1 0 1 0 2 0v-5H11v5a1 1 0 1 0 2 0v-5h6a.5.5 0 0 0 .5-.5V6.5a1 1 0 1 0-2 0v5h-3.75V10H16V6.5a2.5 2.5 0 0 1 5 0V13a2 2 0 0 1-2 2h-4.5v3.5a2.5 2.5 0 0 1-5 0V15H8v3.5a2.5 2.5 0 0 1-5 0v-12Z",
    fill: primaryFill
  }));
};

export const Transmission24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Transmission24RegularIcon, 'Transmission24Regular');

const TrayItemAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3Zm2 5.5a.5.5 0 0 0-1 0v5.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L14 13.29V7.5ZM5 11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5Zm-2 2.5a.5.5 0 0 0-1 0V15c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.5Z",
    fill: primaryFill
  }));
};

export const TrayItemAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemAdd20FilledIcon, 'TrayItemAdd20Filled');

const TrayItemAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3Zm4 0h-3v2h3V3Zm-1.5 4c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L13 13.29V7.5c0-.28.22-.5.5-.5ZM4 12a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2Zm4 0H5v2h3v-2Zm-5.5 1c.28 0 .5.22.5.5V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.5a.5.5 0 0 1 1 0V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const TrayItemAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemAdd20RegularIcon, 'TrayItemAdd20Regular');

const TrayItemAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h4C18.44 7 19 6.44 19 5.75v-2.5C19 2.56 18.44 2 17.75 2h-4Zm2.75 7.25a.75.75 0 0 0-1.5 0v6.69l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22V9.25ZM6.25 13.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-4ZM3.5 16.75a.75.75 0 0 0-1.5 0v2a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 18.75v-2a.75.75 0 0 0-1.5 0v2c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2Z",
    fill: primaryFill
  }));
};

export const TrayItemAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemAdd24FilledIcon, 'TrayItemAdd24Filled');

const TrayItemAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3.5v2h3.5v-2H14Zm-1.5-.25c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2.5C19 6.44 18.44 7 17.75 7h-4c-.69 0-1.25-.56-1.25-1.25v-2.5Zm3.25 5.25c.41 0 .75.34.75.75v6.69l1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L15 15.94V9.25c0-.41.34-.75.75-.75ZM6.5 15v2H10v-2H6.5ZM5 14.75c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-2.5ZM2.75 16c.41 0 .75.34.75.75v2c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2a2.75 2.75 0 0 1-2.75 2.75H4.75A2.75 2.75 0 0 1 2 18.75v-2c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const TrayItemAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemAdd24RegularIcon, 'TrayItemAdd24Regular');

const TrayItemRemove20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3Zm1.85 5.15a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L13 8.71v5.79a.5.5 0 0 0 1 0V8.7l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2ZM5 11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5Zm-2 2.5a.5.5 0 0 0-1 0V15c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.5Z",
    fill: primaryFill
  }));
};

export const TrayItemRemove20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemRemove20FilledIcon, 'TrayItemRemove20Filled');

const TrayItemRemove20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3Zm4 0h-3v2h3V3Zm-1.85 4.15c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L14 8.71v5.79a.5.5 0 0 1-1 0V8.7l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2ZM4 12a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2Zm4 0H5v2h3v-2Zm-5.5 1c.28 0 .5.22.5.5V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.5a.5.5 0 0 1 1 0V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const TrayItemRemove20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemRemove20RegularIcon, 'TrayItemRemove20Regular');

const TrayItemRemove24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h4C18.44 7 19 6.44 19 5.75v-2.5C19 2.56 18.44 2 17.75 2h-4Zm2.53 6.72a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L15 11.06v6.69a.75.75 0 0 0 1.5 0v-6.69l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5ZM6.25 13.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-4ZM3.5 16.75a.75.75 0 0 0-1.5 0v2a2.75 2.75 0 0 0 2.75 2.75h14.5A2.75 2.75 0 0 0 22 18.75v-2a.75.75 0 0 0-1.5 0v2c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2Z",
    fill: primaryFill
  }));
};

export const TrayItemRemove24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemRemove24FilledIcon, 'TrayItemRemove24Filled');

const TrayItemRemove24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3.5v2h3.5v-2H14Zm-1.5-.25c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2.5C19 6.44 18.44 7 17.75 7h-4c-.69 0-1.25-.56-1.25-1.25v-2.5Zm2.72 5.47c.3-.3.77-.3 1.06 0l2.5 2.5a.75.75 0 1 1-1.06 1.06l-1.22-1.22v6.69a.75.75 0 0 1-1.5 0v-6.69l-1.22 1.22a.75.75 0 1 1-1.06-1.06l2.5-2.5ZM6.5 15v2H10v-2H6.5ZM5 14.75c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-2.5ZM2.75 16c.41 0 .75.34.75.75v2c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2a2.75 2.75 0 0 1-2.75 2.75H4.75A2.75 2.75 0 0 1 2 18.75v-2c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const TrayItemRemove24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrayItemRemove24RegularIcon, 'TrayItemRemove24Regular');

const TreeDeciduous20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.52 3.52 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2ZM9 15h2v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15Z",
    fill: primaryFill
  }));
};

export const TreeDeciduous20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TreeDeciduous20FilledIcon, 'TreeDeciduous20Filled');

const TreeDeciduous20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.52 3.52 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2Zm1 13v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15h2ZM7.53 5.11a2.5 2.5 0 0 1 4.94 0c.03.22.2.39.42.42A2.5 2.5 0 0 1 14.9 8.7a.5.5 0 0 0 .25.58A2.5 2.5 0 0 1 14 14H6a2.5 2.5 0 0 1-1.15-4.72.5.5 0 0 0 .25-.58A2.5 2.5 0 0 1 7.1 5.53a.5.5 0 0 0 .42-.42Z",
    fill: primaryFill
  }));
};

export const TreeDeciduous20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TreeDeciduous20RegularIcon, 'TreeDeciduous20Regular');

const TreeEvergreen20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32l-3.31-2.6ZM9 15h2v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15Z",
    fill: primaryFill
  }));
};

export const TreeEvergreen20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TreeEvergreen20FilledIcon, 'TreeEvergreen20Filled');

const TreeEvergreen20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32l-3.31-2.6ZM11 15v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15h2ZM10 3l3.3 2.6a.5.5 0 0 1-.28.9.5.5 0 0 0-.3.88l2.09 1.73a.5.5 0 0 1-.32.89h-.76a.5.5 0 0 0-.34.86l2.45 2.3c.32.3.1.84-.34.84h-11a.49.49 0 0 1-.34-.85l2.44-2.29a.5.5 0 0 0-.34-.86H5.5a.5.5 0 0 1-.31-.89l2.1-1.73a.5.5 0 0 0-.3-.88.5.5 0 0 1-.3-.9L10 3Z",
    fill: primaryFill
  }));
};

export const TreeEvergreen20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TreeEvergreen20RegularIcon, 'TreeEvergreen20Regular');

const Triangle12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.79 1.46a.9.9 0 0 0-1.58 0L1.12 8.63A.92.92 0 0 0 1.91 10H10.09c.7 0 1.14-.76.79-1.37l-4.1-7.17Z",
    fill: primaryFill
  }));
};

export const Triangle12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle12FilledIcon, 'Triangle12Filled');

const Triangle12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.21 1.46a.9.9 0 0 1 1.58 0l4.09 7.17a.92.92 0 0 1-.79 1.37H1.91a.92.92 0 0 1-.79-1.37l4.1-7.17Zm.79.66L2.08 8.98h7.84L6 2.12Z",
    fill: primaryFill
  }));
};

export const Triangle12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle12RegularIcon, 'Triangle12Regular');

const Triangle16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.69 1.78a1.5 1.5 0 0 1 2.63 0l5.5 10A1.5 1.5 0 0 1 13.5 14h-11a1.5 1.5 0 0 1-1.31-2.22l5.5-10Z",
    fill: primaryFill
  }));
};

export const Triangle16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle16FilledIcon, 'Triangle16Filled');

const Triangle16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.69 1.78a1.5 1.5 0 0 1 2.63 0l5.5 10A1.5 1.5 0 0 1 13.5 14h-11a1.5 1.5 0 0 1-1.31-2.22l5.5-10Zm1.75.48a.5.5 0 0 0-.88 0l-5.5 10a.5.5 0 0 0 .44.74h11a.5.5 0 0 0 .44-.74l-5.5-10Z",
    fill: primaryFill
  }));
};

export const Triangle16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle16RegularIcon, 'Triangle16Regular');

const Triangle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.18 15.8c-.53 1 .2 2.2 1.32 2.2h15a1.5 1.5 0 0 0 1.32-2.22l-7.6-14a1.5 1.5 0 0 0-2.65.02l-7.4 14Z",
    fill: primaryFill
  }));
};

export const Triangle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle20FilledIcon, 'Triangle20Filled');

const Triangle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 18a1.5 1.5 0 0 1-1.32-2.2l7.4-14a1.5 1.5 0 0 1 2.64-.02l7.6 14A1.5 1.5 0 0 1 17.5 18h-15Zm-.44-1.73a.5.5 0 0 0 .44.73h15a.5.5 0 0 0 .44-.74l-7.6-14a.5.5 0 0 0-.89 0l-7.39 14Z",
    fill: primaryFill
  }));
};

export const Triangle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle20RegularIcon, 'Triangle20Regular');

const Triangle32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.85 4.68a3.25 3.25 0 0 0-5.7 0L2.4 24.18A3.25 3.25 0 0 0 5.25 29h21.5a3.25 3.25 0 0 0 2.84-4.82L18.85 4.68Z",
    fill: primaryFill
  }));
};

export const Triangle32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle32FilledIcon, 'Triangle32Filled');

const Triangle32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.15 4.68a3.25 3.25 0 0 1 5.7 0l10.74 19.5A3.25 3.25 0 0 1 26.74 29H5.25a3.25 3.25 0 0 1-2.85-4.82l10.75-19.5Zm3.95.97a1.25 1.25 0 0 0-2.2 0L4.17 25.15c-.46.83.14 1.85 1.1 1.85h21.48c.95 0 1.56-1.02 1.1-1.85L17.1 5.65Z",
    fill: primaryFill
  }));
};

export const Triangle32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle32RegularIcon, 'Triangle32Regular');

const Triangle48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.47 7.23a4.25 4.25 0 0 1 7.5.04l15.53 29.5A4.25 4.25 0 0 1 39.74 43H8.26a4.25 4.25 0 0 1-3.74-6.27l15.95-29.5Z",
    fill: primaryFill
  }));
};

export const Triangle48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle48FilledIcon, 'Triangle48Filled');

const Triangle48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.76 8.43a1.75 1.75 0 0 0-3.09-.01L6.72 37.92a1.75 1.75 0 0 0 1.54 2.58h31.48c1.32 0 2.17-1.4 1.55-2.56L25.76 8.44Zm-5.29-1.2a4.25 4.25 0 0 1 7.5.04l15.53 29.5A4.25 4.25 0 0 1 39.74 43H8.26a4.25 4.25 0 0 1-3.74-6.27l15.95-29.5Z",
    fill: primaryFill
  }));
};

export const Triangle48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Triangle48RegularIcon, 'Triangle48Regular');

const TriangleDown12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.21 10.54a.9.9 0 0 0 1.58 0l4.09-7.17A.92.92 0 0 0 10.09 2H1.91a.92.92 0 0 0-.79 1.37l4.1 7.17Z",
    fill: primaryFill
  }));
};

export const TriangleDown12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown12FilledIcon, 'TriangleDown12Filled');

const TriangleDown12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.79 10.54a.9.9 0 0 1-1.58 0L1.12 3.37A.92.92 0 0 1 1.91 2h8.18c.7 0 1.14.76.79 1.37l-4.1 7.17ZM6 9.88l3.92-6.86H2.08L6 9.88Z",
    fill: primaryFill
  }));
};

export const TriangleDown12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown12RegularIcon, 'TriangleDown12Regular');

const TriangleDown16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.31 14.22a1.5 1.5 0 0 1-2.63 0l-5.5-10A1.5 1.5 0 0 1 2.5 2h11a1.5 1.5 0 0 1 1.31 2.22l-5.5 10Z",
    fill: primaryFill
  }));
};

export const TriangleDown16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown16FilledIcon, 'TriangleDown16Filled');

const TriangleDown16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.31 14.22a1.5 1.5 0 0 1-2.63 0l-5.5-10A1.5 1.5 0 0 1 2.5 2h11a1.5 1.5 0 0 1 1.31 2.22l-5.5 10Zm-1.75-.48a.5.5 0 0 0 .88 0l5.5-10A.5.5 0 0 0 13.5 3h-11a.5.5 0 0 0-.44.74l5.5 10Z",
    fill: primaryFill
  }));
};

export const TriangleDown16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown16RegularIcon, 'TriangleDown16Regular');

const TriangleDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.76 4.93A2 2 0 0 0 17 2H3a2 2 0 0 0-1.76 2.93l7 13.02a2 2 0 0 0 3.53 0l7-13.02Z",
    fill: primaryFill
  }));
};

export const TriangleDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown20FilledIcon, 'TriangleDown20Filled');

const TriangleDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.88 4.46A1 1 0 0 0 17 3H3a1 1 0 0 0-.87 1.46l7 13.02a1 1 0 0 0 1.75 0l7-13.02ZM17 2a2 2 0 0 1 1.76 2.93l-7 13.02a2 2 0 0 1-3.52 0l-7-13.02A2 2 0 0 1 3.01 2H17Z",
    fill: primaryFill
  }));
};

export const TriangleDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown20RegularIcon, 'TriangleDown20Regular');

const TriangleDown32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.15 27.32a3.25 3.25 0 0 0 5.7 0l10.74-19.5A3.25 3.25 0 0 0 26.75 3H5.25a3.25 3.25 0 0 0-2.84 4.82l10.74 19.5Z",
    fill: primaryFill
  }));
};

export const TriangleDown32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown32FilledIcon, 'TriangleDown32Filled');

const TriangleDown32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.84 27.32 29.6 7.82A3.25 3.25 0 0 0 26.75 3H5.25a3.25 3.25 0 0 0-2.84 4.82l10.74 19.5a3.25 3.25 0 0 0 5.7 0Zm-3.94-.97L4.16 6.85A1.25 1.25 0 0 1 5.26 5h21.49c.95 0 1.55 1.02 1.1 1.86l-10.76 19.5c-.47.86-1.71.86-2.19 0Z",
    fill: primaryFill
  }));
};

export const TriangleDown32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown32RegularIcon, 'TriangleDown32Regular');

const TriangleDown48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M27.53 40.77a4.25 4.25 0 0 1-7.5-.04L4.5 11.23A4.25 4.25 0 0 1 8.26 5h31.48a4.25 4.25 0 0 1 3.74 6.27l-15.95 29.5Z",
    fill: primaryFill
  }));
};

export const TriangleDown48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown48FilledIcon, 'TriangleDown48Filled');

const TriangleDown48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.24 39.57a1.75 1.75 0 0 0 3.09.01l15.95-29.5a1.75 1.75 0 0 0-1.54-2.58H8.26a1.75 1.75 0 0 0-1.55 2.56l15.53 29.5Zm5.29 1.2a4.25 4.25 0 0 1-7.5-.04L4.5 11.23A4.25 4.25 0 0 1 8.26 5h31.48a4.25 4.25 0 0 1 3.74 6.27l-15.95 29.5Z",
    fill: primaryFill
  }));
};

export const TriangleDown48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleDown48RegularIcon, 'TriangleDown48Regular');

const TriangleLeft12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.46 5.21a.9.9 0 0 0 0 1.58l7.17 4.09a.92.92 0 0 0 1.37-.79V1.91a.92.92 0 0 0-1.37-.79l-7.17 4.1Z",
    fill: primaryFill
  }));
};

export const TriangleLeft12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft12FilledIcon, 'TriangleLeft12Filled');

const TriangleLeft12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.46 6.79a.9.9 0 0 1 0-1.58l7.17-4.09a.92.92 0 0 1 1.37.79v8.18a.92.92 0 0 1-1.37.79l-7.17-4.1ZM2.12 6l6.86 3.92V2.08L2.12 6Z",
    fill: primaryFill
  }));
};

export const TriangleLeft12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft12RegularIcon, 'TriangleLeft12Regular');

const TriangleLeft16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.78 9.31a1.5 1.5 0 0 1 0-2.63l10-5.5c1-.54 2.22.18 2.22 1.32v11a1.5 1.5 0 0 1-2.22 1.31l-10-5.5Z",
    fill: primaryFill
  }));
};

export const TriangleLeft16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft16FilledIcon, 'TriangleLeft16Filled');

const TriangleLeft16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.78 9.31a1.5 1.5 0 0 1 0-2.63l10-5.5c1-.54 2.22.18 2.22 1.32v11a1.5 1.5 0 0 1-2.22 1.31l-10-5.5Zm.48-1.75a.5.5 0 0 0 0 .88l10 5.5a.5.5 0 0 0 .74-.44v-11a.5.5 0 0 0-.74-.44l-10 5.5Z",
    fill: primaryFill
  }));
};

export const TriangleLeft16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft16RegularIcon, 'TriangleLeft16Regular');

const TriangleLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.07 18.76A2 2 0 0 0 18 17V3a2 2 0 0 0-2.93-1.76l-13.02 7a2 2 0 0 0 0 3.52l13.02 7Z",
    fill: primaryFill
  }));
};

export const TriangleLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft20FilledIcon, 'TriangleLeft20Filled');

const TriangleLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.54 17.88A1 1 0 0 0 17 17V3a1 1 0 0 0-1.46-.88l-13.02 7a1 1 0 0 0 0 1.76l13.02 7ZM18 17a2 2 0 0 1-2.93 1.76l-13.02-7a2 2 0 0 1 0-3.52l13.02-7A2 2 0 0 1 18 3.01V17Z",
    fill: primaryFill
  }));
};

export const TriangleLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft20RegularIcon, 'TriangleLeft20Regular');

const TriangleLeft32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.68 13.15a3.25 3.25 0 0 0 0 5.7l19.5 10.74A3.25 3.25 0 0 0 29 26.75V5.25a3.25 3.25 0 0 0-4.82-2.84L4.68 13.15Z",
    fill: primaryFill
  }));
};

export const TriangleLeft32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft32FilledIcon, 'TriangleLeft32Filled');

const TriangleLeft32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.68 18.84a3.25 3.25 0 0 1 0-5.69l19.5-10.74A3.25 3.25 0 0 1 29 5.25v21.5a3.25 3.25 0 0 1-4.82 2.84L4.68 18.84Zm.97-3.94a1.25 1.25 0 0 0 0 2.2l19.5 10.74c.83.46 1.85-.14 1.85-1.1V5.26c0-.95-1.02-1.55-1.85-1.09L5.65 14.9Z",
    fill: primaryFill
  }));
};

export const TriangleLeft32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft32RegularIcon, 'TriangleLeft32Regular');

const TriangleLeft48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.23 27.53a4.25 4.25 0 0 1 .04-7.5L36.77 4.5A4.25 4.25 0 0 1 43 8.26v31.48a4.25 4.25 0 0 1-6.27 3.74L7.23 27.53Z",
    fill: primaryFill
  }));
};

export const TriangleLeft48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft48FilledIcon, 'TriangleLeft48Filled');

const TriangleLeft48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.43 22.24a1.75 1.75 0 0 0-.01 3.09l29.5 15.95a1.75 1.75 0 0 0 2.58-1.54V8.26c0-1.32-1.4-2.17-2.56-1.55L8.44 22.24Zm-1.2 5.29a4.25 4.25 0 0 1 .04-7.5L36.77 4.5A4.25 4.25 0 0 1 43 8.26v31.48a4.25 4.25 0 0 1-6.27 3.74L7.23 27.53Z",
    fill: primaryFill
  }));
};

export const TriangleLeft48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleLeft48RegularIcon, 'TriangleLeft48Regular');

const TriangleRight12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.54 6.79a.9.9 0 0 0 0-1.58L3.37 1.12A.92.92 0 0 0 2 1.91V10.09c0 .7.76 1.14 1.37.79l7.17-4.1Z",
    fill: primaryFill
  }));
};

export const TriangleRight12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight12FilledIcon, 'TriangleRight12Filled');

const TriangleRight12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.54 5.21a.9.9 0 0 1 0 1.58l-7.17 4.09A.92.92 0 0 1 2 10.09V1.91c0-.7.76-1.14 1.37-.79l7.17 4.1ZM9.88 6 3.02 2.08v7.84L9.88 6Z",
    fill: primaryFill
  }));
};

export const TriangleRight12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight12RegularIcon, 'TriangleRight12Regular');

const TriangleRight16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.22 6.69a1.5 1.5 0 0 1 0 2.63l-10 5.5A1.5 1.5 0 0 1 2 13.5v-11A1.5 1.5 0 0 1 4.22 1.2l10 5.5Z",
    fill: primaryFill
  }));
};

export const TriangleRight16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight16FilledIcon, 'TriangleRight16Filled');

const TriangleRight16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.22 6.69a1.5 1.5 0 0 1 0 2.63l-10 5.5A1.5 1.5 0 0 1 2 13.5v-11A1.5 1.5 0 0 1 4.22 1.2l10 5.5Zm-.48 1.75a.5.5 0 0 0 0-.88l-10-5.5A.5.5 0 0 0 3 2.5v11c0 .38.4.62.74.44l10-5.5Z",
    fill: primaryFill
  }));
};

export const TriangleRight16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight16RegularIcon, 'TriangleRight16Regular');

const TriangleRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.93 1.24A2 2 0 0 0 2 3v14a2 2 0 0 0 2.93 1.76l13.02-7a2 2 0 0 0 0-3.52l-13.02-7Z",
    fill: primaryFill
  }));
};

export const TriangleRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight20FilledIcon, 'TriangleRight20Filled');

const TriangleRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.46 2.12A1 1 0 0 0 3 3v14a1 1 0 0 0 1.46.88l13.02-7a1 1 0 0 0 0-1.76l-13.02-7ZM2 3a2 2 0 0 1 2.93-1.76l13.02 7a2 2 0 0 1 0 3.52l-13.02 7A2 2 0 0 1 2 16.99V3Z",
    fill: primaryFill
  }));
};

export const TriangleRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight20RegularIcon, 'TriangleRight20Regular');

const TriangleRight32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M27.32 18.85a3.25 3.25 0 0 0 0-5.7L7.82 2.4A3.25 3.25 0 0 0 3 5.25v21.5a3.25 3.25 0 0 0 4.82 2.84l19.5-10.74Z",
    fill: primaryFill
  }));
};

export const TriangleRight32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight32FilledIcon, 'TriangleRight32Filled');

const TriangleRight32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M27.32 13.15a3.25 3.25 0 0 1 0 5.7L7.82 29.59A3.25 3.25 0 0 1 3 26.74V5.25A3.25 3.25 0 0 1 7.82 2.4l19.5 10.75Zm-.97 3.94c.86-.47.86-1.71 0-2.19L6.85 4.16A1.25 1.25 0 0 0 5 5.25v21.5c0 .94 1.02 1.55 1.85 1.09l19.5-10.75Z",
    fill: primaryFill
  }));
};

export const TriangleRight32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight32RegularIcon, 'TriangleRight32Regular');

const TriangleRight48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.77 20.47a4.25 4.25 0 0 1-.04 7.5L11.23 43.5A4.25 4.25 0 0 1 5 39.74V8.26a4.25 4.25 0 0 1 6.27-3.74l29.5 15.95Z",
    fill: primaryFill
  }));
};

export const TriangleRight48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight48FilledIcon, 'TriangleRight48Filled');

const TriangleRight48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.57 25.76a1.75 1.75 0 0 0 .01-3.09L10.08 6.72A1.75 1.75 0 0 0 7.5 8.26v31.48c0 1.32 1.4 2.17 2.57 1.55l29.5-15.53Zm1.2-5.29a4.25 4.25 0 0 1-.04 7.5L11.23 43.5A4.25 4.25 0 0 1 5 39.74V8.26a4.25 4.25 0 0 1 6.27-3.74l29.5 15.95Z",
    fill: primaryFill
  }));
};

export const TriangleRight48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TriangleRight48RegularIcon, 'TriangleRight48Regular');

const Trophy16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03a4 4 0 0 0 3.38-3A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm8 1h.5c.28 0 .5.22.5.5v1c0 .65-.42 1.2-1 1.41V4ZM4 4v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5H4Z",
    fill: primaryFill
  }));
};

export const Trophy16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy16FilledIcon, 'Trophy16Filled');

const Trophy16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47 4 4 0 0 1-3.38 3V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3H4Zm7 0a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 6 .07V3Zm1 3.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5H12v2.91ZM4 4h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41V4Zm1 10h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const Trophy16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy16RegularIcon, 'Trophy16Regular');

const Trophy20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97 4.5 4.5 0 0 1-3.9 3.5v1.5h2a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4h1Zm9 4.94A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1v3.94ZM5.5 5h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93V5Z",
    fill: primaryFill
  }));
};

export const Trophy20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy20FilledIcon, 'Trophy20Filled');

const Trophy20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5a4.5 4.5 0 0 0 3.9-3.5A3 3 0 0 0 17 7V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5V7Zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5Zm10 0h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94V5Zm-1-1v5a3.5 3.5 0 0 1-7 .16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Zm-7 12.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1h-7Z",
    fill: primaryFill
  }));
};

export const Trophy20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy20RegularIcon, 'Trophy20Regular');

const Trophy24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.76 5.76 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7Zm3.5 3.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5Z",
    fill: primaryFill
  }));
};

export const Trophy24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy24FilledIcon, 'Trophy24Filled');

const Trophy24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.76 5.76 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7Zm-1 17h-5c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19h-.16Zm1-15.5h-7a.75.75 0 0 0-.75.75v6a4.25 4.25 0 0 0 8.5 0v-6a.75.75 0 0 0-.75-.75Zm3.5 2H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5Z",
    fill: primaryFill
  }));
};

export const Trophy24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy24RegularIcon, 'Trophy24Regular');

const Trophy28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.76 6.76 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5Zm13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99Z",
    fill: primaryFill
  }));
};

export const Trophy28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy28FilledIcon, 'Trophy28Filled');

const Trophy28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.76 6.76 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5Zm13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99ZM9.75 3.5c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 1 0 10.5 0v-7.5c0-.69-.56-1.25-1.25-1.25h-8ZM8.5 24.25v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75Z",
    fill: primaryFill
  }));
};

export const Trophy28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy28RegularIcon, 'Trophy28Regular');

const Trophy32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45ZM8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8Z",
    fill: primaryFill
  }));
};

export const Trophy32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy32FilledIcon, 'Trophy32Filled');

const Trophy32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8v6.95ZM10 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a6 6 0 0 1-12 0V5Zm0 22.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v.5H10v-.5Z",
    fill: primaryFill
  }));
};

export const Trophy32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy32RegularIcon, 'Trophy32Regular');

const Trophy48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12.01 12.01 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26Zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm24 10.91c2-.4 3.5-2.17 3.5-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91Z",
    fill: primaryFill
  }));
};

export const Trophy48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy48FilledIcon, 'Trophy48Filled');

const Trophy48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm.37 13.48A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12.01 12.01 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96ZM36 21.41c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM14.5 8.25V21a9.5 9.5 0 0 0 19 0V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75Zm0 33.25h19A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5Z",
    fill: primaryFill
  }));
};

export const Trophy48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Trophy48RegularIcon, 'Trophy48Regular');

const TrophyLock16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h3.77A2 2 0 0 1 8 14v-4a2 2 0 0 1 1.5-1.94V8A3 3 0 0 1 12 5.04V4h.5c.28 0 .5.22.5.5v.54c.36.06.7.19 1 .36v-.9c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm0 1v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5H4Zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0Zm1 1V8a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const TrophyLock16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock16FilledIcon, 'TrophyLock16Filled');

const TrophyLock16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v.9c-.3-.17-.64-.3-1-.36V4.5a.5.5 0 0 0-.5-.5H12v1.04c-.36.06-.7.19-1 .36V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3v3H6a1 1 0 0 0-1 1h3c0 .37.1.71.27 1H4.5a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3H4Zm0 1h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41V4Zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0Zm1 1V8a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const TrophyLock16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock16RegularIcon, 'TrophyLock16Regular');

const TrophyLock20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7c0 .45-.1.88-.28 1.26-.3-.14-.64-.23-1-.25.18-.3.28-.64.28-1V5.5a.5.5 0 0 0-.5-.5h-1v3.17a3 3 0 0 0-2 2.83v.06A2 2 0 0 0 11 13v.39c-.16.04-.33.06-.5.08v1.5h.5V17c0 .35.1.68.25.97H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4h1Zm0 1h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93V5Zm8 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const TrophyLock20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock20FilledIcon, 'TrophyLock20Filled');

const TrophyLock20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h5.25A2 2 0 0 1 11 17v-.03H6.5a1 1 0 0 1 1-1H11v-1h-.5v-1.5c.17-.02.34-.04.5-.08V13a2 2 0 0 1 .12-.68A3.5 3.5 0 0 1 6.5 9.16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.76a3 3 0 0 1 1-.59V5h1c.27 0 .5.22.5.5V7c0 .37-.1.71-.27 1 .35.03.68.12 1 .26.17-.38.27-.8.27-1.26V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5V7Zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5Zm9 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const TrophyLock20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock20RegularIcon, 'TrophyLock20Regular');

const TrophyLock24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15c0 .43-.08.85-.23 1.23a3.48 3.48 0 0 0-1.44-.46c.1-.2.15-.4.17-.62V5.75a.25.25 0 0 0-.18-.24l-.06-.01H17.5v4.14A3.5 3.5 0 0 0 15 13v.05a2.5 2.5 0 0 0-2 2.45v.36a5.7 5.7 0 0 1-.5.1v1.54h.5v3c0 .56.19 1.08.5 1.5H6.75a.75.75 0 0 1-.74-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5ZM16 14v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5Zm1.5-1v1h2v-1a1 1 0 1 0-2 0Zm2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock24FilledIcon, 'TrophyLock24Filled');

const TrophyLock24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.49 4a2.25 2.25 0 0 0-2.24-2h-7c-1.16 0-2.11.88-2.24 2H4.75C3.78 4 3 4.78 3 5.75v3C3 10.55 4.45 12 6.25 12h.02A5.76 5.76 0 0 0 11 15.95v1.55H9.07A3.25 3.25 0 0 0 6 20.76v.6c.06.37.37.65.75.65h6.75c-.31-.42-.5-.94-.5-1.5H7.52l.03-.15c.18-.77.87-1.35 1.7-1.35H13v-1.5h-.5v-1.55c.17-.02.34-.05.5-.09v-.36c0-.49.14-.94.38-1.32a4.24 4.24 0 0 1-5.88-3.93v-6c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75v6.3a3.5 3.5 0 0 1 1.5-.9V5.5h1.31c.12.03.2.13.2.25V8.9c-.03.22-.09.43-.18.62.52.04 1 .2 1.44.46.15-.38.24-.8.24-1.23V5.61C20.42 4.7 19.67 4 18.75 4h-1.27ZM4.75 5.5H6v4.98a1.75 1.75 0 0 1-1.5-1.73v-3c0-.14.1-.25.25-.25Zm13.75 5A2.5 2.5 0 0 0 16 13v1h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-2.5-2.5Zm0 1.5a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 1-1Zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const TrophyLock24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock24RegularIcon, 'TrophyLock24Regular');

const TrophyLock28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a3.99 3.99 0 0 0-1.48-.78A2.75 2.75 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12a4 4 0 0 0-4 4v.04A3 3 0 0 0 14 19v5c0 .77.29 1.47.76 2H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5ZM17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5Zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0Zm3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock28FilledIcon, 'TrophyLock28Filled');

const TrophyLock28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a3.99 3.99 0 0 0-1.48-.78A2.75 2.75 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12c-.53 0-1.04.1-1.5.3V4.74c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 0 0 5.93 5.2c-.27.46-.43.99-.43 1.55v3.5h-3.75c-.97 0-1.75.78-1.75 1.75v.25h5.54c.1.57.35 1.09.72 1.5H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5ZM17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5Zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0Zm3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock28RegularIcon, 'TrophyLock28Regular');

const TrophyLock32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3c-.2-.46-.3-.97-.3-1.5v-6a4 4 0 0 1 3.08-3.9 5 5 0 0 1 6.87-3.7A4.49 4.49 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45ZM8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8Zm13 13v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5Zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0Zm3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock32FilledIcon, 'TrophyLock32Filled');

const TrophyLock32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3c-.2-.46-.3-.97-.3-1.5V28H10v-.5c0-.83.67-1.5 1.5-1.5h5v-3.5c0-1.04.4-2 1.05-2.7A6 6 0 0 1 10 14V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9c0 .43-.04.84-.13 1.25a4.98 4.98 0 0 1 4.58-.35A4.49 4.49 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8v6.95ZM21 20v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5Zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0Zm3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock32RegularIcon, 'TrophyLock32Regular');

const TrophyLock48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a6.98 6.98 0 0 0-9.41 5.64A5 5 0 0 0 26 32.83c-.25.05-.5.08-.75.1v3.57H26V43c0 .34.03.68.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26Zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm24 10.91c2-.4 3.5-2.17 3.5-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3h1Zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0Zm5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock48FilledIcon, 'TrophyLock48Filled');

const TrophyLock48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm.37 13.48A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a6.98 6.98 0 0 0-6.2.62c.15-.66.23-1.36.23-2.07V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75V21a9.5 9.5 0 0 0 12.48 9.02 4.98 4.98 0 0 0-.98 2.81c-.25.05-.5.08-.75.1v3.57H26V39h-9a2.5 2.5 0 0 0-2.5 2.5H26V43c0 .34.03.68.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96ZM36 21.41c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3h1Zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0Zm5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
    fill: primaryFill
  }));
};

export const TrophyLock48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyLock48RegularIcon, 'TrophyLock48Regular');

const TrophyOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m9.84 10.55 4.3 4.3a.5.5 0 0 0 .71-.7l-13-13a.5.5 0 1 0-.7.7L2.59 3.3c-.36.28-.6.71-.6 1.2v1a2.5 2.5 0 0 0 2.13 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03c.48-.06.93-.2 1.34-.42ZM3.32 4.03l.68.68v2.2c-.58-.2-1-.76-1-1.41v-1c0-.22.13-.4.32-.47Zm8.56 3.94c-.11.45-.3.87-.55 1.24L4.22 2.1A2 2 0 0 1 6 1h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47ZM12 4v2.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5H12Z",
    fill: primaryFill
  }));
};

export const TrophyOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff16FilledIcon, 'TrophyOff16Filled');

const TrophyOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.32 4.03A.5.5 0 0 0 3 4.5v1c0 .65.42 1.2 1 1.41v-2.2l-.68-.68ZM2.6 3.3 1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7l-4.3-4.3c-.42.21-.87.36-1.35.42V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1c0-.49.23-.92.6-1.2Zm6.5 6.5-4.1-4.1V7a3 3 0 0 0 4.1 2.8Zm1.9-2.73c0 .51-.14 1-.38 1.41l.72.73c.25-.37.44-.8.55-1.24A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-1.78 1.1l.79.78A1 1 0 0 1 6 2h4a1 1 0 0 1 1 1v4.07Zm1-.16V4h.5c.29 0 .5.22.5.5v1c0 .65-.4 1.2-1 1.41ZM5 14h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const TrophyOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff16RegularIcon, 'TrophyOff16Regular');

const TrophyOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5c.6-.07 1.19-.26 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7l-15-15ZM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5c0-.22.13-.4.32-.47L5.5 6.21Zm8.9 3.76a4.48 4.48 0 0 1-.7 1.6L5.57 3.46A2 2 0 0 1 7.5 2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97Zm.1-1.03A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1v3.94Z",
    fill: primaryFill
  }));
};

export const TrophyOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff20FilledIcon, 'TrophyOff20Filled');

const TrophyOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5c.6-.07 1.19-.26 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7l-15-15Zm8.62 10.03A3.5 3.5 0 0 1 6.5 9.16V7.2l4.97 4.97ZM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5c0-.22.13-.4.32-.47L5.5 6.21Zm8 2.79c0 .68-.2 1.31-.53 1.85l.72.72c.33-.47.58-1.01.7-1.6A3 3 0 0 0 17 7V5.5c0-.83-.67-1.5-1.5-1.5h-.99a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.92 1.46l.92.92V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5Zm1-4h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94V5Zm-8 11.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1h-7Z",
    fill: primaryFill
  }));
};

export const TrophyOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff20RegularIcon, 'TrophyOff20Regular');

const TrophyOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39c-.56.28-1.18.48-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2ZM6 7.06 4.54 5.6a.25.25 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73V7.06ZM17.23 12c-.16.5-.38.96-.66 1.39L6.3 3.12A2.25 2.25 0 0 1 8.25 2h7c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01Zm1.53-6.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01Z",
    fill: primaryFill
  }));
};

export const TrophyOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff24FilledIcon, 'TrophyOff24Filled');

const TrophyOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39c-.56.28-1.18.48-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2Zm9.71 9.71L7.5 8.56v1.69a4.25 4.25 0 0 0 5.69 4ZM6 7.06 4.54 5.6a.25.25 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73V7.06Zm10 3.19c0 .74-.19 1.44-.52 2.05l1.1 1.09c.27-.43.5-.9.65-1.39h.21a3.25 3.25 0 0 0 3.07-3.25V5.61C20.42 4.7 19.67 4 18.75 4h-1.27a2.25 2.25 0 0 0-2.24-2h-7c-.83 0-1.56.45-1.95 1.12l1.2 1.2v-.07c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75v6ZM9.25 19c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19H9.25Zm9.5-13.5h.07c.1.03.19.13.19.25V8.9c-.08.82-.7 1.47-1.5 1.58V5.5h1.25Z",
    fill: primaryFill
  }));
};

export const TrophyOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff24RegularIcon, 'TrophyOff24Regular');

const TrophyOff28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a6.7 6.7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61ZM7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06Zm.12-4.12L19.3 16.11c.44-.63.78-1.35.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94Zm13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74Z",
    fill: primaryFill
  }));
};

export const TrophyOff28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff28FilledIcon, 'TrophyOff28Filled');

const TrophyOff28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a6.7 6.7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61Zm11.88 11.88L8.5 9.56v2.69a5.25 5.25 0 0 0 7.46 4.77ZM7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06Zm.12-4.12L8.5 5.32v-.57c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v7.5c0 1.02-.3 1.97-.8 2.78l1.09 1.08c.44-.63.78-1.35.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94Zm13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74Zm-12 11.76v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75Z",
    fill: primaryFill
  }));
};

export const TrophyOff28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff28RegularIcon, 'TrophyOff28Regular');

const TrophyOff32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6c-.83.42-1.73.7-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4c0-.59.2-1.12.54-1.55ZM8 9.41l-2-2a.5.5 0 0 0 0 .09v4a2.5 2.5 0 0 0 2 2.45V9.41ZM23.75 16c-.27 1.05-.74 2.01-1.38 2.85L8.04 4.5A3 3 0 0 1 11 2h10a3 3 0 0 1 3 3h1.5A2.5 2.5 0 0 1 28 7.5v4a4.5 4.5 0 0 1-4.25 4.5Zm.25-2.04a2.5 2.5 0 0 0 2-2.45v-4a.5.5 0 0 0-.5-.5H24v6.95Z",
    fill: primaryFill
  }));
};

export const TrophyOff32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff32FilledIcon, 'TrophyOff32Filled');

const TrophyOff32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6c-.83.42-1.73.7-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4c0-.59.2-1.12.54-1.55ZM18.18 19.6 10 11.41V14a6 6 0 0 0 8.18 5.6ZM8 9.41l-2-2a.5.5 0 0 0 0 .09v4a2.5 2.5 0 0 0 2 2.45V9.41ZM22 14c0 1.26-.4 2.44-1.06 3.4l1.43 1.44c.64-.84 1.11-1.8 1.38-2.85A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11a3 3 0 0 0-2.96 2.5L10 6.46V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9Zm2-7h1.5c.27 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM10 27.5v.5h12v-.5c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5Z",
    fill: primaryFill
  }));
};

export const TrophyOff32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff32RegularIcon, 'TrophyOff32Regular');

const TrophyOff48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a11.92 11.92 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37c0-.82.36-1.55.93-2.06ZM12 13.76 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.23 10 21 12 21.4V13.77Zm23.63 10.21a11.95 11.95 0 0 1-2.07 4.28L12.2 6.9A4.25 4.25 0 0 1 16.25 4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85Zm.36-2.57c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91Z",
    fill: primaryFill
  }));
};

export const TrophyOff48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff48FilledIcon, 'TrophyOff48Filled');

const TrophyOff48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a11.92 11.92 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37c0-.82.36-1.55.93-2.06ZM27.9 29.66l-13.4-13.4V21a9.5 9.5 0 0 0 13.4 8.67ZM12 13.77 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.23 10 21 12 21.4V13.77ZM33.5 21c0 2.04-.64 3.92-1.73 5.47l1.79 1.79c.95-1.26 1.66-2.7 2.07-4.28A6.88 6.88 0 0 0 42 17.12v-6.37A2.75 2.75 0 0 0 39.25 8h-3.26a4.25 4.25 0 0 0-4.24-4h-15.5a4.25 4.25 0 0 0-4.04 2.91L14.5 9.2v-.95c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75V21Zm2.5.41V10.5h3.25c.14 0 .25.11.25.25v6.38c0 2.11-1.5 3.88-3.5 4.28ZM33.5 41.5A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5h19Z",
    fill: primaryFill
  }));
};

export const TrophyOff48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TrophyOff48RegularIcon, 'TrophyOff48Regular');

const Tv16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm0 9.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const Tv16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv16FilledIcon, 'Tv16Filled');

const Tv16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4ZM3 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Zm1.5 7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    fill: primaryFill
  }));
};

export const Tv16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv16RegularIcon, 'Tv16Regular');

const Tv20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm3.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z",
    fill: primaryFill
  }));
};

export const Tv20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv20FilledIcon, 'Tv20Filled');

const Tv20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Zm1 11.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const Tv20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv20RegularIcon, 'Tv20Regular');

const Tv24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v8.5A2.75 2.75 0 0 0 4.75 18h14.5A2.75 2.75 0 0 0 22 15.25v-8.5A2.75 2.75 0 0 0 19.25 4H4.75ZM5 20.25c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const Tv24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv24FilledIcon, 'Tv24Filled');

const Tv24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v8.5A2.75 2.75 0 0 0 4.75 18h14.5A2.75 2.75 0 0 0 22 15.25v-8.5A2.75 2.75 0 0 0 19.25 4H4.75ZM3.5 6.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-8.5ZM5.75 19.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5H5.75Z",
    fill: primaryFill
  }));
};

export const Tv24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv24RegularIcon, 'Tv24Regular');

const Tv28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h17.5c1.8 0 3.25-1.45 3.25-3.25V7.25C26 5.45 24.55 4 22.75 4H5.25ZM6 23.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const Tv28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv28FilledIcon, 'Tv28Filled');

const Tv28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h17.5c1.8 0 3.25-1.45 3.25-3.25V7.25C26 5.45 24.55 4 22.75 4H5.25ZM3.5 7.25c0-.97.79-1.75 1.75-1.75h17.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75H5.25c-.96 0-1.75-.78-1.75-1.75V7.25ZM6.75 23a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H6.75Z",
    fill: primaryFill
  }));
};

export const Tv28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv28RegularIcon, 'Tv28Regular');

const Tv48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 12.75A4.75 4.75 0 0 1 8.75 8h30.5A4.75 4.75 0 0 1 44 12.75v18.5A4.75 4.75 0 0 1 39.25 36H8.75A4.75 4.75 0 0 1 4 31.25v-18.5Zm7.25 26.75a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5h-25.5Z",
    fill: primaryFill
  }));
};

export const Tv48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv48FilledIcon, 'Tv48Filled');

const Tv48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 8A4.75 4.75 0 0 0 4 12.75v18.5A4.75 4.75 0 0 0 8.75 36h30.5A4.75 4.75 0 0 0 44 31.25v-18.5A4.75 4.75 0 0 0 39.25 8H8.75ZM6.5 12.75c0-1.24 1-2.25 2.25-2.25h30.5c1.24 0 2.25 1 2.25 2.25v18.5c0 1.24-1 2.25-2.25 2.25H8.75c-1.24 0-2.25-1-2.25-2.25v-18.5Zm4.75 26.75a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5h-25.5Z",
    fill: primaryFill
  }));
};

export const Tv48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Tv48RegularIcon, 'Tv48Regular');

const TvArrowRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2ZM14.5 11c1.33 0 2.55-.47 3.5-1.26V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5.2a5.5 5.5 0 0 0 5.3 7Zm-9 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z",
    fill: primaryFill
  }));
};

export const TvArrowRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvArrowRight20FilledIcon, 'TvArrowRight20Filled');

const TvArrowRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2ZM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5.2c-.08.32-.15.66-.18 1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1ZM5 16.5c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const TvArrowRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvArrowRight20RegularIcon, 'TvArrowRight20Regular');

const TvUsb16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4.03a2 2 0 0 1-.03-.33V8c0-.65.42-1.2 1-1.41V5.5c0-.83.67-1.5 1.5-1.5h3c.08 0 .16 0 .24.02A2 2 0 0 0 12 3H4Zm.5 9h4l.75 1H4.5a.5.5 0 0 1 0-1Zm6 1-1.3-1.73a1 1 0 0 1-.2-.6V8c0-.28.22-.5.5-.5h.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2h.5c.28 0 .5.22.5.5v2.67a1 1 0 0 1-.2.6L13.5 13v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V13Zm.5-7v1.5h2V6h-2Z",
    fill: primaryFill
  }));
};

export const TvUsb16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb16FilledIcon, 'TvUsb16Filled');

const TvUsb16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4.03a2 2 0 0 1-.03-.33V10H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9.5c.08 0 .16 0 .24.02A2 2 0 0 0 12 3H4Zm.5 9h4l.75 1H4.5a.5.5 0 0 1 0-1Zm6 1-1.3-1.73a1 1 0 0 1-.2-.6V8c0-.28.22-.5.5-.5h.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2h.5c.28 0 .5.22.5.5v2.67a1 1 0 0 1-.2.6L13.5 13v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V13Zm.5-7v1.5h2V6h-2Z",
    fill: primaryFill
  }));
};

export const TvUsb16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb16RegularIcon, 'TvUsb16Regular');

const TvUsb20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v1.27A2 2 0 0 0 17 7h-2a2 2 0 0 0-2 2v1.27A2 2 0 0 0 12 12v2.18a2 2 0 0 0 .18.82H4a2 2 0 0 1-2-2V6Zm15 2a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v2.2a1 1 0 0 1-.2.6l-1.3 1.8V18a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.4l-1.31-1.84a1 1 0 0 1-.19-.58V12a1 1 0 0 1 1-1V9a1 1 0 0 1 1-1h2Zm0 3V9h-2v2h2Zm-3.5 5.91-.66-.91H5.5a.5.5 0 0 0 0 1h8v-.09Zm-.31-2.15-.34.24Z",
    fill: primaryFill
  }));
};

export const TvUsb20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb20FilledIcon, 'TvUsb20Filled');

const TvUsb20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v1.27A2 2 0 0 0 17 7V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8v.18a2 2 0 0 0 .18.82H4a2 2 0 0 1-2-2V6Zm11.5 10.91-.66-.91H5.5a.5.5 0 0 0 0 1h8v-.09ZM14 9v2a1 1 0 0 0-1 1v2.18c0 .2.07.41.19.58l1.31 1.83V18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.4l1.3-1.8a1 1 0 0 0 .2-.6V12a1 1 0 0 0-1-1V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1Zm3 2h-2V9h2v2Z",
    fill: primaryFill
  }));
};

export const TvUsb20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb20RegularIcon, 'TvUsb20Regular');

const TvUsb24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 0 0 2 5.75v8.5A2.75 2.75 0 0 0 4.75 17h9.75v-3c0-.82.4-1.54 1-2v-1A2.5 2.5 0 0 1 18 8.5h3c.36 0 .7.07 1 .2V5.76A2.75 2.75 0 0 0 19.25 3H4.75Zm1 15.5h9l.16.28.8 1.22H5.75a.75.75 0 0 1 0-1.5ZM17.5 20l-1.34-2.04a1 1 0 0 1-.16-.55V14a1 1 0 0 1 1-1v-2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v3.44a1 1 0 0 1-.17.55L21.5 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm1-8.5V13h2v-1.5h-2Z",
    fill: primaryFill
  }));
};

export const TvUsb24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb24FilledIcon, 'TvUsb24Filled');

const TvUsb24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 0 0 2 5.75v8.5A2.75 2.75 0 0 0 4.75 17h9.75v-1.5H4.75c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25V8.5h.5c.36 0 .7.07 1 .2V5.76A2.75 2.75 0 0 0 19.25 3H4.75Zm1 15.5h9l.16.28.8 1.22H5.75a.75.75 0 0 1 0-1.5ZM17.5 20l-1.34-2.04a1 1 0 0 1-.16-.55V14a1 1 0 0 1 1-1v-2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v3.44a1 1 0 0 1-.17.55L21.5 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm3-8.5h-2V13h2v-1.5Z",
    fill: primaryFill
  }));
};

export const TvUsb24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb24RegularIcon, 'TvUsb24Regular');

const TvUsb28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h12.26l-.01-.26v-4.17c0-.82.4-1.54 1-2V13a2.5 2.5 0 0 1 2.5-2.5h4c.35 0 .7.07 1 .2V7.26C26 5.45 24.54 4 22.75 4H5.25Zm1.5 19H18.4l.6 1.06v.44H6.75a.75.75 0 0 1 0-1.5Zm13.75.67V26a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2.33l1.37-2.44a1 1 0 0 0 .13-.5v-4.16a1 1 0 0 0-1-1v-2.65a1 1 0 0 0-1-.92h-4a1 1 0 0 0-1 1v2.57a1 1 0 0 0-1 1v4.17a1 1 0 0 0 .13.49l1.37 2.44Zm1-10.17h3v2.07h-3V13.5Z",
    fill: primaryFill
  }));
};

export const TvUsb28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb28FilledIcon, 'TvUsb28Filled');

const TvUsb28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 4A3.25 3.25 0 0 0 2 7.25v10.5C2 19.55 3.46 21 5.25 21h12.26l-.01-.26V19.5H5.25c-.97 0-1.75-.78-1.75-1.75V7.25c0-.97.78-1.75 1.75-1.75h17.5c.96 0 1.75.78 1.75 1.75v3.25h.5c.35 0 .7.07 1 .2V7.26C26 5.45 24.54 4 22.75 4H5.25Zm1.5 19H18.4l.6 1.06v.44H6.75a.75.75 0 0 1 0-1.5Zm13.75.67V26a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2.33l1.37-2.44a1 1 0 0 0 .13-.5v-4.16a1 1 0 0 0-1-1v-2.65a1 1 0 0 0-1-.92h-4a1 1 0 0 0-1 1v2.57a1 1 0 0 0-1 1v4.17a1 1 0 0 0 .13.49l1.37 2.44Zm1-10.17h3v2.07h-3V13.5Z",
    fill: primaryFill
  }));
};

export const TvUsb28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb28RegularIcon, 'TvUsb28Regular');

const TvUsb48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 11.75A4.75 4.75 0 0 1 8.75 7h30.5A4.75 4.75 0 0 1 44 11.75v7.9a3.5 3.5 0 0 0-1-.15h-7a3.5 3.5 0 0 0-3.5 3.5v2.84a2 2 0 0 0-2 2V35H8.75A4.75 4.75 0 0 1 4 30.25v-18.5ZM11.25 41h21.8l-1.59-2.5H11.25a1.25 1.25 0 1 0 0 2.5ZM35 23v5h-1a1 1 0 0 0-1 1v6.96a1 1 0 0 0 .15.53L36 41v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4l2.85-4.5a1 1 0 0 0 .15-.54V29a1 1 0 0 0-1-1h-1v-5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1Zm2.5 1.5h4V28h-4v-3.5Z",
    fill: primaryFill
  }));
};

export const TvUsb48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb48FilledIcon, 'TvUsb48Filled');

const TvUsb48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 7A4.75 4.75 0 0 0 4 11.75v18.5A4.75 4.75 0 0 0 8.75 35H30.5v-2.5H8.75c-1.24 0-2.25-1-2.25-2.25v-18.5c0-1.24 1-2.25 2.25-2.25h30.5c1.24 0 2.25 1 2.25 2.25v7.75H43c.35 0 .68.05 1 .14v-7.89A4.75 4.75 0 0 0 39.25 7H8.75Zm2.5 31.5h20.21l1.58 2.5H11.25a1.25 1.25 0 1 1 0-2.5ZM35 23v5h-1a1 1 0 0 0-1 1v6.96a1 1 0 0 0 .15.53L36 41v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4l2.85-4.5a1 1 0 0 0 .15-.54V29a1 1 0 0 0-1-1h-1v-5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1Zm2.5 1.5h4V28h-4v-3.5Z",
    fill: primaryFill
  }));
};

export const TvUsb48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TvUsb48RegularIcon, 'TvUsb48Regular');

const Umbrella20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.51 9.13c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05a.5.5 0 0 0 .84 0l.03-.05a3.18 3.18 0 0 1 .56-.6c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05A.5.5 0 0 0 18 9.5C18 5.72 14.78 2 10 2 5.22 2 2 5.72 2 9.5a.5.5 0 0 0 .92.28l.03-.05a3.2 3.2 0 0 1 .56-.6c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05a.5.5 0 0 0 .84 0l.03-.05a3.2 3.2 0 0 1 .56-.6ZM10 9.5c-.15 0-.32.05-.5.15v6.1a1.25 1.25 0 1 1-2.5 0v-.25a.5.5 0 0 0-1 0v.25a2.25 2.25 0 0 0 4.5 0v-6.1c-.18-.1-.35-.15-.5-.15Z",
    fill: primaryFill
  }));
};

export const Umbrella20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Umbrella20FilledIcon, 'Umbrella20Filled');

const Umbrella20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.51 9.13c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05a.5.5 0 0 0 .84 0l.03-.05a3.18 3.18 0 0 1 .56-.6c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05A.5.5 0 0 0 18 9.5C18 5.72 14.78 2 10 2 5.22 2 2 5.72 2 9.5a.5.5 0 0 0 .92.28l.03-.05a3.2 3.2 0 0 1 .56-.6c.4-.34.9-.63 1.49-.63.58 0 1.1.3 1.49.63a3.88 3.88 0 0 1 .56.6l.03.05a.5.5 0 0 0 .84 0l.03-.05a3.2 3.2 0 0 1 .56-.6Zm-5.35-1A6.87 6.87 0 0 1 10 3a6.87 6.87 0 0 1 6.84 5.13A3.17 3.17 0 0 0 15 7.5c-.92 0-1.66.46-2.14.87-.14.12-.26.24-.36.35-.1-.11-.22-.23-.36-.35A3.33 3.33 0 0 0 10 7.5c-.92 0-1.66.46-2.14.87-.14.12-.26.24-.36.35-.1-.11-.22-.23-.36-.35A3.33 3.33 0 0 0 5 7.5c-.74 0-1.37.3-1.84.63ZM10 9.5c-.15 0-.32.05-.5.15v6.1a1.25 1.25 0 1 1-2.5 0v-.25a.5.5 0 0 0-1 0v.25a2.25 2.25 0 0 0 4.5 0v-6.1c-.18-.1-.35-.15-.5-.15Z",
    fill: primaryFill
  }));
};

export const Umbrella20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Umbrella20RegularIcon, 'Umbrella20Regular');

const Umbrella24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 10.91c.47-.4 1.07-.73 1.75-.73.68 0 1.28.33 1.75.73a4.6 4.6 0 0 1 .68.71l.03.05a.75.75 0 0 0 1.24 0 5.6 5.6 0 0 1 .71-.76c.48-.4 1.08-.73 1.76-.73.67 0 1.28.33 1.75.73.23.2.41.4.54.54l.17.22a.75.75 0 0 0 1.37-.42C22 6.57 17.95 2 12 2S2 6.57 2 11.25a.75.75 0 0 0 1.37.42l.17-.22c.13-.15.31-.34.54-.54.47-.4 1.08-.73 1.75-.73.68 0 1.28.33 1.76.73a4.6 4.6 0 0 1 .7.76.75.75 0 0 0 1.25 0l.03-.05a3.8 3.8 0 0 1 .68-.7Zm1.75.27c-.24 0-.49.08-.75.24V19a1.5 1.5 0 1 1-3 0v-.25a.75.75 0 0 0-1.5 0V19a3 3 0 1 0 6 0v-7.58a1.47 1.47 0 0 0-.75-.24Z",
    fill: primaryFill
  }));
};

export const Umbrella24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Umbrella24FilledIcon, 'Umbrella24Filled');

const Umbrella24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 10.91c.47-.4 1.07-.73 1.75-.73.68 0 1.28.33 1.75.73a4.6 4.6 0 0 1 .68.71l.03.05a.75.75 0 0 0 1.24 0 5.6 5.6 0 0 1 .71-.76c.48-.4 1.08-.73 1.76-.73.67 0 1.28.33 1.75.73.23.2.41.4.54.54l.17.22a.75.75 0 0 0 1.37-.42C22 6.57 17.95 2 12 2S2 6.57 2 11.25a.75.75 0 0 0 1.37.42l.17-.22c.13-.15.31-.34.54-.54.47-.4 1.08-.73 1.75-.73.68 0 1.28.33 1.76.73a4.6 4.6 0 0 1 .7.76.75.75 0 0 0 1.25 0l.03-.05a3.8 3.8 0 0 1 .68-.7ZM3.79 9.28C4.71 6.18 7.74 3.5 12 3.5c4.26 0 7.29 2.68 8.2 5.78a3.94 3.94 0 0 0-2.03-.6c-1.18 0-2.12.57-2.72 1.09a6 6 0 0 0-.37.33l-.36-.33A4.27 4.27 0 0 0 12 8.67c-1.17 0-2.11.58-2.72 1.1-.13.11-.26.22-.36.33a6 6 0 0 0-.37-.33 4.27 4.27 0 0 0-2.72-1.1c-.8 0-1.49.28-2.04.6Zm8.21 1.9c-.24 0-.49.08-.75.24V19a1.5 1.5 0 1 1-3 0v-.25a.75.75 0 0 0-1.5 0V19a3 3 0 1 0 6 0v-7.58a1.47 1.47 0 0 0-.75-.24Z",
    fill: primaryFill
  }));
};

export const Umbrella24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Umbrella24RegularIcon, 'Umbrella24Regular');

const UninstallApp20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 17A1.5 1.5 0 0 1 3 15.5v-11C3 3.67 3.67 3 4.5 3h4.75c.83 0 1.5.67 1.5 1.5v4.75h4.75c.83 0 1.5.67 1.5 1.5v4.75c0 .83-.67 1.5-1.5 1.5h-11Zm11-6.25h-4.75v4.75h4.75v-4.75Zm-6.25 0H4.5v4.75h4.75v-4.75Zm0-1.5V4.5H4.5v4.75h4.75Zm5.03-2.47a.75.75 0 1 1-1.06-1.06l1.22-1.22-1.22-1.22a.75.75 0 0 1 1.06-1.06l1.22 1.22 1.22-1.22a.75.75 0 1 1 1.06 1.06L16.56 4.5l1.22 1.22a.75.75 0 0 1-1.06 1.06L15.5 5.56l-1.22 1.22Z",
    fill: primaryFill
  }));
};

export const UninstallApp20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UninstallApp20FilledIcon, 'UninstallApp20Filled');

const UninstallApp20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 17A1.5 1.5 0 0 1 3 15.5v-11C3 3.67 3.67 3 4.5 3H9c.83 0 1.5.67 1.5 1.5v5h5c.83 0 1.5.67 1.5 1.5v4.5c0 .83-.67 1.5-1.5 1.5h-11Zm11-6.5h-5V16h5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5Zm-6 0H4v5c0 .28.22.5.5.5h5v-5.5Zm0-1v-5A.5.5 0 0 0 9 4H4.5a.5.5 0 0 0-.5.5v5h5.5Zm4.35-2.65a.5.5 0 0 1-.7-.7l1.64-1.65-1.64-1.65a.5.5 0 0 1 .7-.7l1.65 1.64 1.65-1.64a.5.5 0 0 1 .7.7L16.21 4.5l1.64 1.65a.5.5 0 0 1-.7.7L15.5 5.21l-1.65 1.64Z",
    fill: primaryFill
  }));
};

export const UninstallApp20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UninstallApp20RegularIcon, 'UninstallApp20Regular');

const UninstallApp24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m16.61 8.79.1-.08 1.79-1.8 1.8 1.8a1 1 0 0 0 1.31.08l.1-.08a1 1 0 0 0 .08-1.32l-.08-.1-1.8-1.79 1.8-1.8a1 1 0 0 0 .08-1.31l-.08-.1a1 1 0 0 0-1.32-.08l-.1.08-1.79 1.8-1.8-1.8a1 1 0 0 0-1.31-.08l-.1.08a1 1 0 0 0-.08 1.32l.08.1 1.8 1.79-1.8 1.8a1 1 0 0 0-.08 1.31l.08.1a1 1 0 0 0 1.22.15l.1-.07ZM18.5 21a2.5 2.5 0 0 0 2.5-2.5v-5a2.5 2.5 0 0 0-2.5-2.5H13V5.5A2.5 2.5 0 0 0 10.5 3h-5A2.5 2.5 0 0 0 3 5.5v13A2.5 2.5 0 0 0 5.5 21h13ZM5 11V5.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V11H5Zm6 8H5.5a.5.5 0 0 1-.5-.5V13h6v6Zm7.5 0H13v-6h5.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5Z",
    fill: primaryFill
  }));
};

export const UninstallApp24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UninstallApp24FilledIcon, 'UninstallApp24Filled');

const UninstallApp24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m21.7 8.85.08-.07a.75.75 0 0 0 .07-.98l-.07-.08-2.22-2.22 2.22-2.22a.75.75 0 0 0 .07-.97l-.07-.09a.75.75 0 0 0-.98-.07l-.08.07-2.22 2.22-2.22-2.22a.75.75 0 0 0-.98-.07l-.08.07a.75.75 0 0 0-.07.98l.07.08 2.22 2.22-2.22 2.22a.75.75 0 0 0-.07.98l.07.08c.27.27.68.3.98.07l.08-.07 2.22-2.22 2.22 2.22c.26.27.68.3.97.07ZM18.74 21c1.24 0 2.25-1 2.25-2.25V13.5c0-1.24-1-2.25-2.25-2.25h-6v-6c0-1.24-1-2.25-2.25-2.25H5.25C4.01 3 3 4 3 5.25v13.5C3 19.99 4 21 5.25 21h13.5Zm-7.5-9.75H4.5v-6c0-.41.34-.75.75-.75h5.25c.41 0 .75.34.75.75v6Zm7.5 8.25h-6v-6.75h6c.41 0 .75.34.75.75v5.25c0 .41-.34.75-.75.75Zm-7.5 0h-6a.75.75 0 0 1-.75-.75v-6h6.75v6.75Z",
    fill: primaryFill
  }));
};

export const UninstallApp24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UninstallApp24RegularIcon, 'UninstallApp24Regular');

const UsbPlug20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h.08C14.14 6 15 6.85 15 7.91v5.18c0 1.06-.86 1.91-1.92 1.91H12v2.5a.5.5 0 0 1-1 0V15H9v2.5a.5.5 0 0 1-1 0V15H6.92A1.92 1.92 0 0 1 5 13.09V7.9C5 6.85 5.86 6 6.92 6H7V2.5ZM8 6h4V3H8v3Z",
    fill: primaryFill
  }));
};

export const UsbPlug20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbPlug20FilledIcon, 'UsbPlug20Filled');

const UsbPlug20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2h5c.28 0 .5.22.5.5V6h.08C14.14 6 15 6.85 15 7.91v5.18c0 1.06-.86 1.91-1.92 1.91H12v2.5a.5.5 0 0 1-1 0V15H9v2.5a.5.5 0 0 1-1 0V15H6.92A1.92 1.92 0 0 1 5 13.09V7.9C5 6.85 5.86 6 6.92 6H7V2.5c0-.28.22-.5.5-.5Zm5.58 12c.51 0 .92-.41.92-.91V7.9c0-.5-.4-.91-.92-.91H6.92a.92.92 0 0 0-.92.91v5.18c0 .5.4.91.92.91h6.16ZM12 6V3H8v3h4Z",
    fill: primaryFill
  }));
};

export const UsbPlug20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbPlug20RegularIcon, 'UsbPlug20Regular');

const UsbPlug24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 21.25a.75.75 0 0 1-1.5.1V17h-.75c-1.19 0-2.16-.93-2.24-2.1V9.25c0-.98.63-1.82 1.5-2.13V2.75c0-.38.29-.7.65-.75h6.6c.39 0 .7.28.75.65V7.13c.82.3 1.42 1.05 1.49 1.95v5.67c0 1.2-.92 2.17-2.1 2.24l-.15.01h-.75v4.25a.75.75 0 0 1-1.5.1V17h-2v4.25ZM14.52 3.5h-5V7h5V3.5Z",
    fill: primaryFill
  }));
};

export const UsbPlug24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbPlug24FilledIcon, 'UsbPlug24Filled');

const UsbPlug24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 21.25a.75.75 0 0 1-1.5.1V17h-.75c-1.19 0-2.16-.93-2.24-2.1V9.25c0-.98.63-1.82 1.5-2.13V2.75c0-.38.29-.7.65-.75h6.6c.39 0 .7.28.75.65V7.13c.82.3 1.42 1.05 1.49 1.95v5.67c0 1.2-.92 2.17-2.1 2.24l-.15.01h-.75v4.25a.75.75 0 0 1-1.5.1V17h-2v4.25ZM15.25 8.5h-6.5c-.38 0-.69.28-.74.65v5.6c0 .38.28.7.64.74l.1.01h6.5c.38 0 .7-.28.75-.65v-5.6c0-.38-.28-.7-.64-.74l-.1-.01Zm-.73-5h-5V7h5V3.5Z",
    fill: primaryFill
  }));
};

export const UsbPlug24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbPlug24RegularIcon, 'UsbPlug24Regular');

const UsbStick20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2V2.5ZM8 6h4V3H8v3Z",
    fill: primaryFill
  }));
};

export const UsbStick20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbStick20FilledIcon, 'UsbStick20Filled');

const UsbStick20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2h5c.28 0 .5.22.5.5V6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2V2.5c0-.28.22-.5.5-.5ZM12 6V3H8v3h4ZM7 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7Z",
    fill: primaryFill
  }));
};

export const UsbStick20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbStick20RegularIcon, 'UsbStick20Regular');

const UsbStick24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.27 2c.38 0 .7.28.74.65V7.13c.82.3 1.42 1.05 1.49 1.95v10.67c0 1.2-.92 2.17-2.1 2.24l-.15.01h-6.5c-1.19 0-2.16-.93-2.24-2.1V9.25c0-.98.63-1.82 1.5-2.13V2.75c0-.38.29-.7.65-.75h6.6Zm-.75 1.5h-5V7h5V3.5Z",
    fill: primaryFill
  }));
};

export const UsbStick24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbStick24FilledIcon, 'UsbStick24Filled');

const UsbStick24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.27 2c.38 0 .7.28.74.65V7.13c.82.3 1.42 1.05 1.49 1.95v10.67c0 1.2-.92 2.17-2.1 2.24l-.15.01h-6.5c-1.19 0-2.16-.93-2.24-2.1V9.25c0-.98.63-1.82 1.5-2.13V2.75c0-.38.29-.7.65-.75h6.6Zm-.02 6.5h-6.5c-.38 0-.69.28-.74.65v10.6c0 .38.28.7.64.74l.1.01h6.5c.38 0 .7-.28.75-.65V9.25c0-.38-.28-.7-.64-.74l-.1-.01Zm-.73-5h-5V7h5V3.5Z",
    fill: primaryFill
  }));
};

export const UsbStick24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/UsbStick24RegularIcon, 'UsbStick24Regular');

const Vault16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-9-3A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5Zm3.5.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5Zm6.85 2.65a1.5 1.5 0 0 0 0-1.3l.5-.5a.5.5 0 0 0-.7-.7l-.5.5a1.5 1.5 0 0 0-1.3 0l-.5-.5a.5.5 0 1 0-.7.7l.5.5a1.5 1.5 0 0 0 0 1.3l-.5.5a.5.5 0 1 0 .7.7l.5-.5a1.5 1.5 0 0 0 1.3 0l.5.5a.5.5 0 0 0 .7-.7l-.5-.5Z",
    fill: primaryFill
  }));
};

export const Vault16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault16FilledIcon, 'Vault16Filled');

const Vault16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 6c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5Zm7 2c0 .23-.05.45-.15.65l.5.5a.5.5 0 0 1-.7.7l-.5-.5a1.5 1.5 0 0 1-1.3 0l-.5.5a.5.5 0 0 1-.7-.7l.5-.5a1.5 1.5 0 0 1 0-1.3l-.5-.5a.5.5 0 1 1 .7-.7l.5.5a1.5 1.5 0 0 1 1.3 0l.5-.5a.5.5 0 0 1 .7.7l-.5.5c.1.2.15.42.15.65Zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5ZM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-9Z",
    fill: primaryFill
  }));
};

export const Vault16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault16RegularIcon, 'Vault16Regular');

const Vault20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3.5 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm8.85.65a.5.5 0 0 0-.7 0l-.63.63a2 2 0 0 0-2.04 0l-.63-.63a.5.5 0 0 0-.7.7l.63.63a2 2 0 0 0 0 2.04l-.63.63a.5.5 0 0 0 .7.7l.63-.63a2 2 0 0 0 2.04 0l.63.63a.5.5 0 0 0 .7-.7l-.63-.63a2 2 0 0 0 0-2.04l.63-.63a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const Vault20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault20FilledIcon, 'Vault20Filled');

const Vault20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.72 11.02a2 2 0 0 0 0-2.04l.63-.63a.5.5 0 0 0-.7-.7l-.63.63a2 2 0 0 0-2.04 0l-.63-.63a.5.5 0 0 0-.7.7l.63.63a2 2 0 0 0 0 2.04l-.63.63a.5.5 0 0 0 .7.7l.63-.63a2 2 0 0 0 2.04 0l.63.63a.5.5 0 0 0 .7-.7l-.63-.63ZM12 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 7.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z",
    fill: primaryFill
  }));
};

export const Vault20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault20RegularIcon, 'Vault20Regular');

const Vault24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2 7.75A3.75 3.75 0 0 1 5.75 4h12.5A3.75 3.75 0 0 1 22 7.75v8.5A3.75 3.75 0 0 1 18.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-8.5ZM5.75 7a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 1.5 0v-8.5A.75.75 0 0 0 5.75 7Zm5.53 1.22a.75.75 0 1 0-1.06 1.06l1.2 1.2a2.99 2.99 0 0 0 0 3.04l-1.2 1.2a.75.75 0 1 0 1.06 1.06l1.2-1.2a2.99 2.99 0 0 0 3.04 0l1.2 1.2a.75.75 0 1 0 1.06-1.06l-1.2-1.2a2.99 2.99 0 0 0 0-3.04l1.2-1.2a.75.75 0 0 0-1.06-1.06l-1.2 1.2a2.99 2.99 0 0 0-3.04 0l-1.2-1.2Z",
    fill: primaryFill
  }));
};

export const Vault24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault24FilledIcon, 'Vault24Filled');

const Vault24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.58 13.52a2.99 2.99 0 0 0 0-3.04l1.2-1.2a.75.75 0 0 0-1.06-1.06l-1.2 1.2a2.99 2.99 0 0 0-3.04 0l-1.2-1.2a.75.75 0 1 0-1.06 1.06l1.2 1.2a2.99 2.99 0 0 0 0 3.04l-1.2 1.2a.75.75 0 1 0 1.06 1.06l1.2-1.2a2.99 2.99 0 0 0 3.04 0l1.2 1.2a.75.75 0 1 0 1.06-1.06l-1.2-1.2ZM14 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6.5 7.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Zm-4.5 0A3.75 3.75 0 0 1 5.75 4h12.5A3.75 3.75 0 0 1 22 7.75v8.5A3.75 3.75 0 0 1 18.25 20H5.75A3.75 3.75 0 0 1 2 16.25v-8.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v8.5c0 1.24 1 2.25 2.25 2.25h12.5c1.24 0 2.25-1 2.25-2.25v-8.5c0-1.24-1-2.25-2.25-2.25H5.75Z",
    fill: primaryFill
  }));
};

export const Vault24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Vault24RegularIcon, 'Vault24Regular');

const VehicleBicycle16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 1.5a.75.75 0 0 0 0 1.5h.9l.34 1.5H6v-.75A.75.75 0 0 0 5.25 3h-1.5a.75.75 0 0 0 0 1.5h.75v.68L4.13 7a3.25 3.25 0 1 0 3.08 1.92l3.22-2.48.17.77a3.25 3.25 0 1 0 1.5-.2l-1.12-4.93a.75.75 0 0 0-.73-.58h-1.5ZM5.61 7.3 5.86 6h2.68L6.3 7.73a3.25 3.25 0 0 0-.7-.43ZM2.5 10.25c0-.82.56-1.5 1.32-1.7l-.3 1.55a.75.75 0 0 0 1.19.74l1.25-.96A1.76 1.76 0 0 1 4.25 12c-.97 0-1.75-.78-1.75-1.75Zm8.44-1.55.33 1.47a.75.75 0 0 0 1.46-.34l-.27-1.18a1.75 1.75 0 1 1-1.52.05Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle16FilledIcon, 'VehicleBicycle16Filled');

const VehicleBicycle16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2a.5.5 0 0 0 0 1h1.12l.53 2H6V3.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1H5v1.2c0 .05 0 .1.02.15l-.56 1.69A3 3 0 1 0 7 10.2l3.5-3.93.26 1a3 3 0 1 0 .97-.26l-1.24-4.64A.5.5 0 0 0 10 2H8.5ZM4 8h.14l-.61 1.84a.5.5 0 0 0 .47.66h1.94A2 2 0 1 1 4 8Zm.7 1.5.39-1.18a2 2 0 0 1 .85 1.18H4.69Zm.71-2.15L5.86 6h3.53l-2.6 2.91a3.01 3.01 0 0 0-1.38-1.56Zm5.6.9.5 1.88a.5.5 0 0 0 .97-.26L11.98 8H12a2 2 0 1 1-.98.26Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle16RegularIcon, 'VehicleBicycle16Regular');

const VehicleBicycle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 2a.75.75 0 0 0 0 1.5h1.13l.36 2H7.25v-.75A.75.75 0 0 0 6.5 4h-2a.75.75 0 0 0 0 1.5h1.25v.7L5.4 9.02a3.75 3.75 0 1 0 4.06 3.2l3.23-4.3.24 1.32A3.75 3.75 0 1 0 14.41 9l-1.17-6.39A.75.75 0 0 0 12.5 2h-1.75Zm-3.6 5.13A.75.75 0 0 0 7.2 7h4.29l-2.69 3.58a3.76 3.76 0 0 0-1.92-1.4l.26-2.05ZM3.5 12.75c0-1.05.73-1.94 1.7-2.18L5 12.16a.75.75 0 0 0 .75.84h2.24a2.25 2.25 0 0 1-4.49-.25Zm3.1-1.25.1-.8c.37.18.7.46.92.8H6.6Zm6.61-.75.3 1.64A.75.75 0 0 0 15 12.1l-.3-1.57a2.25 2.25 0 1 1-1.48.21Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle20FilledIcon, 'VehicleBicycle20Filled');

const VehicleBicycle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2a.5.5 0 0 0 0 1h1.59l.6 3H7V4.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1H6v1.46L5.58 9H5.5A3.5 3.5 0 1 0 9 12.67l3.97-5.3.36 1.83a3.5 3.5 0 1 0 .98-.2L13 2.4a.5.5 0 0 0-.49-.4h-2ZM3 12.5A2.5 2.5 0 0 1 5.41 10l-.4 2.42a.5.5 0 0 0 .49.58h2.45A2.5 2.5 0 0 1 3 12.5Zm3.09-.5.3-1.83c.8.3 1.39.99 1.56 1.83H6.09Zm.47-2.84L6.92 7H12l-3.22 4.29a3.5 3.5 0 0 0-2.22-2.13Zm6.97 1.04.48 2.4a.5.5 0 0 0 .98-.2l-.48-2.4a2.5 2.5 0 1 1-.98.2Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle20RegularIcon, 'VehicleBicycle20Regular');

const VehicleBicycle24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 2a1 1 0 1 0 0 2h1.19l.62 3H9V6a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h2v.86l-.9 3.16a4.5 4.5 0 1 0 4.9 4.35l4.47-5.21.25 1.2A4.5 4.5 0 1 0 17.7 11l-1.71-8.2A1 1 0 0 0 15 2h-2Zm3.14 11.4.38 1.8a1 1 0 0 0 1.96-.4l-.36-1.72a2.5 2.5 0 1 1-1.98.32Zm-5.83-.3a4.52 4.52 0 0 0-2.21-1.8L8.75 9h5.08l-3.52 4.1Zm-2.76.13c.37.17.7.44.95.77H7.33l.22-.77Zm-2.08 0-.43 1.5A1 1 0 0 0 6 16h2.95a2.5 2.5 0 1 1-3.48-2.78Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle24FilledIcon, 'VehicleBicycle24Filled');

const VehicleBicycle24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.75 3a.75.75 0 0 0 0 1.5h1.43l.95 3.5H8.5V5.75A.75.75 0 0 0 7.75 5h-3a.75.75 0 0 0 0 1.5H7v2.19l-.3 1.81a4.25 4.25 0 1 0 4.3 4.06l4.65-4.65.28 1a4.25 4.25 0 1 0 1.44-.4l-1.9-6.96a.75.75 0 0 0-.72-.55h-2Zm3.58 9.4.7 2.55a.75.75 0 1 0 1.44-.4l-.7-2.55a2.75 2.75 0 1 1-1.44.4Zm-5.77.47a4.26 4.26 0 0 0-2.38-2.12l.2-1.25h5.56l-3.38 3.37Zm-2.64-.6c.72.33 1.26.96 1.48 1.73H7.64l.28-1.74Zm-1.47-.25L6 14.62a.75.75 0 0 0 .74.88H9.4a2.75 2.75 0 1 1-2.95-3.48Z",
    fill: primaryFill
  }));
};

export const VehicleBicycle24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBicycle24RegularIcon, 'VehicleBicycle24Regular');

const VehicleBus16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM4.9 1A2.9 2.9 0 0 0 2 3.9V6h-.5a.5.5 0 0 0 0 1H2v6.7c0 .72.58 1.3 1.3 1.3h1.4c.72 0 1.3-.58 1.3-1.3V13h4v.7c0 .72.58 1.3 1.3 1.3h1.4c.72 0 1.3-.58 1.3-1.3V7h.5a.5.5 0 0 0 0-1H14V3.9C14 2.3 12.7 1 11.1 1H4.9ZM13 3.9V8H3V3.9C3 2.85 3.85 2 4.9 2h6.2c1.05 0 1.9.85 1.9 1.9Zm0 9.1v.7a.3.3 0 0 1-.3.3h-1.4a.3.3 0 0 1-.3-.3V13h2Zm-8 0v.7a.3.3 0 0 1-.3.3H3.3a.3.3 0 0 1-.3-.3V13h2Zm1.5-2.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm3.75.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z",
    fill: primaryFill
  }));
};

export const VehicleBus16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus16FilledIcon, 'VehicleBus16Filled');

const VehicleBus16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm-1 7.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm3.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM2 3.9C2 2.3 3.3 1 4.9 1h6.2C12.7 1 14 2.3 14 3.9V6h.5a.5.5 0 0 1 0 1H14v6.7c0 .72-.58 1.3-1.3 1.3h-1.4a1.3 1.3 0 0 1-1.3-1.3V13H6v.7c0 .72-.58 1.3-1.3 1.3H3.3A1.3 1.3 0 0 1 2 13.7V7h-.5a.5.5 0 0 1 0-1H2V3.9Zm11 0A1.9 1.9 0 0 0 11.1 2H4.9A1.9 1.9 0 0 0 3 3.9V8h10V3.9ZM11 13v.7c0 .17.13.3.3.3h1.4a.3.3 0 0 0 .3-.3V13h-2Zm-8 0v.7c0 .17.13.3.3.3h1.4a.3.3 0 0 0 .3-.3V13H3Zm0-1h10V9H3v3Z",
    fill: primaryFill
  }));
};

export const VehicleBus16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus16RegularIcon, 'VehicleBus16Regular');

const VehicleBus20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H9ZM3 5.5A3.5 3.5 0 0 1 6.5 2h7A3.5 3.5 0 0 1 17 5.5V8h1a.5.5 0 0 1 0 1h-1v7.5c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V16H7v.5c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 3 16.5V9H2a.5.5 0 0 1 0-1h1V5.5Zm13 0A2.5 2.5 0 0 0 13.5 3h-7A2.5 2.5 0 0 0 4 5.5V10h12V5.5ZM14 16v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16h-2ZM4 16v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16H4Zm4-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleBus20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus20FilledIcon, 'VehicleBus20Filled');

const VehicleBus20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H9Zm-1 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM3 5.5A3.5 3.5 0 0 1 6.5 2h7A3.5 3.5 0 0 1 17 5.5V8h1a.5.5 0 0 1 0 1h-1v7.5c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V16H7v.5c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 3 16.5V9H2a.5.5 0 0 1 0-1h1V5.5Zm13 0A2.5 2.5 0 0 0 13.5 3h-7A2.5 2.5 0 0 0 4 5.5V10h12V5.5ZM14 16v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16h-2ZM4 16v.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16H4Zm0-1h12v-4H4v4Z",
    fill: primaryFill
  }));
};

export const VehicleBus20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus20RegularIcon, 'VehicleBus20Regular');

const VehicleBus24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5ZM4 5.75A3.75 3.75 0 0 1 7.75 2h8.5A3.75 3.75 0 0 1 20 5.75V9.5h1.23a.75.75 0 0 1 0 1.5H20v8.75c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75V18.5H9v1.25c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75V11H2.75a.75.75 0 0 1 0-1.5H4V5.75ZM16.5 18.5v1.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25V18.5h-2Zm-11 0v1.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25V18.5h-2Zm2.25-15c-1.24 0-2.25 1-2.25 2.25V12h13V5.75c0-1.24-1-2.25-2.25-2.25h-8.5ZM9 15a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleBus24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus24FilledIcon, 'VehicleBus24Filled');

const VehicleBus24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10.75 5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Zm-3-3A3.75 3.75 0 0 0 4 5.75V9.5H2.75a.75.75 0 1 0 0 1.5H4v8.75c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75V18.5h6v1.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75V11h1.23a.75.75 0 0 0 0-1.5H20V5.75A3.75 3.75 0 0 0 16.25 2h-8.5ZM18.5 18.5v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V18.5h2Zm0-1.5h-13v-4h13v4Zm-13 2.75V18.5h2v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm0-14c0-1.24 1-2.25 2.25-2.25h8.5c1.24 0 2.25 1 2.25 2.25v5.75h-13V5.75Z",
    fill: primaryFill
  }));
};

export const VehicleBus24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleBus24RegularIcon, 'VehicleBus24Regular');

const VehicleCab16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 1a.5.5 0 0 0-.5.5V2h-.68a2 2 0 0 0-1.98 1.74L3.17 5H2.5a.5.5 0 0 0 0 1h.54v.07C2.43 6.27 2 6.83 2 7.5v3c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-3a1.5 1.5 0 0 0-1.04-1.43V6h.54a.5.5 0 0 0 0-1h-.68l-.16-1.25A2 2 0 0 0 10.68 2H10v-.5a.5.5 0 0 0-.5-.5h-3Zm4.18 2a1 1 0 0 1 1 .87L11.93 6H4.05l.28-2.13A1 1 0 0 1 5.32 3h5.36ZM4.5 9A.75.75 0 1 1 6 9a.75.75 0 0 1-1.5 0ZM10 9a.75.75 0 1 1 1.5 0A.75.75 0 0 1 10 9Zm1 4h1.5v.25a.75.75 0 1 1-1.5 0V13Zm-7.5 0H5v.25a.75.75 0 0 1-1.5 0V13Z",
    fill: primaryFill
  }));
};

export const VehicleCab16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab16FilledIcon, 'VehicleCab16Filled');

const VehicleCab16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM11.5 9A.75.75 0 1 1 10 9a.75.75 0 0 1 1.5 0Zm-5-8a.5.5 0 0 0-.5.5V2h-.68a2 2 0 0 0-1.98 1.74L3.17 5H2.5a.5.5 0 0 0 0 1h.54v.07C2.43 6.27 2 6.83 2 7.5v3c0 .83.67 1.5 1.5 1.5v1.25a.75.75 0 0 0 1.5 0V12h6v1.25a.75.75 0 0 0 1.5 0V12c.83 0 1.5-.67 1.5-1.5v-3a1.5 1.5 0 0 0-1.04-1.43V6h.54a.5.5 0 0 0 0-1h-.68l-.16-1.25A2 2 0 0 0 10.68 2H10v-.5a.5.5 0 0 0-.5-.5h-3ZM4.05 6l.28-2.13A1 1 0 0 1 5.32 3h5.36a1 1 0 0 1 1 .87L11.93 6H4.05ZM13 10.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v3Z",
    fill: primaryFill
  }));
};

export const VehicleCab16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab16RegularIcon, 'VehicleCab16Regular');

const VehicleCab20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 1a.75.75 0 0 0-.75.75V3h-.86a2.5 2.5 0 0 0-2.45 2.01l-.2.99h-.74a.75.75 0 0 0 0 1.5h.44l-.11.56A1.5 1.5 0 0 0 2 9.5v4c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4a1.5 1.5 0 0 0-1.08-1.44l-.11-.56h.54a.75.75 0 0 0 .65-.75v-.1a.75.75 0 0 0-.75-.65h-.74l-.2-.99A2.5 2.5 0 0 0 13.86 3H13V1.75a.75.75 0 0 0-.75-.75h-4.5ZM6.14 4h7.72c.72 0 1.33.5 1.47 1.2L15.9 8H4.11l.56-2.8C4.8 4.5 5.42 4 6.14 4ZM5 11.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm8 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM6 17v-1H4v1a1 1 0 1 0 2 0Zm10-1v1a1 1 0 1 1-2 0v-1h2Z",
    fill: primaryFill
  }));
};

export const VehicleCab20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab20FilledIcon, 'VehicleCab20Filled');

const VehicleCab20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM7 3h-.86a2.5 2.5 0 0 0-2.45 2.01l-.2.99h-.74a.75.75 0 0 0 0 1.5h.44l-.11.56A1.5 1.5 0 0 0 2 9.5v5c0 .83.67 1.5 1.5 1.5H4v1a1 1 0 1 0 2 0v-1h8v1a1 1 0 1 0 2 0v-1h.5c.83 0 1.5-.67 1.5-1.5v-5a1.5 1.5 0 0 0-1.08-1.44l-.11-.56h.54a.75.75 0 0 0 .65-.75v-.1a.75.75 0 0 0-.75-.65h-.74l-.2-.99A2.5 2.5 0 0 0 13.86 3H13V1.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V3Zm1 0V2h4v1H8ZM3.5 9h13c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5Zm2.64-5h7.72c.72 0 1.33.5 1.47 1.2L15.9 8H4.11l.56-2.8C4.8 4.5 5.42 4 6.14 4Z",
    fill: primaryFill
  }));
};

export const VehicleCab20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab20RegularIcon, 'VehicleCab20Regular');

const VehicleCab24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.27 2a.75.75 0 0 0-.75.74V4.5h-.67c-1.43 0-2.69.93-3.1 2.3l-.07.2h-.93a.75.75 0 0 0 0 1.5h.53l-.2.83c-.65.4-1.08 1.1-1.08 1.92v8.5c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75V18.5h8v1.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-8.5c0-.82-.43-1.53-1.08-1.92l-.2-.83h.53a.75.75 0 0 0 0-1.5h-.94l-.06-.18a3.25 3.25 0 0 0-3.11-2.32h-.66V2.74a.75.75 0 0 0-.75-.75H9.27ZM7.85 6h8.29c.77 0 1.45.5 1.68 1.25l.2.7L18.3 9H5.7l.25-1.05.22-.71C6.4 6.5 7.08 6 7.85 6ZM4.5 18.5h2v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V18.5Zm13 0h2v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V18.5ZM8 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleCab24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab24FilledIcon, 'VehicleCab24Filled');

const VehicleCab24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-7.52.75c0-.41.34-.75.75-.75h3.49a.75.75 0 0 1 0 1.5h-3.49a.75.75 0 0 1-.75-.75ZM9.27 1.99a.75.75 0 0 0-.75.75V4.5h-.67c-1.43 0-2.69.93-3.1 2.3l-.07.2h-.93a.75.75 0 0 0 0 1.5h.53l-.2.83c-.65.4-1.08 1.1-1.08 1.92v8.5c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75V18.5h8v1.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-8.5c0-.82-.43-1.53-1.08-1.92l-.2-.83h.53a.75.75 0 0 0 0-1.5h-.94l-.06-.18a3.25 3.25 0 0 0-3.11-2.32h-.64V2.74a.75.75 0 0 0-.75-.75H9.27ZM14 4.5h-3.98v-1H14v1ZM7.85 6h8.29c.77 0 1.45.5 1.68 1.25l.2.7L18.3 9H5.7l.25-1.05.22-.71C6.4 6.5 7.08 6 7.85 6ZM4.5 17v-5.75c0-.41.34-.75.75-.75h13.5c.41 0 .75.34.75.75V17h-15Zm0 2.75V18.5h2v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm15-1.25v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V18.5h2Z",
    fill: primaryFill
  }));
};

export const VehicleCab24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab24RegularIcon, 'VehicleCab24Regular');

const VehicleCab28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 2a1 1 0 0 0-1 1v1h-.18A3.75 3.75 0 0 0 6.2 6.81L5.63 9H4.25a.75.75 0 0 0 0 1.5h1l-.3 1.12A2.75 2.75 0 0 0 3 14.25v9A2.75 2.75 0 0 0 5.75 26h1a2.75 2.75 0 0 0 2.75-2.75v-1h9v1A2.75 2.75 0 0 0 21.25 26h1A2.75 2.75 0 0 0 25 23.25v-9c0-1.24-.82-2.3-1.95-2.63l-.3-1.12h1a.75.75 0 0 0 0-1.5h-1.38l-.56-2.19A3.75 3.75 0 0 0 18.18 4H18V3a1 1 0 0 0-1-1h-6Zm7.18 3.5c1.02 0 1.92.7 2.17 1.69l1.12 4.31H6.53l1.12-4.31c.25-1 1.15-1.69 2.17-1.69h8.36ZM20 22.25h3.5v1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25v-1Zm-12 1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25v-1H8v1Zm-1-7a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm12.75 1.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm-3.5 0a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h4.5Z",
    fill: primaryFill
  }));
};

export const VehicleCab28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab28FilledIcon, 'VehicleCab28Filled');

const VehicleCab28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 16.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm10.25 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-8.75.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-1-14.5V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.75h.16a3.75 3.75 0 0 1 3.64 2.84L22.4 9h1.35a.75.75 0 0 1 0 1.5h-.98l.28 1.12A2.75 2.75 0 0 1 25 14.25v9A2.75 2.75 0 0 1 22.25 26h-1a2.75 2.75 0 0 1-2.75-2.75v-1h-9v1A2.75 2.75 0 0 1 6.75 26h-1A2.75 2.75 0 0 1 3 23.25v-9c0-1.24.82-2.29 1.95-2.63l.28-1.12h-.98a.75.75 0 0 1 0-1.5H5.6l.6-2.41a3.75 3.75 0 0 1 3.64-2.84H10Zm1.5 0h5V2.5h-5v1.25Zm-1.66 1.5c-1.03 0-1.93.7-2.18 1.7L6.52 11.5h14.96l-1.14-4.55c-.25-1-1.15-1.7-2.18-1.7H9.84Zm10.16 17v1c0 .69.56 1.25 1.25 1.25h1c.69 0 1.25-.56 1.25-1.25v-1H20Zm-12 1v-1H4.5v1c0 .69.56 1.25 1.25 1.25h1c.69 0 1.25-.56 1.25-1.25ZM22.25 13H5.75c-.69 0-1.25.56-1.25 1.25v6.5h19v-6.5c0-.69-.56-1.25-1.25-1.25Z",
    fill: primaryFill
  }));
};

export const VehicleCab28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCab28RegularIcon, 'VehicleCab28Regular');

const VehicleCar16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.04 6v.07C2.43 6.27 2 6.83 2 7.5v3c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-3a1.5 1.5 0 0 0-1.04-1.43V6h.54a.5.5 0 0 0 0-1h-.68l-.16-1.25A2 2 0 0 0 10.68 2H5.32a2 2 0 0 0-1.98 1.74L3.17 5H2.5a.5.5 0 0 0 0 1h.54Zm2.28-3h5.36a1 1 0 0 1 1 .87L11.93 6H4.05l.28-2.13A1 1 0 0 1 5.32 3Zm-.07 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm5.5 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12.5 13H11v.25a.75.75 0 0 0 1.5 0V13ZM5 13H3.5v.25a.75.75 0 0 0 1.5 0V13Z",
    fill: primaryFill
  }));
};

export const VehicleCar16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar16FilledIcon, 'VehicleCar16Filled');

const VehicleCar16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 9a.75.75 0 1 1-1.5 0A.75.75 0 0 1 6 9Zm4.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM3.03 6.07 3.04 6H2.5a.5.5 0 0 1 0-1h.67l.17-1.26A2 2 0 0 1 5.32 2h5.36a2 2 0 0 1 1.98 1.75L12.82 5h.68a.5.5 0 0 1 0 1h-.55l.01.07c.6.2 1.04.76 1.04 1.43v3c0 .83-.67 1.5-1.5 1.5v1.25a.75.75 0 1 1-1.5 0V12H5v1.25a.75.75 0 0 1-1.5 0V12A1.5 1.5 0 0 1 2 10.5v-3c0-.67.43-1.23 1.03-1.43Zm1.3-2.2L4.05 6h7.9l-.28-2.13a1 1 0 0 0-1-.87H5.33a1 1 0 0 0-1 .87ZM12.5 11a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h9Z",
    fill: primaryFill
  }));
};

export const VehicleCar16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar16RegularIcon, 'VehicleCar16Regular');

const VehicleCar20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 16v1a1 1 0 1 1-2 0v-1h2Zm10 0v1a1 1 0 1 1-2 0v-1h2ZM13.86 3c1.2 0 2.22.84 2.45 2.01l.2.99h.74c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-.44l.11.56A1.5 1.5 0 0 1 18 9.5v4c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 13.5v-4c0-.68.46-1.26 1.08-1.44l.11-.56h-.44a.75.75 0 0 1 0-1.5h.74l.2-.99A2.5 2.5 0 0 1 6.14 3h7.72ZM6 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM13.86 4H6.14c-.72 0-1.33.5-1.47 1.2L4.1 8h11.78l-.56-2.8A1.5 1.5 0 0 0 13.86 4Z",
    fill: primaryFill
  }));
};

export const VehicleCar20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar20FilledIcon, 'VehicleCar20Filled');

const VehicleCar20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.86 3c1.2 0 2.22.84 2.45 2.01l.2.99h.74c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-.44l.11.56A1.5 1.5 0 0 1 18 9.5v5c0 .83-.67 1.5-1.5 1.5H16v1a1 1 0 1 1-2 0v-1H6v1a1 1 0 1 1-2 0v-1h-.5A1.5 1.5 0 0 1 2 14.5v-5c0-.68.46-1.26 1.08-1.44l.11-.56h-.44a.75.75 0 0 1 0-1.5h.74l.2-.99A2.5 2.5 0 0 1 6.14 3h7.72Zm2.64 6h-13a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5ZM6 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-.14-7H6.14c-.72 0-1.33.5-1.47 1.2L4.1 8h11.78l-.56-2.8A1.5 1.5 0 0 0 13.86 4Z",
    fill: primaryFill
  }));
};

export const VehicleCar20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar20RegularIcon, 'VehicleCar20Regular');

const VehicleCar24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.8 3c1.49 0 2.79 1.01 3.15 2.46L19.34 7h.91c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-.54l.21.83c.65.4 1.08 1.1 1.08 1.92v8.5c0 .96-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.79-1.75-1.75V18.5H8v1.25c0 .96-.78 1.75-1.75 1.75h-1.5C3.78 21.5 3 20.7 3 19.75v-8.5c0-.81.43-1.53 1.08-1.92l.2-.83h-.53a.75.75 0 0 1-.74-.65L3 7.75c0-.38.28-.7.65-.74l.1-.01h.91l.39-1.54A3.25 3.25 0 0 1 8.2 3h7.6ZM6.5 18.5h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5Zm13 0h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5ZM13.75 14h-3.6a.75.75 0 0 0 0 1.5h3.7a.75.75 0 0 0-.1-1.5ZM17 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8.8-7.5H8.2c-.8 0-1.5.55-1.7 1.33L5.71 9H18.3l-.8-3.18c-.19-.77-.89-1.32-1.7-1.32Z",
    fill: primaryFill
  }));
};

export const VehicleCar24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar24FilledIcon, 'VehicleCar24Filled');

const VehicleCar24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.8 3c1.49 0 2.79 1.01 3.15 2.46L19.34 7h.91c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-.54l.21.83c.65.4 1.08 1.1 1.08 1.92v8.5c0 .96-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.79-1.75-1.75V18.5H8v1.25c0 .96-.78 1.75-1.75 1.75h-1.5C3.78 21.5 3 20.7 3 19.75v-8.5c0-.81.43-1.53 1.08-1.92l.2-.83h-.53a.75.75 0 0 1-.74-.65L3 7.75c0-.38.28-.7.65-.74l.1-.01h.91l.39-1.54A3.25 3.25 0 0 1 8.2 3h7.6ZM6.5 18.5h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5Zm13 0h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5Zm-.75-8H5.25a.75.75 0 0 0-.75.75V17h15v-5.75a.75.75 0 0 0-.75-.75Zm-8.5 3.5h3.5a.75.75 0 0 1 .1 1.5h-3.6a.75.75 0 0 1-.1-1.5h3.6-3.5ZM17 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM7 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8.8-7.5H8.2c-.8 0-1.5.55-1.7 1.33L5.71 9H18.3l-.8-3.18c-.19-.77-.89-1.32-1.7-1.32Z",
    fill: primaryFill
  }));
};

export const VehicleCar24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar24RegularIcon, 'VehicleCar24Regular');

const VehicleCar28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m5.24 9.5-.29 1.12A2.75 2.75 0 0 0 3 13.25v9A2.75 2.75 0 0 0 5.75 25h1a2.75 2.75 0 0 0 2.75-2.75v-1h9v1A2.75 2.75 0 0 0 21.25 25h1A2.75 2.75 0 0 0 25 22.25v-9c0-1.24-.82-2.3-1.95-2.63l-.3-1.12h1a.75.75 0 0 0 0-1.5h-1.38l-.56-2.19A3.75 3.75 0 0 0 18.18 3H9.82A3.75 3.75 0 0 0 6.2 5.81L5.63 8H4.25a.75.75 0 0 0 0 1.5h1Zm4.58-5h8.36c1.02 0 1.92.7 2.17 1.69l1.12 4.31H6.53l1.12-4.31c.25-1 1.15-1.69 2.17-1.69ZM20 22.25v-1h3.5v1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25Zm-12-1v1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25v-1H8Zm.25-4.75a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM21 15.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-9.25 1.25h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const VehicleCar28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar28FilledIcon, 'VehicleCar28Filled');

const VehicleCar28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 16.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM21 15.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-9.25 1.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm-6.52-7-.28 1.12A2.75 2.75 0 0 0 3 13.25v9A2.75 2.75 0 0 0 5.75 25h1a2.75 2.75 0 0 0 2.75-2.75v-1h9v1A2.75 2.75 0 0 0 21.25 25h1A2.75 2.75 0 0 0 25 22.25v-9c0-1.24-.82-2.29-1.95-2.63l-.28-1.12h.98a.75.75 0 0 0 0-1.5H22.4l-.6-2.41a3.75 3.75 0 0 0-3.64-2.84H9.84A3.75 3.75 0 0 0 6.2 5.59L5.6 8H4.25a.75.75 0 0 0 0 1.5h.98Zm4.61-5.25h8.32c1.03 0 1.93.7 2.18 1.7l1.14 4.55H6.52l1.14-4.55c.25-1 1.15-1.7 2.18-1.7Zm10.16 18v-1h3.5v1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25Zm-12-1v1c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25v-1H8ZM5.75 12h16.5c.69 0 1.25.56 1.25 1.25v6.5h-19v-6.5c0-.69.56-1.25 1.25-1.25Z",
    fill: primaryFill
  }));
};

export const VehicleCar28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar28RegularIcon, 'VehicleCar28Regular');

const VehicleCar32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 6.13A4 4 0 0 1 10.4 3h11.2a4 4 0 0 1 3.9 3.13L26.14 9H27a1 1 0 1 1 0 2h-.42l.33 1.48A4 4 0 0 1 29 16v10a3 3 0 0 1-3 3h-1a3 3 0 0 1-3-3v-1H10v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V16a4 4 0 0 1 2.09-3.52L5.42 11H5a1 1 0 1 1 0-2h.86l.64-2.87ZM7.25 12h17.5l-1.2-5.43A2 2 0 0 0 21.59 5H10.41a2 2 0 0 0-1.96 1.57L7.25 12ZM5 25v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1H5Zm19 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h-3Zm-11.5-5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-5a1 1 0 0 0-1 1Zm-3-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM24 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const VehicleCar32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar32FilledIcon, 'VehicleCar32Filled');

const VehicleCar32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 6.13A4 4 0 0 1 10.4 3h11.2a4 4 0 0 1 3.9 3.13L26.14 9H27a1 1 0 1 1 0 2h-.42l.33 1.48A4 4 0 0 1 29 16v10a3 3 0 0 1-3 3h-1a3 3 0 0 1-3-3v-1H10v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V16a4 4 0 0 1 2.09-3.52L5.42 11H5a1 1 0 1 1 0-2h.86l.64-2.87Zm17.05.44A2 2 0 0 0 21.59 5H10.41a2 2 0 0 0-1.96 1.57L7.25 12h17.5l-1.2-5.43ZM24 25v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h-3ZM5 25v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1H5Zm2-11a2 2 0 0 0-2 2v7h22v-7a2 2 0 0 0-2-2H7Zm6.5 5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5ZM11 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM22.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: primaryFill
  }));
};

export const VehicleCar32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar32RegularIcon, 'VehicleCar32Regular');

const VehicleCar48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m9.2 16.5-.43 1.77A4.25 4.25 0 0 0 6 22.25v17.5C6 41.55 7.46 43 9.25 43h3.5c1.8 0 3.25-1.46 3.25-3.25V36.5h16v3.25c0 1.8 1.46 3.25 3.25 3.25h3.5c1.8 0 3.25-1.46 3.25-3.25v-17.5c0-1.84-1.17-3.4-2.8-4l-.5-1.75h2.05a1.25 1.25 0 1 0 0-2.5h-2.77l-1-3.47a6.25 6.25 0 0 0-6-4.53h-14.3a6.25 6.25 0 0 0-6.08 4.76L9.81 14H7.25a1.25 1.25 0 1 0 0 2.5H9.2Zm7.47-8h14.3a3.75 3.75 0 0 1 3.61 2.72L36.52 18H11.4l1.63-6.64a3.75 3.75 0 0 1 3.64-2.86Zm17.83 28h5v3.25c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75V36.5Zm-26 3.25V36.5h5v3.25c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75ZM14 28a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm22-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-15.75 2h7.5a1.25 1.25 0 1 1 0 2.5h-7.5a1.25 1.25 0 1 1 0-2.5Z",
    fill: primaryFill
  }));
};

export const VehicleCar48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar48FilledIcon, 'VehicleCar48Filled');

const VehicleCar48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 29.25c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25ZM16 26a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm18 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8.77 18.27l.43-1.77H7.25a1.25 1.25 0 1 1 0-2.5h2.56l.8-3.24A6.25 6.25 0 0 1 16.66 6h14.3A6.25 6.25 0 0 1 37 10.53l.99 3.47h2.77a1.25 1.25 0 1 1 0 2.5h-2.06l.5 1.75c1.64.6 2.81 2.16 2.81 4v17.5c0 1.8-1.46 3.25-3.25 3.25h-3.5A3.25 3.25 0 0 1 32 39.75V36.5H16v3.25c0 1.8-1.46 3.25-3.25 3.25h-3.5A3.25 3.25 0 0 1 6 39.75v-17.5a4.25 4.25 0 0 1 2.77-3.98Zm4.26-6.91L11.4 18h25.12l-1.94-6.78a3.75 3.75 0 0 0-3.6-2.72h-14.3a3.75 3.75 0 0 0-3.65 2.86Zm-2.78 9.14c-.97 0-1.75.78-1.75 1.75V34h31V22.25c0-.97-.78-1.75-1.75-1.75h-27.5ZM34.5 39.75c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75V36.5h-5v3.25Zm-26-3.25v3.25c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75V36.5h-5Z",
    fill: primaryFill
  }));
};

export const VehicleCar48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCar48RegularIcon, 'VehicleCar48Regular');

const VehicleCarCollision16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.9 1.2a.5.5 0 0 0-.9.3v2a.5.5 0 0 0 1 0V3l.61.8a.5.5 0 0 0 .59.16l1.48-.6-.65 1.98a.5.5 0 0 0 .47.66h1.58l-1.39 1.11a.5.5 0 0 0 0 .78L13.08 9H11.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .31-.89l-2-1.61 2-1.61A.5.5 0 0 0 14.5 5h-2.3l.77-2.34a.5.5 0 0 0-.66-.62l-2.13.85L8.9 1.2ZM1.64 8l-.1.62A2 2 0 0 0 1 10v3a1 1 0 0 0 2 0h5a1 1 0 0 0 2 0v-3a2 2 0 0 0-.55-1.38L9.36 8H10a.5.5 0 0 0 0-1h-.78l-.1-.71A1.5 1.5 0 0 0 7.63 5H3.37a1.5 1.5 0 0 0-1.49 1.29l-.1.71a.5.5 0 0 0-.03 0H1a.5.5 0 0 0 0 1h.64Zm1.73-2h4.26a.5.5 0 0 1 .5.43l.23 1.6A2.01 2.01 0 0 0 8 8H3l-.36.03.23-1.6a.5.5 0 0 1 .5-.43ZM8 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-4.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision16FilledIcon, 'VehicleCarCollision16Filled');

const VehicleCarCollision16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.9 1.2a.5.5 0 0 0-.9.3v2a.5.5 0 0 0 1 0V3l.61.8a.5.5 0 0 0 .59.16l1.48-.6-.65 1.98a.5.5 0 0 0 .47.66h1.58l-1.39 1.11a.5.5 0 0 0 0 .78L13.08 9H11.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .31-.89l-2-1.61 2-1.61A.5.5 0 0 0 14.5 5h-2.3l.77-2.34a.5.5 0 0 0-.66-.62l-2.13.85L8.9 1.2ZM7.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM9.36 8l.1.62A2 2 0 0 1 10 10v3a1 1 0 1 1-2 0H3a1 1 0 1 1-2 0v-3a2 2 0 0 1 .55-1.38L1.64 8H1a.5.5 0 0 1 0-1h.75a.5.5 0 0 1 .03 0l.1-.71A1.5 1.5 0 0 1 3.37 5h4.26c.75 0 1.38.55 1.49 1.29l.1.71a.5.5 0 0 1 .03 0H10a.5.5 0 0 1 0 1h-.64ZM2.87 6.43l-.23 1.6L3 8h5l.36.03-.23-1.6a.5.5 0 0 0-.5-.43H3.37a.5.5 0 0 0-.5.43ZM9 10a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2h7v-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision16RegularIcon, 'VehicleCarCollision16Regular');

const VehicleCarCollision20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.36 2.02a.5.5 0 0 1 .56.2l1.72 2.59 2.58-1.73a.5.5 0 0 1 .77.54L14.14 7h3.36a.5.5 0 0 1 .35.85l-2.57 2.57 2.5 1.66a.5.5 0 0 1-.28.92h-3a.5.5 0 1 1 0-1h1.35l-1.63-1.08a.5.5 0 0 1-.07-.77L16.29 8H13.5a.5.5 0 0 1-.49-.62l.7-2.75-1.93 1.29a.5.5 0 0 1-.7-.14L10 4.15V5.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .36-.48ZM2.5 10a.5.5 0 1 0 0 1H3c-.6.46-1 1.18-1 2v4a1 1 0 0 0 2 0v-.5h7v.5a1 1 0 0 0 2 0v-4c0-.82-.4-1.54-1-2h.5a.5.5 0 0 0 0-1h-.66l-.14-.83A2 2 0 0 0 9.73 7.5H5.27A2 2 0 0 0 3.3 9.17l-.14.83H2.5Zm1.58.53.2-1.2a1 1 0 0 1 1-.83h4.45a1 1 0 0 1 .99.84l.2 1.2a2.52 2.52 0 0 0-.42-.04h-6l-.42.03Zm1.42 3.22a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm4.75.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision20FilledIcon, 'VehicleCarCollision20Filled');

const VehicleCarCollision20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.36 2.02a.5.5 0 0 1 .56.2l1.72 2.59 2.58-1.73a.5.5 0 0 1 .77.54L14.14 7h3.36a.5.5 0 0 1 .35.85l-2.57 2.57 2.5 1.66a.5.5 0 0 1-.28.92h-3a.5.5 0 1 1 0-1h1.35l-1.63-1.08a.5.5 0 0 1-.07-.77L16.29 8H13.5a.5.5 0 0 1-.49-.62l.7-2.75-1.93 1.29a.5.5 0 0 1-.7-.14L10 4.15V5.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .36-.48ZM4.75 14.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm6.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 11c.6.46 1 1.18 1 2v4a1 1 0 1 1-2 0v-.5H4v.5a1 1 0 1 1-2 0v-4c0-.82.4-1.54 1-2h-.5a.5.5 0 1 1 0-1h.66l.14-.83A2 2 0 0 1 5.27 7.5h4.46a2 2 0 0 1 1.97 1.67l.14.83h.66a.5.5 0 0 1 0 1H12ZM5.27 8.5a1 1 0 0 0-.99.84l-.2 1.2c.14-.03.28-.04.42-.04h6l.42.03-.2-1.2a1 1 0 0 0-1-.83H5.28ZM3 13v2.5h9V13c0-.83-.67-1.5-1.5-1.5h-6c-.83 0-1.5.67-1.5 1.5Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision20RegularIcon, 'VehicleCarCollision20Regular');

const VehicleCarCollision24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.34 2.3a.75.75 0 0 0-1.34.45v4.5a.75.75 0 0 0 1.5 0v-2.3l1.16 1.5c.23.32.67.4 1 .18l1.7-1.1-.82 2.48a.75.75 0 0 0 .71.99h3.19l-1.22 1.22a.75.75 0 0 0-.08.97l1.65 2.31h-1.54a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 .61-1.19l-2.13-2.98 2.05-2.05a.75.75 0 0 0-.53-1.28h-3.96l1.17-3.51a.75.75 0 0 0-1.12-.87L14.42 5l-2.08-2.7ZM2.86 13.74h-.11a.75.75 0 0 1 0-1.5h.77l.26-1.41A2.25 2.25 0 0 1 6 9h6.09c1.03 0 1.93.7 2.18 1.7l.39 1.55h.6a.75.75 0 1 1 0 1.5h-.11c.53.5.86 1.21.86 2v4.75a1.5 1.5 0 1 1-3 0V20H5v.5a1.5 1.5 0 1 1-3 0v-4.75c0-.79.33-1.5.86-2Zm2.4-2.64L4.9 13h8.35v-.12l-.44-1.81a.75.75 0 0 0-.73-.57H5.99a.75.75 0 0 0-.73.61ZM13 16.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision24FilledIcon, 'VehicleCarCollision24Filled');

const VehicleCarCollision24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2.04c.31-.1.65 0 .84.25L14.42 5l2.92-1.87a.75.75 0 0 1 1.12.87L17.3 7.5h3.96a.75.75 0 0 1 .53 1.28l-2.05 2.05 2.13 2.98a.75.75 0 0 1-.61 1.19h-3a.75.75 0 1 1 0-1.5h1.54l-1.65-2.31a.75.75 0 0 1 .08-.97L19.44 9h-3.19a.75.75 0 0 1-.71-.99l.83-2.48-1.71 1.1a.75.75 0 0 1-1-.17l-1.16-1.5v2.29a.75.75 0 0 1-1.5 0v-4.5c0-.32.2-.6.5-.71ZM12 17.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8.14-2.75h.11a.75.75 0 1 0 0-1.5h-.6l-.39-1.55c-.25-1-1.15-1.7-2.18-1.7H5.99c-1.08 0-2 .77-2.2 1.84l-.27 1.41h-.77a.75.75 0 0 0 0 1.5h.11c-.53.5-.86 1.21-.86 2v4.75a1.5 1.5 0 1 0 3 0V20h8v.5a1.5 1.5 0 1 0 3 0v-4.75c0-.79-.33-1.5-.86-2ZM5.99 10.5h6.09c.34 0 .64.23.73.57l.45 1.81-.01.12H4.9l.36-1.89a.75.75 0 0 1 .73-.61Zm8.51 8h-11v-2.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v2.75Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision24RegularIcon, 'VehicleCarCollision24Regular');

const VehicleCarCollision28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.53 2.03c.32-.1.66.03.84.3l2.35 3.52 4.24-1.8a.75.75 0 0 1 .98 1L20.4 8.5h3.85a.75.75 0 0 1 .58 1.23l-2.1 2.5 3.08 3.53a.75.75 0 0 1-.56 1.24h-4.5a.75.75 0 1 1 0-1.5h2.85l-2.41-2.76a.75.75 0 0 1-.02-.97L22.65 10h-3.4a.75.75 0 0 1-.69-1.05l1.23-2.77-3.06 1.3a.75.75 0 0 1-.92-.28L14.5 5.23v3.02a.75.75 0 0 1-1.5 0v-5.5c0-.33.22-.62.53-.72ZM4.15 14l.31-1.74A2.75 2.75 0 0 1 7.16 10h6.17c1.33 0 2.47.95 2.7 2.26l.33 1.75.14-.01h1.25a.75.75 0 1 1 0 1.5h-.42c.7.5 1.17 1.32 1.17 2.25v6.5c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75V23H7v1.25C7 25.22 6.22 26 5.25 26h-1.5C2.78 26 2 25.22 2 24.25V22.5l.01-.12a.76.76 0 0 1-.01-.13v-4.5c0-.93.46-1.75 1.17-2.25h-.42a.75.75 0 0 1 0-1.5h1.4Zm1.79-1.47L5.49 15h9.52l-.45-2.47c-.1-.6-.63-1.03-1.23-1.03H7.17c-.6 0-1.12.43-1.23 1.03ZM17 23h-2v1.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25V23ZM3.5 24.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25V23h-2v1.25Zm11-4.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 19a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm1.75 0a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision28FilledIcon, 'VehicleCarCollision28Filled');

const VehicleCarCollision28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.37 2.33a.75.75 0 0 0-1.37.42v5.5a.75.75 0 0 0 1.5 0V5.23l1.31 1.97c.2.3.59.41.92.27l3.06-1.3-1.23 2.78a.75.75 0 0 0 .69 1.05h3.4l-1.48 1.77c-.23.28-.23.7.02.97l2.4 2.76h-2.84a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 .56-1.24l-3.07-3.52 2.09-2.51a.75.75 0 0 0-.58-1.23H20.4l1.54-3.45a.75.75 0 0 0-.98-1l-4.24 1.8-2.35-3.52ZM14.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1.75 0a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Zm-6-3.5h.42C2.47 16 2 16.82 2 17.75v4.5l.01.13-.01.12v1.75c0 .97.78 1.75 1.75 1.75h1.5C6.22 26 7 25.22 7 24.25V23h6.5v1.25c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-6.5c0-.93-.46-1.75-1.17-2.25h.42a.75.75 0 0 0 0-1.5H16.5l-.14.01-.32-1.75a2.75 2.75 0 0 0-2.7-2.26H7.16c-1.33 0-2.47.95-2.7 2.26L4.14 14h-1.4a.75.75 0 1 0 0 1.5Zm.75 2.25c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25v3.75H3.5v-3.75Zm11.06-5.22.45 2.47H5.49l.45-2.47c.1-.6.62-1.03 1.23-1.03h6.16c.6 0 1.12.43 1.23 1.03ZM15 24.25V23h2v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM5.5 23v1.25c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V23h2Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision28RegularIcon, 'VehicleCarCollision28Regular');

const VehicleCarCollision32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.72 3.3A1 1 0 0 0 15 4v5a1 1 0 1 0 2 0V6.48l2.28 2.36a1 1 0 0 0 1.34.1L22 7.85l-.95 2.83A1 1 0 0 0 22 12h3l-1.8 2.4a1 1 0 0 0 .18 1.38L26.15 18H24a1 1 0 1 0 0 2h5a1 1 0 0 0 .62-1.78l-4.24-3.4 2.42-3.22A1 1 0 0 0 27 10h-3.61l1.56-4.68a1 1 0 0 0-1.57-1.1L20.1 6.8l-3.37-3.5ZM4.51 16H3a1 1 0 1 0 0 2h1.06A4 4 0 0 0 2 21.5v6A2.5 2.5 0 0 0 4.5 30H6a2.5 2.5 0 0 0 2.5-2.5v-1h6v1A2.5 2.5 0 0 0 17 30h1.5a2.5 2.5 0 0 0 2.5-2.5v-6a4 4 0 0 0-2.06-3.5H20a1 1 0 1 0 0-2h-1.5l-.18-1.05A3.5 3.5 0 0 0 14.87 12H8.13a3.5 3.5 0 0 0-3.45 2.95L4.5 16Zm12.2 1.5H6.29l.36-2.24A1.5 1.5 0 0 1 8.13 14h6.74c.74 0 1.36.54 1.48 1.26l.36 2.24Zm2.29 9v1a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5v-1H19Zm-12.5 0v1a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5v-1h2.5ZM17 23a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.75 0h3.5a1 1 0 1 1 0 2h-3.5a1 1 0 1 1 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision32FilledIcon, 'VehicleCarCollision32Filled');

const VehicleCarCollision32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.72 3.3A1 1 0 0 0 15 4v5a1 1 0 1 0 2 0V6.48l2.28 2.36a1 1 0 0 0 1.34.1L22 7.85l-.95 2.83A1 1 0 0 0 22 12h3l-1.8 2.4a1 1 0 0 0 .18 1.38L26.15 18H24a1 1 0 1 0 0 2h5a1 1 0 0 0 .62-1.78l-4.24-3.4 2.42-3.22A1 1 0 0 0 27 10h-3.61l1.56-4.68a1 1 0 0 0-1.57-1.1L20.1 6.8l-3.37-3.5ZM17 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.75 0a1 1 0 1 0 0 2h3.5a1 1 0 1 0 0-2h-3.5ZM20 18h-1.06A4 4 0 0 1 21 21.5v6a2.5 2.5 0 0 1-2.5 2.5H17a2.5 2.5 0 0 1-2.5-2.5v-1h-6v1A2.5 2.5 0 0 1 6 30H4.5A2.5 2.5 0 0 1 2 27.5v-6A4 4 0 0 1 4.06 18H3a1 1 0 1 1 0-2h1.49l.21-1.28A3.25 3.25 0 0 1 7.9 12h7.2a3.25 3.25 0 0 1 3.2 2.72l.21 1.28H20a1 1 0 1 1 0 2ZM6.67 15.04l-.4 2.46h10.47l-.41-2.46c-.1-.6-.62-1.04-1.24-1.04H7.91c-.62 0-1.14.44-1.24 1.04ZM16.5 26.5v1c0 .28.22.5.5.5h1.5a.5.5 0 0 0 .5-.5v-1h-2.5ZM4 26.5v1c0 .28.22.5.5.5H6a.5.5 0 0 0 .5-.5v-1H4Zm2-7a2 2 0 0 0-2 2v3h15v-3a2 2 0 0 0-2-2H6Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision32RegularIcon, 'VehicleCarCollision32Regular');

const VehicleCarCollision48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.88 2.06c.52-.17 1.09.03 1.4.48l4.78 6.95 5.96-4.26a1.25 1.25 0 0 1 1.92 1.4l-2.48 7.87h6.29a1.25 1.25 0 0 1 .95 2.06l-4.63 5.47 6.42 4.71a1.25 1.25 0 0 1-.74 2.26h-7.5a1.25 1.25 0 0 1 0-2.5h3.68l-4.42-3.24a1.25 1.25 0 0 1-.21-1.82L39.05 17h-5.3a1.25 1.25 0 0 1-1.2-1.63l1.88-5.93-3.95 2.83a1.25 1.25 0 0 1-1.76-.31L25.5 7.27v6.48a1.25 1.25 0 0 1-2.5 0V3.25c0-.55.36-1.03.88-1.2Zm-17.5 25.2.17-.76h-1.3a1.25 1.25 0 0 1 0-2.5h1.84l.5-2.36a5.25 5.25 0 0 1 5.14-4.14h11.54c2.47 0 4.61 1.72 5.13 4.14l.52 2.4c.1-.02.22-.04.33-.04h1.5a1.25 1.25 0 1 1 0 2.5h-1.3l.17.76c1.4.54 2.38 1.9 2.38 3.49v11.5c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 24 42.25V41H13v1.25c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 4 42.25v-11.5c0-1.59.99-2.95 2.38-3.5Zm3.66-5.1L9 27h19l-1.04-4.83A2.75 2.75 0 0 0 24.27 20H12.73c-1.3 0-2.42.9-2.69 2.17ZM26.5 42.26c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V41h-4v1.25ZM10.5 41h-4v1.25c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V41Zm.5-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm17-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-11.75 1a1.25 1.25 0 1 0 0 2.5h4.5a1.25 1.25 0 0 0 0-2.5h-4.5Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision48FilledIcon, 'VehicleCarCollision48Filled');

const VehicleCarCollision48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.88 2.06c.52-.17 1.09.03 1.4.48l4.78 6.95 5.96-4.26a1.25 1.25 0 0 1 1.92 1.4l-2.48 7.87h6.29a1.25 1.25 0 0 1 .95 2.06l-4.63 5.47 6.42 4.71a1.25 1.25 0 0 1-.74 2.26h-7.5a1.25 1.25 0 0 1 0-2.5h3.68l-4.42-3.24a1.25 1.25 0 0 1-.21-1.82L39.05 17h-5.3a1.25 1.25 0 0 1-1.2-1.63l1.88-5.93-3.95 2.83a1.25 1.25 0 0 1-1.76-.31L25.5 7.27v6.48a1.25 1.25 0 0 1-2.5 0V3.25c0-.55.36-1.03.88-1.2ZM11 35a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm17-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-11.75 1a1.25 1.25 0 1 0 0 2.5h4.5a1.25 1.25 0 0 0 0-2.5h-4.5Zm-9.87-6.74.17-.76h-1.3a1.25 1.25 0 0 1 0-2.5h1.84l.5-2.36a5.25 5.25 0 0 1 5.14-4.14h11.54c2.47 0 4.61 1.72 5.13 4.14l.52 2.4c.1-.02.22-.04.33-.04h1.5a1.25 1.25 0 1 1 0 2.5h-1.3l.17.76c1.4.54 2.38 1.9 2.38 3.49v11.5c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 24 42.25V41H13v1.25c0 1.8-1.46 3.25-3.25 3.25h-2.5A3.25 3.25 0 0 1 4 42.25v-11.5c0-1.59.99-2.95 2.38-3.5Zm3.66-5.1L9 27h19l-1.04-4.83A2.75 2.75 0 0 0 24.27 20H12.73c-1.3 0-2.42.9-2.69 2.17ZM26.5 42.26c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V41h-4v1.25ZM10.5 41h-4v1.25c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75V41Zm-4-10.25v7.75h24v-7.75c0-.69-.56-1.25-1.25-1.25H7.75c-.69 0-1.25.56-1.25 1.25Z",
    fill: primaryFill
  }));
};

export const VehicleCarCollision48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarCollision48RegularIcon, 'VehicleCarCollision48Regular');

const VehicleCarParking16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 .5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5H13v8.5a.5.5 0 0 1-1 0V6h-1.5a.5.5 0 0 1-.5-.5v-5ZM5.32 2H9v1H5.32a1 1 0 0 0-1 .87L4.06 6H9.1c.2.58.76 1 1.41 1h.5v1.3a.75.75 0 1 0 0 1.4V12H3.5A1.5 1.5 0 0 1 2 10.5v-3c0-.67.43-1.23 1.03-1.43L3.04 6H2.5a.5.5 0 0 1 0-1h.67l.17-1.26A2 2 0 0 1 5.32 2Zm-.07 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 13H3.5v.25a.75.75 0 0 0 1.5 0V13Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking16FilledIcon, 'VehicleCarParking16Filled');

const VehicleCarParking16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 .5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5H13v8.5a.5.5 0 0 1-1 0V6h-1.5a.5.5 0 0 1-.5-.5v-5ZM5.32 2H9v1H5.32a1 1 0 0 0-1 .87L4.06 6H9.1c.2.58.76 1 1.41 1h-7a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5H11v1H5v1.25a.75.75 0 0 1-1.5 0V12A1.5 1.5 0 0 1 2 10.5v-3c0-.67.43-1.23 1.03-1.43L3.04 6H2.5a.5.5 0 0 1 0-1h.67l.17-1.26A2 2 0 0 1 5.32 2Zm5.43 6.25c.09 0 .17.02.25.04v1.42a.75.75 0 1 1-.25-1.46ZM6 9a.75.75 0 1 1-1.5 0A.75.75 0 0 1 6 9Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking16RegularIcon, 'VehicleCarParking16Regular');

const VehicleCarParking20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5H17v11.5a.5.5 0 0 1-1 0V7h-1.5a.5.5 0 0 1-.5-.5v-5ZM13 3H6.14a2.5 2.5 0 0 0-2.45 2.01l-.2.99h-.74a.75.75 0 0 0 0 1.5h.44l-.11.56A1.5 1.5 0 0 0 2 9.5v4c0 .83.67 1.5 1.5 1.5H15V8H4.11l.56-2.8C4.8 4.5 5.42 4 6.14 4H13V3Zm2 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 6.5a1 1 0 0 1-1-1v-1h1v2Zm-9-1v-1H4v1a1 1 0 1 0 2 0Zm-1-5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking20FilledIcon, 'VehicleCarParking20Filled');

const VehicleCarParking20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5H17v11.5a.5.5 0 0 1-1 0V7h-1.5a.5.5 0 0 1-.5-.5v-5ZM13 3H6.14a2.5 2.5 0 0 0-2.45 2.01l-.2.99h-.74a.75.75 0 0 0 0 1.5h.44l-.11.56A1.5 1.5 0 0 0 2 9.5v5c0 .83.67 1.5 1.5 1.5H4v1a1 1 0 1 0 2 0v-1h8v1a1 1 0 0 0 1 1v-3H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5H15V8H4.11l.56-2.8C4.8 4.5 5.42 4 6.14 4H13V3Zm2 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking20RegularIcon, 'VehicleCarParking20Regular');

const VehicleCarParking24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 2a1 1 0 0 1 1-1H22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v14.25a.75.75 0 0 1-1.5 0V8h-1.25a1 1 0 0 1-1-1V2ZM15.8 3l.45.03v1.53c-.14-.04-.3-.06-.45-.06H8.2c-.8 0-1.5.55-1.7 1.33L5.71 9H18.5v9.5h-1v1.25c0 .13.11.25.25.25h.75v1.5h-.75c-.97 0-1.75-.79-1.75-1.75V18.5H8v1.25c0 .96-.78 1.75-1.75 1.75h-1.5C3.78 21.5 3 20.7 3 19.75v-8.5c0-.81.43-1.53 1.08-1.92l.2-.83h-.53a.75.75 0 0 1-.74-.65L3 7.75c0-.38.28-.7.65-.74l.1-.01h.91l.39-1.54A3.25 3.25 0 0 1 8.2 3h7.6ZM6.5 18.5h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5Zm7.25-4.5h-3.6a.75.75 0 0 0 0 1.5h3.7a.75.75 0 0 0-.1-1.5ZM17 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking24FilledIcon, 'VehicleCarParking24Filled');

const VehicleCarParking24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 2a1 1 0 0 1 1-1H22a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v14.25a.75.75 0 0 1-1.5 0V8h-1.25a1 1 0 0 1-1-1V2ZM15.8 3l.45.03v1.53c-.14-.04-.3-.06-.45-.06H8.2c-.8 0-1.5.55-1.7 1.33L5.71 9H18.5v1.5H5.25a.75.75 0 0 0-.75.75V17h14v1.5h-1v1.25c0 .13.11.25.25.25h.75v1.5h-.75c-.97 0-1.75-.79-1.75-1.75V18.5H8v1.25c0 .96-.78 1.75-1.75 1.75h-1.5C3.78 21.5 3 20.7 3 19.75v-8.5c0-.81.43-1.53 1.08-1.92l.2-.83h-.53a.75.75 0 0 1-.74-.65L3 7.75c0-.38.28-.7.65-.74l.1-.01h.91l.39-1.54A3.25 3.25 0 0 1 8.2 3h7.6ZM6.5 18.5h-2v1.25c0 .13.11.25.25.25h1.5c.14 0 .25-.12.25-.25V18.5Zm3.75-4.5h3.5a.75.75 0 0 1 .1 1.5h-3.6a.75.75 0 0 1-.1-1.5h.1ZM17 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM7 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking24RegularIcon, 'VehicleCarParking24Regular');

const VehicleCarParking32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v19a1 1 0 1 1-2 0V11h-1a2 2 0 0 1-2-2V3Zm-1.5 0H10.4a4 4 0 0 0-3.9 3.13L5.86 9H5a1 1 0 0 0 0 2h.42l-.33 1.48A4 4 0 0 0 3 16v10a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1h12v1a3 3 0 0 0 2.5 2.96v-2.1A1 1 0 0 1 24 26v-1h.5V12.46a3.48 3.48 0 0 1-1.3-.46H7.25l1.2-5.43A2 2 0 0 1 10.41 5H21.5V3ZM5 26v-1h3v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm8.5-5a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2h-5ZM11 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM22.5 16a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking32FilledIcon, 'VehicleCarParking32Filled');

const VehicleCarParking32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v19a1 1 0 1 1-2 0V11h-1a2 2 0 0 1-2-2V3Zm-1.5 0H10.4a4 4 0 0 0-3.9 3.13L5.86 9H5a1 1 0 0 0 0 2h.42l-.33 1.48A4 4 0 0 0 3 16v10a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3v-1h12v1a3 3 0 0 0 2.5 2.96v-2.1A1 1 0 0 1 24 26v-1h.5v-2H5v-7c0-1.1.9-2 2-2h17.5v-1.54a3.48 3.48 0 0 1-1.3-.46H7.25l1.2-5.43A2 2 0 0 1 10.41 5H21.5V3ZM5 26v-1h3v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm7.5-6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1Zm-3-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM24 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking32RegularIcon, 'VehicleCarParking32Regular');

const VehicleCarParking48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M36.5 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2H39v28.75a1.25 1.25 0 1 0 2.5 0V16H44a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7.5Zm-4 4.19c-.49-.13-1-.19-1.52-.19h-14.3a6.25 6.25 0 0 0-6.08 4.76L9.81 14H7.25a1.25 1.25 0 1 0 0 2.5H9.2l-.43 1.77A4.25 4.25 0 0 0 6 22.25v17.5C6 41.55 7.46 43 9.25 43h3.5c1.8 0 3.25-1.46 3.25-3.25V36.5h16v3.25c0 1.8 1.46 3.25 3.25 3.25H37v-2.5h-1.75a.75.75 0 0 1-.75-.75V36.5H37V18H11.4l1.63-6.64a3.75 3.75 0 0 1 3.64-2.86h14.3c.55 0 1.06.11 1.53.32V6.2ZM8.5 36.5h5v3.25c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75V36.5ZM12 26a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm22 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-6.25 0a1.25 1.25 0 1 1 0 2.5h-7.5a1.25 1.25 0 1 1 0-2.5h7.5Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking48FilledIcon, 'VehicleCarParking48Filled');

const VehicleCarParking48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M36.5 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2H39v28.75a1.25 1.25 0 1 0 2.5 0V16H44a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7.5Zm-4 4.19c-.49-.13-1-.19-1.52-.19h-14.3a6.25 6.25 0 0 0-6.08 4.76L9.81 14H7.25a1.25 1.25 0 1 0 0 2.5H9.2l-.43 1.77A4.25 4.25 0 0 0 6 22.25v17.5C6 41.55 7.46 43 9.25 43h3.5c1.8 0 3.25-1.46 3.25-3.25V36.5h16v3.25c0 1.8 1.46 3.25 3.25 3.25H37v-2.5h-1.75a.75.75 0 0 1-.75-.75V36.5H37V34H8.5V22.25c0-.97.78-1.75 1.75-1.75H37V18H11.4l1.63-6.64a3.75 3.75 0 0 1 3.64-2.86h14.3c.55 0 1.06.11 1.53.32V6.2ZM20.25 28a1.25 1.25 0 1 0 0 2.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5ZM14 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm22-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8.5 39.75V36.5h5v3.25c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75Z",
    fill: primaryFill
  }));
};

export const VehicleCarParking48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarParking48RegularIcon, 'VehicleCarParking48Regular');

const VehicleCarProfileLtr16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m11.78 6.5-.14-.05-1.13-2.13A2.5 2.5 0 0 0 8.3 3H5.44a2.5 2.5 0 0 0-2.37 1.7l-.54 1.63A2.5 2.5 0 0 0 1 8.63v1.12c0 .71.42 1.32 1.03 1.6a2 2 0 0 0 3.9.15h4.13a2 2 0 0 0 3.91-.15c.6-.28 1.03-.89 1.03-1.6v-.34c0-1.06-.67-2-1.66-2.35l-1.51-.54V6.5h-.05ZM4.02 5.03A1.5 1.5 0 0 1 5.44 4H6.5v2.5H3.53l.49-1.47Zm6.51 1.47H7.5V4h.8c.55 0 1.06.3 1.32.8l.91 1.7ZM3 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm9-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr16FilledIcon, 'VehicleCarProfileLtr16Filled');

const VehicleCarProfileLtr16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m11.78 6.5-.14-.05-1.13-2.13A2.5 2.5 0 0 0 8.3 3H5.44a2.5 2.5 0 0 0-2.37 1.7l-.54 1.63A2.5 2.5 0 0 0 1 8.63v1.12c0 .71.42 1.32 1.03 1.6a2 2 0 0 0 3.9.15h4.13a2 2 0 0 0 3.91-.15c.6-.28 1.03-.89 1.03-1.6v-.34c0-1.06-.67-2-1.66-2.35l-1.51-.54V6.5h-.05ZM5.44 4H6.5v2.5H3.53l.49-1.47A1.5 1.5 0 0 1 5.44 4ZM7.5 4h.8c.55 0 1.06.3 1.32.8l.91 1.7H7.5V4Zm4.1 3.5L13 8c.6.21 1 .78 1 1.41v.34c0 .18-.06.34-.16.46a2 2 0 0 0-3.78.29H5.94a2 2 0 0 0-3.78-.29.75.75 0 0 1-.16-.46V8.64c0-.45.2-.86.52-1.14h9.08ZM3 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm9-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr16RegularIcon, 'VehicleCarProfileLtr16Regular');

const VehicleCarProfileLtr20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.98 13.84c.6-.27 1.02-.88 1.02-1.59v-1.21a2.5 2.5 0 0 0-1.86-2.42l-2.09-.56-1.54-2.77A2.5 2.5 0 0 0 10.32 4H6.94a2.5 2.5 0 0 0-2.37 1.7l-.82 2.48A2.5 2.5 0 0 0 2 10.56v1.69c0 .7.42 1.32 1.02 1.6a2.5 2.5 0 0 0 4.93.15h4.1a2.5 2.5 0 0 0 4.93-.16ZM6.94 5H8v3H4.86l.66-1.97A1.5 1.5 0 0 1 6.94 5Zm4.7.77L12.86 8H9V5h1.32c.55 0 1.05.3 1.31.77ZM4 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm9 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr20FilledIcon, 'VehicleCarProfileLtr20Filled');

const VehicleCarProfileLtr20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.52 6.03 4.86 8H8V5H6.94a1.5 1.5 0 0 0-1.42 1.03ZM4.52 9l-.26.08-.12.03A1.5 1.5 0 0 0 3 10.56v1.69c0 .16.05.31.14.43a2.5 2.5 0 0 1 4.81.32h4.1a2.5 2.5 0 0 1 4.81-.32.75.75 0 0 0 .14-.43v-1.21a1.5 1.5 0 0 0-1.11-1.45L13.69 9H4.52Zm8.35-1-1.24-2.23a1.5 1.5 0 0 0-1.3-.77H9v3h3.87ZM18 12.25c0 .7-.42 1.32-1.02 1.6a2.5 2.5 0 0 1-4.93.15h-4.1a2.5 2.5 0 0 1-4.93-.16A1.75 1.75 0 0 1 2 12.25v-1.69c0-1.1.71-2.06 1.75-2.38l.82-2.47A2.5 2.5 0 0 1 6.94 4h3.38c.91 0 1.75.5 2.19 1.29l1.54 2.77 2.1.56A2.5 2.5 0 0 1 18 11.04v1.21ZM5.5 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr20RegularIcon, 'VehicleCarProfileLtr20Regular');

const VehicleCarProfileLtr24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.03 4c-1.24 0-2.33.83-2.66 2.03l-.95 3.49A2.75 2.75 0 0 0 2 12.25v2.25c0 .86.4 1.64 1.02 2.14a3.25 3.25 0 0 0 6.32.61h4.82a3.25 3.25 0 0 0 6.25-.26A2.75 2.75 0 0 0 22 14.5v-1.69c0-1.26-.86-2.36-2.08-2.67l-2.19-.54-2.5-4.25A2.75 2.75 0 0 0 12.86 4H8.03Zm-1.2 2.42c.14-.54.63-.92 1.2-.92H9.5v4H5.98l.84-3.08ZM11 9.5v-4h1.86c.44 0 .85.23 1.07.61l2 3.39H11Zm-4.75 5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm9.25 1.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr24FilledIcon, 'VehicleCarProfileLtr24Filled');

const VehicleCarProfileLtr24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.37 6.03A2.75 2.75 0 0 1 8.03 4h4.83c.97 0 1.87.51 2.37 1.35l2.5 4.25 2.19.54c1.22.31 2.08 1.41 2.08 2.67v1.69c0 1.1-.65 2.05-1.59 2.5a3.25 3.25 0 0 1-6.25.25H9.34a3.25 3.25 0 0 1-6.32-.61A2.74 2.74 0 0 1 2 14.5v-2.25c0-1.4 1.06-2.57 2.42-2.73l.95-3.5Zm8.67 9.72a3.25 3.25 0 0 1 6.27-.6c.12-.18.19-.4.19-.65v-1.69c0-.57-.39-1.07-.95-1.21l-2.4-.6H4.76c-.69 0-1.25.56-1.25 1.25v2.27a3.25 3.25 0 0 1 5.96 1.23h4.58ZM11 9.5h4.93l-2-3.39a1.25 1.25 0 0 0-1.07-.61H11v4Zm-1.5-4H8.03c-.57 0-1.06.38-1.2.92L5.97 9.5H9.5v-4Zm-3.25 9a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm9.25 1.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtr24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtr24RegularIcon, 'VehicleCarProfileLtr24Regular');

const VehicleCarProfileLtrClock16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM4.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H5V3.5a.5.5 0 0 0-.5-.5Zm0 8c1.93 0 3.63-1 4.61-2.5h2.42l-.9-1.7a1.5 1.5 0 0 0-.67-.65A5.56 5.56 0 0 0 10 5.1c.64.18 1.2.62 1.52 1.22l1.13 2.13 1.7.6A2.5 2.5 0 0 1 16 11.42v.34c0 .7-.42 1.32-1.03 1.6a2 2 0 0 1-3.9.15H6.93a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 2 11.75v-1.11l.01-.23c.75.38 1.6.59 2.49.59ZM4 13a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock16FilledIcon, 'VehicleCarProfileLtrClock16Filled');

const VehicleCarProfileLtrClock16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM4.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H5V3.5a.5.5 0 0 0-.5-.5Zm8.1 6.5H8.28c.31-.3.6-.63.83-1h2.42l-.9-1.7a1.5 1.5 0 0 0-.67-.65A5.56 5.56 0 0 0 10 5.1c.64.18 1.2.62 1.52 1.22l1.13 2.13.14.05h.05v.02l1.5.54A2.5 2.5 0 0 1 16 11.4v.34c0 .71-.42 1.32-1.03 1.6a2 2 0 0 1-3.9.15H6.93a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 2 11.75v-1.11l.01-.23c.31.16.65.29.99.38v.96c0 .18.06.34.16.46a2 2 0 0 1 3.78.29h4.12a2 2 0 0 1 3.78-.29c.1-.12.16-.28.16-.46v-.34c0-.63-.4-1.2-1-1.41l-1.4-.5ZM4 13a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock16RegularIcon, 'VehicleCarProfileLtrClock16Regular');

const VehicleCarProfileLtrClock20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM5.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H7a.5.5 0 0 0 0-1H6V3.5a.5.5 0 0 0-.5-.5ZM3 12.56c0-.71.3-1.37.8-1.83A5.5 5.5 0 0 0 10 8.66V10h3.87l-1.24-2.23a1.5 1.5 0 0 0-1.3-.77h-.54c.1-.32.16-.66.19-1h.34c.91 0 1.75.5 2.19 1.29l1.54 2.77 2.1.56A2.5 2.5 0 0 1 19 13.04v1.21c0 .7-.42 1.32-1.02 1.6a2.5 2.5 0 0 1-4.93.15h-4.1a2.5 2.5 0 0 1-4.93-.16A1.75 1.75 0 0 1 3 14.25v-1.69Zm2 2.94a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm9 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock20FilledIcon, 'VehicleCarProfileLtrClock20Filled');

const VehicleCarProfileLtrClock20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM5.5 3a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H7a.5.5 0 0 0 0-1H6V3.5a.5.5 0 0 0-.5-.5ZM3 12.56c0-.71.3-1.37.8-1.83A5.5 5.5 0 0 0 10 8.66V10h3.87l-1.24-2.23a1.5 1.5 0 0 0-1.3-.77h-.54c.1-.32.16-.66.19-1h.34c.91 0 1.75.5 2.19 1.29l1.54 2.77 2.1.56A2.5 2.5 0 0 1 19 13.04v1.21c0 .7-.42 1.32-1.02 1.6a2.5 2.5 0 0 1-4.93.15h-4.1a2.5 2.5 0 0 1-4.93-.16A1.75 1.75 0 0 1 3 14.25v-1.69ZM5.53 11v.01l-.4.1A1.5 1.5 0 0 0 4 12.56v1.7c0 .15.05.3.14.42a2.5 2.5 0 0 1 4.81.32h4.1a2.5 2.5 0 0 1 4.81-.32.75.75 0 0 0 .14-.43v-1.21a1.5 1.5 0 0 0-1.11-1.45l-2.2-.59H5.52Zm.97 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock20RegularIcon, 'VehicleCarProfileLtrClock20Regular');

const VehicleCarProfileLtrClock24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 1a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm2 5.5h-2V4a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1Zm-2 6.5c1.75 0 3.33-.69 4.5-1.81V12h4.93l-2-3.39A1.25 1.25 0 0 0 12.86 8h-.03c.11-.48.17-.98.17-1.5.92.05 1.76.55 2.23 1.35l2.5 4.25 2.19.54c1.22.31 2.08 1.41 2.08 2.67V17c0 1.1-.65 2.05-1.59 2.5a3.25 3.25 0 0 1-6.25.25H9.34a3.25 3.25 0 0 1-6.32-.61A2.74 2.74 0 0 1 2 17v-2.25c0-1.08.62-2.02 1.53-2.47.9.46 1.9.72 2.97.72Zm-.25 4a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm9.25 1.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock24FilledIcon, 'VehicleCarProfileLtrClock24Filled');

const VehicleCarProfileLtrClock24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 1a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm2 5.5h-2V4a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1Zm-2 6.5A6.5 6.5 0 0 0 12 9.97V12h4.93l-2-3.39A1.25 1.25 0 0 0 13.86 8h-1.03c.11-.48.17-.98.17-1.5h.86c.97 0 1.87.51 2.37 1.35l2.5 4.25 2.19.54c1.22.31 2.08 1.41 2.08 2.67V17c0 1.1-.65 2.05-1.59 2.5a3.25 3.25 0 0 1-6.25.25h-4.82a3.25 3.25 0 0 1-6.32-.61A2.74 2.74 0 0 1 3 17v-2.25c0-.9.43-1.7 1.1-2.2.75.29 1.55.45 2.4.45Zm8.54 5.25a3.25 3.25 0 0 1 6.27-.6c.12-.18.19-.4.19-.65v-1.69c0-.57-.39-1.07-.95-1.21l-2.4-.6H5.76c-.69 0-1.25.56-1.25 1.25v2.27a3.25 3.25 0 0 1 5.96 1.23h4.58ZM7.25 17a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm9.25 1.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileLtrClock24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileLtrClock24RegularIcon, 'VehicleCarProfileLtrClock24Regular');

const VehicleCarProfileRtl16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m4.22 6.5.14-.05 1.13-2.13A2.5 2.5 0 0 1 7.7 3h2.86a2.5 2.5 0 0 1 2.37 1.7l.54 1.63A2.5 2.5 0 0 1 15 8.63v1.12c0 .71-.42 1.32-1.03 1.6a2 2 0 0 1-3.9.15H5.93a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 1 9.75v-.34c0-1.06.67-2 1.66-2.35l1.51-.54V6.5h.05Zm7.76-1.47A1.5 1.5 0 0 0 10.56 4H9.5v2.5h2.97l-.49-1.47ZM5.47 6.5H8.5V4h-.8c-.55 0-1.06.3-1.32.8l-.91 1.7ZM13 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl16FilledIcon, 'VehicleCarProfileRtl16Filled');

const VehicleCarProfileRtl16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m4.22 6.5.14-.05 1.13-2.13A2.5 2.5 0 0 1 7.7 3h2.86a2.5 2.5 0 0 1 2.37 1.7l.54 1.63A2.5 2.5 0 0 1 15 8.63v1.12c0 .71-.42 1.32-1.03 1.6a2 2 0 0 1-3.9.15H5.93a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 1 9.75v-.34c0-1.06.67-2 1.66-2.35l1.51-.54V6.5h.05ZM10.56 4H9.5v2.5h2.97l-.49-1.47A1.5 1.5 0 0 0 10.56 4ZM8.5 4h-.8c-.55 0-1.06.3-1.32.8l-.91 1.7H8.5V4ZM4.4 7.5 3 8c-.6.21-1 .78-1 1.41v.34c0 .18.06.34.16.46a2 2 0 0 1 3.78.29h4.12a2 2 0 0 1 3.78-.29c.1-.12.16-.28.16-.46V8.64c0-.45-.2-.86-.52-1.14H4.4ZM13 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl16RegularIcon, 'VehicleCarProfileRtl16Regular');

const VehicleCarProfileRtl20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.02 13.84A1.75 1.75 0 0 1 2 12.25v-1.21a2.5 2.5 0 0 1 1.86-2.42l2.09-.56L7.49 5.3A2.5 2.5 0 0 1 9.68 4h3.38a2.5 2.5 0 0 1 2.37 1.7l.82 2.48A2.5 2.5 0 0 1 18 10.56v1.69c0 .7-.42 1.32-1.02 1.6a2.5 2.5 0 0 1-4.93.15h-4.1a2.5 2.5 0 0 1-4.93-.16ZM13.06 5H12v3h3.14l-.66-1.97A1.5 1.5 0 0 0 13.06 5Zm-4.7.77L7.14 8H11V5H9.68c-.55 0-1.05.3-1.31.77ZM16 13.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm-9 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl20FilledIcon, 'VehicleCarProfileRtl20Filled');

const VehicleCarProfileRtl20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.48 6.03 15.14 8H12V5h1.06c.64 0 1.22.41 1.42 1.03Zm1 2.97.26.08.12.03A1.5 1.5 0 0 1 17 10.56v1.69c0 .16-.05.31-.14.43a2.5 2.5 0 0 0-4.81.32h-4.1a2.5 2.5 0 0 0-4.81-.32.75.75 0 0 1-.14-.43v-1.21c0-.68.46-1.28 1.11-1.45L6.31 9h9.16ZM7.12 8l1.24-2.23A1.5 1.5 0 0 1 9.67 5H11v3H7.13ZM2 12.25c0 .7.42 1.32 1.02 1.6a2.5 2.5 0 0 0 4.93.15h4.1a2.5 2.5 0 0 0 4.93-.16c.6-.27 1.02-.88 1.02-1.59v-1.69a2.5 2.5 0 0 0-1.75-2.38l-.82-2.47A2.5 2.5 0 0 0 13.06 4H9.68c-.91 0-1.75.5-2.19 1.29L5.95 8.06l-2.1.56A2.5 2.5 0 0 0 2 11.04v1.21ZM14.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl20RegularIcon, 'VehicleCarProfileRtl20Regular');

const VehicleCarProfileRtl24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.97 4c1.24 0 2.33.83 2.66 2.03l.95 3.49A2.75 2.75 0 0 1 22 12.25v2.25c0 .86-.4 1.64-1.02 2.14a3.25 3.25 0 0 1-6.32.61H9.84a3.25 3.25 0 0 1-6.25-.26A2.75 2.75 0 0 1 2 14.5v-1.69c0-1.26.86-2.36 2.08-2.67l2.19-.54 2.5-4.25c.5-.84 1.4-1.35 2.37-1.35h4.83Zm1.2 2.42a1.25 1.25 0 0 0-1.2-.92H14.5v4h3.52l-.84-3.08ZM13 9.5v-4h-1.86c-.44 0-.85.23-1.07.61l-2 3.39H13Zm4.75 5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM8.5 16.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl24FilledIcon, 'VehicleCarProfileRtl24Filled');

const VehicleCarProfileRtl24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.63 6.03A2.75 2.75 0 0 0 15.97 4h-4.83c-.97 0-1.87.51-2.37 1.35L6.27 9.6l-2.19.54A2.75 2.75 0 0 0 2 12.81v1.69c0 1.1.65 2.05 1.59 2.5a3.25 3.25 0 0 0 6.25.25h4.82a3.25 3.25 0 0 0 6.32-.61A2.74 2.74 0 0 0 22 14.5v-2.25c0-1.4-1.06-2.57-2.42-2.73l-.95-3.5Zm-8.67 9.72a3.25 3.25 0 0 0-6.27-.6c-.12-.18-.19-.4-.19-.65v-1.69c0-.57.39-1.07.95-1.21l2.4-.6h12.4c.69 0 1.25.56 1.25 1.25v2.27a3.25 3.25 0 0 0-5.96 1.23H9.96ZM13 9.5H8.07l2-3.39c.22-.38.63-.61 1.07-.61H13v4Zm1.5-4h1.47c.57 0 1.06.38 1.2.92l.85 3.08H14.5v-4Zm3.25 9a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5ZM8.5 16.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z",
    fill: primaryFill
  }));
};

export const VehicleCarProfileRtl24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleCarProfileRtl24RegularIcon, 'VehicleCarProfileRtl24Regular');

const VehicleShip16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V4h2.5c.28 0 .5.22.5.5v3.52l1.2.52a.5.5 0 0 1 .24.7l-1.15 2.06c-.21-.39-.5-.8-1.29-.8-.87 0-1.13.5-1.36.92-.16.31-.3.58-.64.58s-.48-.27-.64-.58c-.23-.42-.5-.92-1.36-.92-.87 0-1.13.5-1.36.92-.16.31-.3.58-.64.58s-.48-.27-.64-.58c-.23-.42-.5-.92-1.36-.92-.79 0-1.08.41-1.3.8L1.57 9.24a.5.5 0 0 1 .24-.7L3 8.02V4.5c0-.28.22-.5.5-.5H6V2.5Zm3 3.79 3 1.3V5H4v2.59l3-1.3a2.5 2.5 0 0 1 2 0ZM7 4h2V3H7v1Zm-2.95 9.07c.38.45 1 .93 1.94.93H6a2.5 2.5 0 0 0 2-1l.19.22c.38.4.97.78 1.8.78h-.13.14a2.48 2.48 0 0 0 2.02-1.03l.13.13c.46.47 1.2.9 2.35.9a.5.5 0 1 0 0-1c-.86 0-1.36-.32-1.65-.6a1.75 1.75 0 0 1-.38-.56.5.5 0 0 0-.95 0 2.2 2.2 0 0 1-.35.59c-.24.3-.61.57-1.17.57-.56 0-.93-.27-1.18-.57a2.2 2.2 0 0 1-.34-.59.5.5 0 0 0-.66-.31.5.5 0 0 0-.3.31l-.07.17a2.2 2.2 0 0 1-.27.42c-.25.3-.62.57-1.18.57-.56 0-.93-.27-1.18-.57a2.2 2.2 0 0 1-.32-.53l-.07-.15a.5.5 0 0 0-.27-.22.5.5 0 0 0-.6.22 1.1 1.1 0 0 0-.05.12 1.85 1.85 0 0 1-.36.52c-.3.3-.8.61-1.65.61a.5.5 0 0 0 0 1 3.2 3.2 0 0 0 2.48-1.03l.07.1Z",
    fill: primaryFill
  }));
};

export const VehicleShip16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip16FilledIcon, 'VehicleShip16Filled');

const VehicleShip16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V4h2.5c.28 0 .5.22.5.5v3.52l1.2.52a.5.5 0 0 1 .24.7l-1.15 2.06c-.15-.28-.35-.57-.74-.71l.74-1.35L8.6 7.2a1.5 1.5 0 0 0-1.19 0L2.7 9.24l.75 1.35c-.4.14-.59.43-.74.71L1.56 9.24a.5.5 0 0 1 .24-.7L3 8.02V4.5c0-.28.22-.5.5-.5H6V2.5ZM4 7.59l3-1.3a2.5 2.5 0 0 1 2 0l3 1.3V5H4v2.59ZM9 3H7v1h2V3Zm-5.4 8.7a1.1 1.1 0 0 0-.1.18 1.85 1.85 0 0 1-.36.52c-.28.28-.78.6-1.64.6a.5.5 0 0 0 0 1 3.2 3.2 0 0 0 2.48-1.03l.07.1c.38.45 1 .93 1.95.93a2.48 2.48 0 0 0 2-1l.05.07c.38.45 1 .93 1.95.93a2.48 2.48 0 0 0 2.02-1.03l.13.13c.46.47 1.2.9 2.35.9a.5.5 0 1 0 0-1c-.86 0-1.36-.32-1.65-.6a1.75 1.75 0 0 1-.38-.56.5.5 0 0 0-.95 0 2.2 2.2 0 0 1-.35.59c-.24.3-.61.57-1.17.57-.56 0-.93-.27-1.18-.57a2.2 2.2 0 0 1-.34-.59.5.5 0 0 0-.66-.31.5.5 0 0 0-.3.31l-.07.17a2.2 2.2 0 0 1-.27.42c-.25.3-.62.57-1.18.57-.56 0-.93-.27-1.18-.57a2.2 2.2 0 0 1-.32-.53l-.07-.15a.5.5 0 0 0-.27-.22.5.5 0 0 0-.56.17Z",
    fill: primaryFill
  }));
};

export const VehicleShip16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip16RegularIcon, 'VehicleShip16Regular');

const VehicleShip20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.54c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V5h2.5c.28 0 .5.22.5.5v4.06l1.63.46a.5.5 0 0 1 .32.7l-1.82 3.79a1.5 1.5 0 0 0-2.53.45V15a2.28 2.28 0 0 1-.35.57c-.26.32-.5.44-.74.44s-.48-.13-.75-.45a2.68 2.68 0 0 1-.36-.6 1.5 1.5 0 0 0-2.81.03 2.27 2.27 0 0 1-.35.57c-.26.33-.5.45-.74.45s-.48-.12-.74-.44a2.61 2.61 0 0 1-.36-.6 1.5 1.5 0 0 0-2.55-.42l-1.8-3.83a.5.5 0 0 1 .32-.7L4 9.57V5.5c0-.28.22-.5.5-.5H7V2.54Zm5 .5H8V5h4V3.04Zm3 6.25V6H5v3.28l4.2-1.16a3 3 0 0 1 1.6 0L15 9.29Zm-3.6 5.66Zm0 0Zm4.09.44v-.01a.5.5 0 0 0-.96-.06v.02a1.62 1.62 0 0 1-.12.24c-.08.17-.22.39-.4.6-.35.45-.85.82-1.51.82s-1.16-.38-1.52-.82a3.64 3.64 0 0 1-.51-.85.5.5 0 0 0-.94 0 1.75 1.75 0 0 1-.12.25c-.09.17-.22.39-.4.6-.35.45-.85.82-1.51.82s-1.16-.37-1.52-.81a3.62 3.62 0 0 1-.5-.85l-.01-.02a.5.5 0 0 0-.96.06 1.5 1.5 0 0 1-.08.24c-.07.16-.17.37-.33.58-.3.41-.8.8-1.6.8a.5.5 0 0 0 0 1 2.9 2.9 0 0 0 2.54-1.4l.17.22C5.66 17.38 6.4 18 7.5 18s1.84-.62 2.3-1.18l.2-.28.2.28A2.96 2.96 0 0 0 12.5 18a2.95 2.95 0 0 0 2.46-1.4l.14.2c.44.6 1.2 1.21 2.4 1.2a.5.5 0 1 0 0-1c-.8.01-1.3-.38-1.6-.79a2.72 2.72 0 0 1-.4-.77l-.01-.05Z",
    fill: primaryFill
  }));
};

export const VehicleShip20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip20FilledIcon, 'VehicleShip20Filled');

const VehicleShip20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2.04a.5.5 0 0 0-.5.5V5H4.5a.5.5 0 0 0-.5.5v4.06l-1.63.46a.5.5 0 0 0-.32.7l1.8 3.82c.22-.26.52-.44.86-.51l-1.5-3.2 6.25-1.75a2 2 0 0 1 1.07 0l6.26 1.74-1.54 3.2c.34.06.65.23.88.49l1.82-3.8a.5.5 0 0 0-.32-.7L16 9.57V5.5a.5.5 0 0 0-.5-.5H13V2.54a.5.5 0 0 0-.5-.5h-5ZM12 5H8V3.04h4V5Zm3 1V9.3l-4.2-1.17a3 3 0 0 0-1.6 0L5 9.28V6h10Zm.49 9.39v-.01a.5.5 0 0 0-.96-.06v.02a1.62 1.62 0 0 1-.12.24c-.08.17-.22.39-.4.6-.35.45-.85.82-1.51.82s-1.16-.38-1.52-.82a3.64 3.64 0 0 1-.51-.85.5.5 0 0 0-.94 0 1.75 1.75 0 0 1-.12.25c-.09.17-.22.39-.4.6-.35.45-.85.82-1.51.82s-1.16-.37-1.52-.81a3.62 3.62 0 0 1-.5-.85l-.01-.02a.5.5 0 0 0-.96.06 1.5 1.5 0 0 1-.08.24c-.07.16-.17.37-.33.58-.3.41-.8.8-1.6.8a.5.5 0 0 0 0 1 2.9 2.9 0 0 0 2.54-1.4l.17.22C5.66 17.38 6.4 18 7.5 18s1.84-.62 2.3-1.18l.2-.28.2.28A2.96 2.96 0 0 0 12.5 18a2.95 2.95 0 0 0 2.46-1.4l.14.2c.44.6 1.2 1.21 2.4 1.2a.5.5 0 1 0 0-1c-.8.01-1.3-.38-1.6-.79a2.72 2.72 0 0 1-.4-.77l-.01-.05Z",
    fill: primaryFill
  }));
};

export const VehicleShip20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip20RegularIcon, 'VehicleShip20Regular');

const VehicleShip24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2a.75.75 0 0 0-.75.75V5H5.75a.75.75 0 0 0-.75.75v4.76l-1.46.54a.75.75 0 0 0-.42 1.02l2.33 5.02a1.75 1.75 0 0 1 2.22 1.14l.01.03.07.16c.07.15.17.35.3.53.28.37.57.55.95.55s.67-.18.94-.55a2.83 2.83 0 0 0 .39-.72 1.75 1.75 0 0 1 3.34 0v.03l.08.16c.06.15.17.35.3.53.28.37.57.55.95.55s.67-.18.94-.55a2.86 2.86 0 0 0 .39-.72 1.75 1.75 0 0 1 2.3-1.12l2.46-5.03a.75.75 0 0 0-.42-1.03l-1.67-.6v-4.7a.75.75 0 0 0-.75-.75H16V2.75a.75.75 0 0 0-.75-.75h-6.5Zm5.75 3h-5V3.5h5V5Zm3 1.5v3.42l-4.4-1.57a3.25 3.25 0 0 0-2.2 0L6.5 9.98V6.5h11Zm1.23 12.06a.75.75 0 0 0-1.45-.03v.01a2.16 2.16 0 0 1-.12.3c-.09.2-.22.45-.42.71-.38.52-.94.95-1.74.95s-1.36-.44-1.74-.95a3.85 3.85 0 0 1-.54-1v-.02a.75.75 0 0 0-1.44 0v.01l-.02.06a3.36 3.36 0 0 1-.52.95c-.38.51-.93.95-1.74.95-.8 0-1.36-.44-1.74-.95a3.83 3.83 0 0 1-.54-1v-.02a.75.75 0 0 0-1.44.02v.01a1.62 1.62 0 0 1-.11.28c-.09.2-.22.45-.42.7-.38.49-1 .96-2 .96a.75.75 0 0 0 0 1.5A3.92 3.92 0 0 0 6 20.37l.06.08C6.6 21.19 7.56 22 9 22a3.63 3.63 0 0 0 3-1.63l.06.08C12.6 21.2 13.56 22 15 22a3.63 3.63 0 0 0 3-1.62l.06.08c.6.76 1.61 1.54 3.19 1.54a.75.75 0 0 0 0-1.5 2.42 2.42 0 0 1-2-.96 3.27 3.27 0 0 1-.52-.98Z",
    fill: primaryFill
  }));
};

export const VehicleShip24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip24FilledIcon, 'VehicleShip24Filled');

const VehicleShip24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2a.75.75 0 0 0-.75.75V5H5.75a.75.75 0 0 0-.75.75v4.76l-1.46.54a.75.75 0 0 0-.42 1.02l2.33 5.02a1.75 1.75 0 0 1 1.93.58l-2.56-5.5 6.59-2.4c.38-.15.8-.15 1.19-.01l6.77 2.42-2.62 5.34a1.75 1.75 0 0 1 1.87-.4l2.47-5.04a.75.75 0 0 0-.42-1.03l-1.67-.6v-4.7a.75.75 0 0 0-.75-.75H16V2.75a.75.75 0 0 0-.75-.75h-6.5Zm5.75 3h-5V3.5h5V5Zm3 1.5v3.42l-4.4-1.57a3.25 3.25 0 0 0-2.2 0L6.5 9.98V6.5h11Zm1.23 12.06a.75.75 0 0 0-1.45-.03v.01a2.16 2.16 0 0 1-.12.3c-.09.2-.22.45-.42.71-.38.52-.94.95-1.74.95s-1.36-.44-1.74-.95a3.85 3.85 0 0 1-.54-1v-.02a.75.75 0 0 0-1.44 0v.01l-.02.06a3.36 3.36 0 0 1-.52.95c-.38.51-.93.95-1.74.95-.8 0-1.36-.44-1.74-.95a3.83 3.83 0 0 1-.54-1v-.02a.75.75 0 0 0-1.44.02v.01a1.62 1.62 0 0 1-.11.28c-.09.2-.22.45-.42.7-.38.49-1 .96-2 .96a.75.75 0 0 0 0 1.5A3.92 3.92 0 0 0 6 20.37l.06.08C6.6 21.19 7.56 22 9 22a3.63 3.63 0 0 0 3-1.63l.06.08C12.6 21.2 13.56 22 15 22a3.63 3.63 0 0 0 3-1.62l.06.08c.6.76 1.61 1.54 3.19 1.54a.75.75 0 0 0 0-1.5 2.42 2.42 0 0 1-2-.96 3.27 3.27 0 0 1-.52-.98Z",
    fill: primaryFill
  }));
};

export const VehicleShip24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleShip24RegularIcon, 'VehicleShip24Regular');

const VehicleSubway16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-4 0A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-.62l1.87 1.07a.5.5 0 1 1-.5.86L8.87 13H7.13l-3.38 1.93a.5.5 0 0 1-.5-.86L5.12 13H4.5A2.5 2.5 0 0 1 2 10.5v-6ZM3 8h10V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V8Zm4 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleSubway16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway16FilledIcon, 'VehicleSubway16Filled');

const VehicleSubway16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-4 0A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-.62l1.87 1.07a.5.5 0 1 1-.5.86L8.87 13H7.13l-3.38 1.93a.5.5 0 0 1-.5-.86L5.12 13H4.5A2.5 2.5 0 0 1 2 10.5v-6ZM3 8v2.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V8H3Zm10-1V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V7h10Z",
    fill: primaryFill
  }));
};

export const VehicleSubway16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway16RegularIcon, 'VehicleSubway16Regular');

const VehicleSubway20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 5a.5.5 0 0 0 0 1h3a.5.5 0 1 0 0-1h-3ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-2.68 2.98l2.38 1.06a.5.5 0 1 1-.4.92L11.9 17H8.1l-4.4 1.96a.5.5 0 1 1-.4-.92l2.38-1.06A3 3 0 0 1 3 14V6Zm1 0v5h12V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm4 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleSubway20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway20FilledIcon, 'VehicleSubway20Filled');

const VehicleSubway20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.5 5a.5.5 0 0 0 0 1h3a.5.5 0 1 0 0-1h-3ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-2.68 2.98l2.38 1.06a.5.5 0 1 1-.4.92L11.9 17H8.1l-4.4 1.96a.5.5 0 1 1-.4-.92l2.38-1.06A3 3 0 0 1 3 14V6Zm9.01 10H14a2 2 0 0 0 2-2v-2H4v2c0 1.1.9 2 2 2h6.01ZM4 6v5h12V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Z",
    fill: primaryFill
  }));
};

export const VehicleSubway20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway20RegularIcon, 'VehicleSubway20Regular');

const VehicleSubway24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 3A3.75 3.75 0 0 1 20 6.75v9a3.75 3.75 0 0 1-2.89 3.65l2.46 1.17a.75.75 0 0 1-.55 1.4l-.1-.04-5.09-2.43h-3.66l-5.1 2.43a.75.75 0 1 1-.64-1.36l2.46-1.17A3.75 3.75 0 0 1 4 15.75v-9A3.75 3.75 0 0 1 7.75 3h8.5ZM8 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm.25-10.5h-8.5c-1.24 0-2.25 1-2.25 2.25v5.75h13V6.75c0-1.24-1-2.25-2.25-2.25Zm-3 1.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h2.5Z",
    fill: primaryFill
  }));
};

export const VehicleSubway24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway24FilledIcon, 'VehicleSubway24Filled');

const VehicleSubway24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 3A3.75 3.75 0 0 1 20 6.75v9a3.75 3.75 0 0 1-2.89 3.65l2.46 1.17a.75.75 0 0 1-.55 1.4l-.1-.04-5.09-2.43h-3.66l-5.1 2.43a.75.75 0 1 1-.64-1.36l2.46-1.17A3.75 3.75 0 0 1 4 15.75v-9A3.75 3.75 0 0 1 7.75 3h8.5Zm2.25 11h-13v1.75c0 1.24 1 2.25 2.25 2.25h8.5c1.24 0 2.25-1 2.25-2.25V14ZM8 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm.25-10.5h-8.5c-1.24 0-2.25 1-2.25 2.25v5.75h13V6.75c0-1.24-1-2.25-2.25-2.25Zm-3 1.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h2.5Z",
    fill: primaryFill
  }));
};

export const VehicleSubway24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleSubway24RegularIcon, 'VehicleSubway24Regular');

const VehicleTruck16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 2.7C1 1.76 1.76 1 2.7 1h10.6c.94 0 1.7.76 1.7 1.7V12a1 1 0 0 1-1 1V7.8c0-.25-.04-.5-.11-.74l-.72-2.3A2.5 2.5 0 0 0 10.78 3H5.22a2.5 2.5 0 0 0-2.39 1.75l-.72 2.31c-.07.24-.11.5-.11.75V13a1 1 0 0 1-1-1V2.7Zm12 11c0 .72-.58 1.3-1.3 1.3h-1.4A1.3 1.3 0 0 1 9 13.7V13H7v.7c0 .72-.58 1.3-1.3 1.3H4.3A1.3 1.3 0 0 1 3 13.7V7.8c0-.15.02-.3.07-.44l.72-2.3.02-.07C4.02 4.4 4.58 4 5.22 4h5.56c.64 0 1.2.4 1.41 1l.02.06.72 2.3c.05.14.07.3.07.45v5.89ZM6 13H4v.7c0 .17.13.3.3.3h1.4a.3.3 0 0 0 .3-.3V13Zm6 0h-2v.7c0 .17.13.3.3.3h1.4a.3.3 0 0 0 .3-.3V13ZM4.8 5.2 4.2 7h7.6l-.6-1.8a.3.3 0 0 0-.28-.2H5.08a.3.3 0 0 0-.29.2Zm.95 4.8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM11 9.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM7.5 10a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
    fill: primaryFill
  }));
};

export const VehicleTruck16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck16FilledIcon, 'VehicleTruck16Filled');

const VehicleTruck16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 9.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm3.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM7 10.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM2.7 1C1.76 1 1 1.76 1 2.7v9c0 .72.58 1.3 1.3 1.3H3v.7c0 .72.58 1.3 1.3 1.3h1.4c.72 0 1.3-.58 1.3-1.3V13h2v.7c0 .72.58 1.3 1.3 1.3h1.4c.72 0 1.3-.58 1.3-1.3V13h.7c.72 0 1.3-.58 1.3-1.3v-9c0-.94-.76-1.7-1.7-1.7H2.7ZM10 13.7V13h2v.7a.3.3 0 0 1-.3.3h-1.4a.3.3 0 0 1-.3-.3ZM6 13v.7a.3.3 0 0 1-.3.3H4.3a.3.3 0 0 1-.3-.3V13h2ZM2 2.7c0-.39.31-.7.7-.7h10.6c.39 0 .7.31.7.7v9a.3.3 0 0 1-.3.3H13V7.76c0-.23-.04-.45-.1-.66l-.74-2.21A1.3 1.3 0 0 0 10.92 4H5.08a1.3 1.3 0 0 0-1.24.89l-.73 2.2c-.07.22-.11.44-.11.67V12h-.7a.3.3 0 0 1-.3-.3v-9ZM4 12V8h8v4H4Zm.2-5 .6-1.8a.3.3 0 0 1 .28-.2h5.84a.3.3 0 0 1 .29.2l.6 1.8H4.19Z",
    fill: primaryFill
  }));
};

export const VehicleTruck16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck16RegularIcon, 'VehicleTruck16Regular');

const VehicleTruck20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1V9.8c0-.25.04-.5.1-.72L4.16 5.6A2.25 2.25 0 0 1 6.3 4h7.4c1 0 1.87.65 2.15 1.6l1.04 3.48c.07.23.11.47.11.71V16a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2H4Zm12 7.8v6.7c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V16H8v.5c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0 1 4 16.5V9.8c0-.15.02-.3.06-.44L5.1 5.9c.16-.53.65-.89 1.2-.89h7.4c.55 0 1.04.36 1.2.9l1.04 3.46c.04.14.06.29.06.43ZM5 16.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16H5v.5ZM14.86 9l-.66-2.62a.5.5 0 0 0-.48-.38H6.28a.5.5 0 0 0-.48.38L5.14 9h9.72ZM13 16.5c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V16h-2v.5ZM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-5.5 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z",
    fill: primaryFill
  }));
};

export const VehicleTruck20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck20FilledIcon, 'VehicleTruck20Filled');

const VehicleTruck20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-5 .5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4 2a2 2 0 0 0-2 2v10.5c0 .83.67 1.5 1.5 1.5H4v.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V16h4v.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V16h.5c.83 0 1.5-.67 1.5-1.5V4a2 2 0 0 0-2-2H4Zm9 14.5V16h2v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5ZM7 16v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V16h2ZM3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v10.5a.5.5 0 0 1-.5.5H16V9.75c0-.2-.03-.41-.07-.61l-.76-3A1.5 1.5 0 0 0 13.72 5H6.28a1.5 1.5 0 0 0-1.45 1.14l-.76 3c-.04.2-.07.4-.07.6V15h-.5a.5.5 0 0 1-.5-.5V4Zm2 11v-5h10v5H5Zm.14-6 .66-2.62A.5.5 0 0 1 6.28 6h7.44a.5.5 0 0 1 .48.38L14.86 9H5.14Z",
    fill: primaryFill
  }));
};

export const VehicleTruck20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck20RegularIcon, 'VehicleTruck20Regular');

const VehicleTruck24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.25C3 4.01 4 3 5.25 3h13.5C19.99 3 21 4 21 5.25v13.5c0 .41-.34.75-.75.75h-1v-8.25c0-.1-.01-.22-.04-.33l-.73-3.32a3 3 0 0 0-2.93-2.35h-7.1A3 3 0 0 0 5.52 7.6l-.73 3.32c-.03.11-.04.22-.04.33v8.25h-1a.75.75 0 0 1-.75-.75V5.25ZM8.45 6c-1.05 0-1.96.73-2.2 1.76l-.73 3.33a.75.75 0 0 0-.02.16v9c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-.75h3v.75c0 .97.78 1.75 1.75 1.75h1.5c.97 0 1.75-.78 1.75-1.75v-9c0-.05 0-.1-.02-.16l-.74-3.33A2.25 2.25 0 0 0 15.54 6H8.46Zm-.73 2.09a.75.75 0 0 1 .73-.59h7.1c.35 0 .65.24.73.59l.54 2.41H7.18l.54-2.41ZM7 20.25v-.75h2v.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm10-.75v.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.75h2Zm-6.25-3h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5Zm-.74-2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const VehicleTruck24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck24FilledIcon, 'VehicleTruck24Filled');

const VehicleTruck24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5.25 1.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5ZM3 5.25C3 4.01 4 3 5.25 3h13.5C19.99 3 21 4 21 5.25v13.5c0 .41-.34.75-.75.75H18.5v.75c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75v-.75h-3v.75c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75v-.75H3.75a.75.75 0 0 1-.75-.75V5.25Zm6 15v-.75H7v.75c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25ZM7 18h10v-6H7v6Zm8 1.5v.75c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25v-.75h-2Zm4.5-1.5V5.25a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75V18h1v-6.75c0-.05 0-.1.02-.16l.74-3.33A2.25 2.25 0 0 1 8.46 6h7.09c1.05 0 1.96.73 2.2 1.76l.73 3.33.02.16V18h1ZM8.45 7.5a.75.75 0 0 0-.73.59l-.54 2.41h9.64l-.54-2.41a.75.75 0 0 0-.73-.59h-7.1Z",
    fill: primaryFill
  }));
};

export const VehicleTruck24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruck24RegularIcon, 'VehicleTruck24Regular');

const VehicleTruckBag20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 1a2 2 0 0 1 1 .27A2 2 0 0 1 8 3v1h.5c.28 0 .5.22.5.5V9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4.5c0-.28.22-.5.5-.5H2V3c0-1.1.9-2 2-2ZM3 4h2V3a1 1 0 0 0-2 0v1Zm3-1v1h1V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 6 3Zm3 .09V3h3.25c.97 0 1.75.78 1.75 1.75V6h.88c.57 0 1.09.32 1.34.83l1.62 3.24c.1.2.16.43.16.67v3.76c0 .83-.67 1.5-1.5 1.5h-1.55a2.5 2.5 0 0 1-4.9 0h-1.1a2.5 2.5 0 0 1-4.9 0H3.8c-.96 0-1.75-.78-1.75-1.75v-2.4c.3.1.63.15.96.15h4a3 3 0 0 0 3-3V4.5c0-.65-.42-1.2-1-1.41ZM14 7v3h2.7l-1.37-2.72a.5.5 0 0 0-.45-.28H14Zm-7.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4.5 1.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckBag20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckBag20FilledIcon, 'VehicleTruckBag20Filled');

const VehicleTruckBag20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 1a2 2 0 0 1 1 .27A2 2 0 0 1 8 3v1h.5c.28 0 .5.22.5.5V9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4.5c0-.28.22-.5.5-.5H2V3c0-1.1.9-2 2-2ZM3 4h2V3a1 1 0 0 0-2 0v1Zm3-1v1h1V3a1 1 0 0 0-1.25-.97A2 2 0 0 1 6 3Zm3 .09V3h3.25c.97 0 1.75.78 1.75 1.75V6h.88c.57 0 1.09.32 1.34.83l1.62 3.24c.1.2.16.43.16.67v3.76c0 .83-.67 1.5-1.5 1.5h-1.55a2.5 2.5 0 0 1-4.9 0h-1.1a2.5 2.5 0 0 1-4.9 0H3.8c-.96 0-1.75-.78-1.75-1.75v-2.4c.3.1.63.15.96.15h.04v2.25c0 .41.34.75.75.75h.26a2.5 2.5 0 0 1 4.9 0h1.1A2.5 2.5 0 0 1 13 13.05v-8.3a.75.75 0 0 0-.75-.75H9.91A1.5 1.5 0 0 0 9 3.09Zm5 10.41c.48.36.83.89.95 1.5h1.55a.5.5 0 0 0 .5-.5V11h-3v2.5Zm0-3.5h2.7l-1.37-2.72a.5.5 0 0 0-.45-.28H14v3Zm-7.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4.5 1.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckBag20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckBag20RegularIcon, 'VehicleTruckBag20Regular');

const VehicleTruckBag24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.75 4.5a.75.75 0 0 0-.75.75v6c0 1.24 1 2.25 2.25 2.25h5c1.24 0 2.25-1 2.25-2.25v-6a.75.75 0 0 0-.75-.75H9.5v-1a2.5 2.5 0 0 0-3.75-2.17A2.5 2.5 0 0 0 2 3.5v1h-.25ZM7 4.5v-1c0-.35-.07-.68-.2-.98A1 1 0 0 1 8 3.5v1H7Zm-1.5-1v1h-2v-1a1 1 0 0 1 2 0ZM2 17.25v-3c.38.16.8.25 1.25.25h5c1.8 0 3.25-1.46 3.25-3.25v-6c0-.7-.4-1.3-1-1.58V3.5c0-.17-.01-.34-.04-.5h3.79c1.24 0 2.25 1 2.25 2.25V6h1.55c.87 0 1.66.5 2.03 1.29l1.7 3.58c.15.3.22.63.22.97v5.41c0 1.24-1 2.25-2.25 2.25h-1.8a3 3 0 0 1-5.9 0h-2.1a3 3 0 0 1-5.91-.01A2.25 2.25 0 0 1 2 17.25Zm18.5-1.75h-1.25a.75.75 0 1 0 0 1.5h1.25v-1.5Zm-.32-4.5-1.45-3.07a.75.75 0 0 0-.68-.43H16.5V11h3.68ZM7 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.5-1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM3.5 3.5a1 1 0 0 1 .08-.4Z",
    fill: primaryFill
  }));
};

export const VehicleTruckBag24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckBag24FilledIcon, 'VehicleTruckBag24Filled');

const VehicleTruckBag24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.75 4.5a.75.75 0 0 0-.75.75v6c0 1.24 1 2.25 2.25 2.25h5c1.24 0 2.25-1 2.25-2.25v-6a.75.75 0 0 0-.75-.75H9.5v-1a2.5 2.5 0 0 0-3.75-2.17A2.5 2.5 0 0 0 2 3.5v1h-.25ZM7 4.5v-1c0-.35-.07-.68-.2-.98A1 1 0 0 1 8 3.5v1H7Zm-1.5-1v1h-2v-1a1 1 0 0 1 2 0ZM2 17.25v-3c.38.16.8.25 1.25.25h.25v2.75c0 .39.3.7.67.75a3 3 0 0 1 5.66 0h2.34A3 3 0 0 1 15 16V5.25a.75.75 0 0 0-.75-.75h-2.92a1.76 1.76 0 0 0-.83-.83V3.5c0-.17-.01-.34-.04-.5h3.79c1.24 0 2.25 1 2.25 2.25V6h1.55c.87 0 1.66.5 2.03 1.29l1.7 3.58c.15.3.22.63.22.97v5.41c0 1.24-1 2.25-2.25 2.25h-1.8a3 3 0 0 1-5.9 0h-2.1a3 3 0 0 1-5.91-.01A2.25 2.25 0 0 1 2 17.25Zm15.83.75h1.92c.41 0 .75-.34.75-.75V17h-1.25a.75.75 0 0 1 0-1.5h1.25v-3h-4v3.9c.61.36 1.09.92 1.33 1.6ZM16.5 7.5V11h3.68l-1.45-3.07a.75.75 0 0 0-.68-.43H16.5ZM7 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.5-1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM3.5 3.5a1 1 0 0 1 .08-.4Z",
    fill: primaryFill
  }));
};

export const VehicleTruckBag24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckBag24RegularIcon, 'VehicleTruckBag24Regular');

const VehicleTruckCube20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.04 9.89v4.36c0 .97.79 1.75 1.75 1.75h.26a2.5 2.5 0 0 0 4.9 0h1.1a2.5 2.5 0 0 0 4.9 0h1.55c.83 0 1.5-.67 1.5-1.5v-3.76c0-.24-.05-.47-.16-.67l-1.62-3.24A1.5 1.5 0 0 0 14.88 6H14V4.75C14 3.78 13.22 3 12.25 3h-2.1a2 2 0 0 1 .35 1.12v3.76a2 2 0 0 1-1.1 1.8l-3 1.5a2 2 0 0 1-1.8 0l-2.56-1.3ZM14 7h.88c.2 0 .36.1.45.28L16.69 10H14V7Zm-7.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM1.5 4.12v3.76a1 1 0 0 0 .55.9l3 1.5a1 1 0 0 0 .9 0l3-1.5a1 1 0 0 0 .55-.9V4.12a1 1 0 0 0-.55-.9l-3-1.5a1 1 0 0 0-.9 0l-3 1.5a1 1 0 0 0-.55.9Zm1.7-.08 2.3.97 2.3-.97a.5.5 0 0 1 .4.92L6 5.9V8.5a.5.5 0 1 1-1 0V5.89l-2.2-.93a.5.5 0 1 1 .4-.92Z",
    fill: primaryFill
  }));
};

export const VehicleTruckCube20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckCube20FilledIcon, 'VehicleTruckCube20Filled');

const VehicleTruckCube20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.5 7.88V4.12a1 1 0 0 1 .55-.9l3-1.5a1 1 0 0 1 .9 0l3 1.5a1 1 0 0 1 .55.9v3.76a1 1 0 0 1-.55.9l-3 1.5a1 1 0 0 1-.9 0l-3-1.5a1 1 0 0 1-.55-.9Zm1.04-3.57a.5.5 0 0 0 .27.65L5 5.9V8.5a.5.5 0 1 0 1 0V5.89l2.2-.93a.5.5 0 0 0-.4-.92l-2.3.97-2.3-.97a.5.5 0 0 0-.66.27Zm-.5 9.94V9.89l1 .5v3.86c0 .41.34.75.75.75h.26a2.5 2.5 0 0 1 4.9 0h1.1A2.5 2.5 0 0 1 13 13.05v-8.3a.75.75 0 0 0-.75-.75H10.5a2 2 0 0 0-.34-1h2.1c.96 0 1.74.78 1.74 1.75V6h.88c.57 0 1.09.32 1.34.83l1.62 3.24c.1.2.16.43.16.67v3.76c0 .83-.67 1.5-1.5 1.5h-1.55a2.5 2.5 0 0 1-4.9 0h-1.1a2.5 2.5 0 0 1-4.9 0H3.8c-.96 0-1.75-.78-1.75-1.75Zm12.91.75h1.55a.5.5 0 0 0 .5-.5V11h-3v2.5c.48.36.83.89.95 1.5Zm1.74-5-1.36-2.72a.5.5 0 0 0-.45-.28H14v3h2.7ZM5 15.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: primaryFill
  }));
};

export const VehicleTruckCube20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckCube20RegularIcon, 'VehicleTruckCube20Regular');

const VehicleTruckCube24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 8.57V4.43c0-.57.32-1.09.83-1.34l3.5-1.75a1.5 1.5 0 0 1 1.34 0l3.5 1.75c.5.25.83.77.83 1.34v4.14a1.5 1.5 0 0 1-.83 1.35l-3.5 1.75a1.5 1.5 0 0 1-1.34 0l-3.5-1.75A1.5 1.5 0 0 1 1 8.57Zm1.55-4.04a.5.5 0 0 0 .23.67L5.5 6.56V9.5a.5.5 0 1 0 1 0V6.56L9.22 5.2a.5.5 0 1 0-.44-.9L6 5.7 3.22 4.3a.5.5 0 0 0-.67.23Zm9-1.53c.29.41.45.9.45 1.43v4.14a2.5 2.5 0 0 1-1.38 2.24l-3.5 1.75a2.5 2.5 0 0 1-2.24 0L2 11.12v6.13c0 1.17.9 2.13 2.04 2.24a3 3 0 0 0 5.92.01h2.08a3 3 0 0 0 5.92 0h1.79c1.24 0 2.25-1 2.25-2.25v-5.41c0-.34-.07-.66-.22-.97l-1.7-3.58A2.25 2.25 0 0 0 18.05 6H16.5v-.75c0-1.24-1-2.25-2.25-2.25h-2.7Zm7.7 12.5h1.25V17h-1.25a.75.75 0 1 1 0-1.5Zm-.52-7.57L20.18 11H16.5V7.5h1.55c.3 0 .55.17.68.43ZM8.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.5-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: primaryFill
  }));
};

export const VehicleTruckCube24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckCube24FilledIcon, 'VehicleTruckCube24Filled');

const VehicleTruckCube24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 8.57V4.43c0-.57.32-1.09.83-1.34l3.5-1.75a1.5 1.5 0 0 1 1.34 0l3.5 1.75c.5.25.83.77.83 1.34v4.14a1.5 1.5 0 0 1-.83 1.35l-3.5 1.75a1.5 1.5 0 0 1-1.34 0l-3.5-1.75A1.5 1.5 0 0 1 1 8.57Zm1.55-4.04a.5.5 0 0 0 .23.67L5.5 6.56V9.5a.5.5 0 1 0 1 0V6.56L9.22 5.2a.5.5 0 1 0-.44-.9L6 5.7 3.22 4.3a.5.5 0 0 0-.67.23Zm.95 7.34v5.38c0 .39.3.7.67.75a3 3 0 0 1 5.66 0h2.34A3 3 0 0 1 15 16V5.25a.75.75 0 0 0-.75-.75H12v-.07A2.5 2.5 0 0 0 11.55 3h2.7c1.24 0 2.25 1 2.25 2.25V6h1.55c.87 0 1.66.5 2.03 1.29l1.7 3.58c.15.3.22.63.22.97v5.41c0 1.24-1 2.25-2.25 2.25h-1.8a3 3 0 0 1-5.9 0h-2.1a3 3 0 0 1-5.91 0A2.25 2.25 0 0 1 2 17.24v-6.13l1.5.75Zm13 4.53c.61.36 1.09.92 1.33 1.6h1.92c.41 0 .75-.34.75-.75V17h-1.25a.75.75 0 1 1 0-1.5h1.25v-3h-4v3.9Zm1.55-8.9H16.5V11h3.68l-1.45-3.07a.75.75 0 0 0-.68-.43ZM5.5 19a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm9.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: primaryFill
  }));
};

export const VehicleTruckCube24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckCube24RegularIcon, 'VehicleTruckCube24Regular');

const VehicleTruckProfile16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.75C2 2.78 2.78 2 3.75 2h5.5c.97 0 1.75.78 1.75 1.75V4h.38c.57 0 1.09.32 1.34.83l1.12 2.24c.1.2.16.43.16.67V11c0 .83-.67 1.5-1.5 1.5h-.56a2 2 0 0 1-3.88 0H6.94a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 2 10.75v-7ZM11 5v2h1.7l-.87-1.72a.5.5 0 0 0-.45-.28H11Zm-6 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile16FilledIcon, 'VehicleTruckProfile16Filled');

const VehicleTruckProfile16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.75C2 2.78 2.78 2 3.75 2h5.5c.97 0 1.75.78 1.75 1.75V4h.38c.57 0 1.09.32 1.34.83l1.12 2.24c.1.2.16.43.16.67V11c0 .83-.67 1.5-1.5 1.5h-.56a2 2 0 0 1-3.88 0H6.94a2 2 0 0 1-3.91-.15A1.75 1.75 0 0 1 2 10.75v-7Zm6.06 7.75A2 2 0 0 1 10 10V3.75A.75.75 0 0 0 9.25 3h-5.5a.75.75 0 0 0-.75.75v7c0 .18.06.34.16.46a2 2 0 0 1 3.78.29h1.12ZM11 10.27c.46.26.8.7.94 1.23h.56a.5.5 0 0 0 .5-.5V8h-2v2.27ZM11 7h1.7l-.87-1.72a.5.5 0 0 0-.45-.28H11v2Zm-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile16RegularIcon, 'VehicleTruckProfile16Regular');

const VehicleTruckProfile20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.04 4.75C2.04 3.78 2.83 3 3.8 3h8.46c.97 0 1.75.78 1.75 1.75V6h.88c.57 0 1.09.32 1.34.83l1.62 3.24c.1.2.16.43.16.67v3.76c0 .83-.67 1.5-1.5 1.5h-1.55a2.5 2.5 0 0 1-4.9 0h-1.1a2.5 2.5 0 0 1-4.9 0H3.8c-.96 0-1.75-.78-1.75-1.75v-9.5ZM14 7v3h2.7l-1.37-2.72a.5.5 0 0 0-.45-.28H14Zm-7.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4.5 1.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile20FilledIcon, 'VehicleTruckProfile20Filled');

const VehicleTruckProfile20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.04 4.75C2.04 3.78 2.83 3 3.8 3h8.46c.97 0 1.75.78 1.75 1.75V6h.88c.57 0 1.09.32 1.34.83l1.62 3.24c.1.2.16.43.16.67v3.76c0 .83-.67 1.5-1.5 1.5h-1.55a2.5 2.5 0 0 1-4.9 0h-1.1a2.5 2.5 0 0 1-4.9 0H3.8c-.96 0-1.75-.78-1.75-1.75v-9.5ZM10.05 15A2.5 2.5 0 0 1 13 13.05v-8.3a.75.75 0 0 0-.75-.75H3.79a.75.75 0 0 0-.75.75v9.5c0 .41.34.75.75.75h.26a2.5 2.5 0 0 1 4.9 0h1.1ZM14 13.5c.48.36.83.89.95 1.5h1.55a.5.5 0 0 0 .5-.5V11h-3v2.5Zm0-3.5h2.7l-1.37-2.72a.5.5 0 0 0-.45-.28H14v3Zm-7.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4.5 1.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile20RegularIcon, 'VehicleTruckProfile20Regular');

const VehicleTruckProfile24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.25C2 4.01 3 3 4.25 3h10c1.24 0 2.25 1 2.25 2.25V6h1.55c.87 0 1.66.5 2.03 1.29l1.7 3.58c.15.3.22.63.22.97v5.41c0 1.24-1 2.25-2.25 2.25h-1.8a3 3 0 0 1-5.9 0h-2.1a3 3 0 0 1-5.91-.01A2.25 2.25 0 0 1 2 17.25v-12ZM20.5 15.5h-1.25a.75.75 0 1 0 0 1.5h1.25v-1.5Zm-.32-4.5-1.45-3.07a.75.75 0 0 0-.68-.43H16.5V11h3.68ZM7 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.5-1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile24FilledIcon, 'VehicleTruckProfile24Filled');

const VehicleTruckProfile24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.25 3C3.01 3 2 4 2 5.25v12c0 1.17.9 2.13 2.04 2.24a3 3 0 0 0 5.92.01h2.08a3 3 0 0 0 5.92 0h1.79c1.24 0 2.25-1 2.25-2.25v-5.41c0-.34-.07-.66-.22-.97l-1.7-3.58A2.25 2.25 0 0 0 18.05 6H16.5v-.75c0-1.24-1-2.25-2.25-2.25h-10Zm13.58 15a3.01 3.01 0 0 0-1.33-1.6v-3.9h4v3h-1.25a.75.75 0 1 0 0 1.5h1.25v.25c0 .41-.34.75-.75.75h-1.92ZM15 16a3 3 0 0 0-2.83 2H9.83a3 3 0 0 0-5.66 0 .75.75 0 0 1-.67-.75v-12c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75V16Zm1.5-8.5h1.55c.3 0 .55.17.68.43L20.18 11H16.5V7.5ZM7 20.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: primaryFill
  }));
};

export const VehicleTruckProfile24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VehicleTruckProfile24RegularIcon, 'VehicleTruckProfile24Regular');

const Video16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2.5A2.5 2.5 0 0 0 1 5v6a2.5 2.5 0 0 0 2.5 2.5h5A2.5 2.5 0 0 0 11 11V5a2.5 2.5 0 0 0-2.5-2.5h-5Zm10.68 1.61L12 5.9v4.22l2.18 1.78a.5.5 0 0 0 .82-.4v-7a.5.5 0 0 0-.82-.38Z",
    fill: primaryFill
  }));
};

export const Video16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video16FilledIcon, 'Video16Filled');

const Video16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 2 11V5Zm1.5-2.5A2.5 2.5 0 0 0 1 5v6a2.5 2.5 0 0 0 2.5 2.5h6A2.5 2.5 0 0 0 12 11v-.5l1.8 1.35c.5.37 1.2.02 1.2-.6v-6.5c0-.61-.7-.97-1.2-.6L12 5.5V5a2.5 2.5 0 0 0-2.5-2.5h-6ZM12 6.75l2-1.5v5.5l-2-1.5v-2.5Z",
    fill: primaryFill
  }));
};

export const Video16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video16RegularIcon, 'Video16Regular');

const Video20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6.5A2.5 2.5 0 0 0 10.5 4h-6A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6a2.5 2.5 0 0 0 2.5-2.5v-7Zm1 1.43v4.15l2.76 2.35a.75.75 0 0 0 1.24-.57V6.2a.75.75 0 0 0-1.23-.57L14 7.93Z",
    fill: primaryFill
  }));
};

export const Video20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video20FilledIcon, 'Video20Filled');

const Video20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h7a2.5 2.5 0 0 0 2.5-2.5v-1l2.4 1.8a1 1 0 0 0 1.6-.8v-7a1 1 0 0 0-1.6-.8L14 7.5v-1A2.5 2.5 0 0 0 11.5 4h-7ZM14 8.75l3-2.25v7l-3-2.25v-2.5ZM13 6.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h7c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const Video20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video20RegularIcon, 'Video20Regular');

const Video24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 16.25c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 2 16.25v-8.5C2 5.95 3.46 4.5 5.25 4.5h7.5c1.8 0 3.25 1.46 3.25 3.25v8.5Zm5.76-10.36a1 1 0 0 1 .24.65v10.92a1 1 0 0 1-1.65.76L17 15.37V8.63l3.35-2.85a1 1 0 0 1 1.41.11Z",
    fill: primaryFill
  }));
};

export const Video24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video24FilledIcon, 'Video24Filled');

const Video24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 4.5c1.8 0 3.25 1.46 3.25 3.25v.17l3.86-2.31a.75.75 0 0 1 1.14.64v11.5c0 .58-.64.94-1.14.64L17 16.07v.18c0 1.8-1.46 3.25-3.25 3.25h-8.5A3.25 3.25 0 0 1 2 16.25v-8.5C2 5.95 3.46 4.5 5.25 4.5h8.5Zm0 1.5h-8.5c-.97 0-1.75.78-1.75 1.75v8.5c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75v-8.5c0-.97-.78-1.75-1.75-1.75Zm6.75 1.57L17 9.67v4.66l3.5 2.1V7.57Z",
    fill: primaryFill
  }));
};

export const Video24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video24RegularIcon, 'Video24Regular');

const Video28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 5.5A3.25 3.25 0 0 0 2 8.75v10.5c0 1.8 1.46 3.25 3.25 3.25h9.5c1.8 0 3.25-1.46 3.25-3.25V8.75c0-1.8-1.46-3.25-3.25-3.25h-9.5Zm17.87 15.14L19.5 17.1V11l3.61-3.62a1.25 1.25 0 0 1 2.14.88v11.5c0 1.1-1.34 1.67-2.13.9Z",
    fill: primaryFill
  }));
};

export const Video28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video28FilledIcon, 'Video28Filled');

const Video28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 5.5A3.25 3.25 0 0 0 2 8.75v10.5c0 1.8 1.46 3.25 3.25 3.25h10.5c1.8 0 3.25-1.46 3.25-3.25v-1.58l4.54 3.11c.83.57 1.96-.02 1.96-1.03V8.25c0-1-1.13-1.6-1.96-1.03L19 10.32V8.76c0-1.8-1.45-3.25-3.25-3.25H5.25ZM19 15.85v-3.7l5-3.43v10.56l-5-3.43Zm-1.5-7.1v10.5c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75V8.75C3.5 7.78 4.28 7 5.25 7h10.5c.97 0 1.75.78 1.75 1.75Z",
    fill: primaryFill
  }));
};

export const Video28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video28RegularIcon, 'Video28Regular');

const Video32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.5 10A4.5 4.5 0 0 0 16 5.5H6.5A4.5 4.5 0 0 0 2 10v12a4.5 4.5 0 0 0 4.5 4.5H16a4.5 4.5 0 0 0 4.5-4.5V10Zm1.5 9.8 5.01 3.76c1.23.92 2.99.05 2.99-1.5V9.94a1.87 1.87 0 0 0-2.99-1.49L22 12.2v7.6Z",
    fill: primaryFill
  }));
};

export const Video32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video32FilledIcon, 'Video32Filled');

const Video32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 5.5A4.5 4.5 0 0 0 2 10v12a4.5 4.5 0 0 0 4.5 4.5h12A4.5 4.5 0 0 0 23 22v-1.5l4.2 3.15c1.15.87 2.8.04 2.8-1.4V9.75a1.75 1.75 0 0 0-2.8-1.4L23 11.5V10a4.5 4.5 0 0 0-4.5-4.5h-12ZM23 14l5-3.75v11.5L23 18v-4Zm-2-4v12a2.5 2.5 0 0 1-2.5 2.5h-12A2.5 2.5 0 0 1 4 22V10a2.5 2.5 0 0 1 2.5-2.5h12A2.5 2.5 0 0 1 21 10Z",
    fill: primaryFill
  }));
};

export const Video32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video32RegularIcon, 'Video32Regular');

const Video36020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.97 4.02A1.7 1.7 0 0 0 2 5.7v8.6a1.7 1.7 0 0 0 1.97 1.68 37.94 37.94 0 0 1 12.25.02A1.7 1.7 0 0 0 18 14.3V5.7a1.7 1.7 0 0 0-1.97-1.68c-4 .64-8.07.64-12.06 0ZM16 14.96c-1-.15-2-.27-3-.35V12h2a1 1 0 0 1 1 1v1.96Zm-4-.41a38.84 38.84 0 0 0-4 0V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2.55Zm-5 .06c-1 .08-2 .2-3 .35V13a1 1 0 0 1 1-1h2v2.61ZM10 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const Video36020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video36020FilledIcon, 'Video36020Filled');

const Video36020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3.97 4.02A1.7 1.7 0 0 0 2 5.7v8.6a1.7 1.7 0 0 0 1.97 1.68c4-.65 8.07-.65 12.06 0A1.7 1.7 0 0 0 18 14.3V5.7a1.7 1.7 0 0 0-1.97-1.68c-4 .64-8.07.64-12.06 0ZM3 5.7a.7.7 0 0 1 .81-.7c4.1.67 8.28.67 12.38 0a.7.7 0 0 1 .81.7v8.6a.7.7 0 0 1-.81.7 31.2 31.2 0 0 0-.19-.04V13a1 1 0 0 0-1-1h-2v2.61l-1-.06V12a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2.55l-1 .06V12H5a1 1 0 0 0-1 1v1.96l-.19.03A.7.7 0 0 1 3 14.3V5.7Z",
    fill: primaryFill
  }));
};

export const Video36020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video36020RegularIcon, 'Video36020Regular');

const Video36024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.7 4.02c-1.38-.2-2.7.85-2.7 2.3v11.36c0 1.45 1.32 2.5 2.7 2.3l.63-.08a54.28 54.28 0 0 1 13.98.08c1.37.2 2.69-.86 2.69-2.3V6.32c0-1.45-1.32-2.5-2.7-2.3-1.57.22-4.1.48-7.3.48s-5.73-.26-7.3-.48ZM19 18.42c-.93-.11-2.11-.23-3.5-.32V15H18a1 1 0 0 1 1 1v2.43Zm-5-.39a59.06 59.06 0 0 0-4 0V15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3.03Zm-5.5.07c-1.39.09-2.57.2-3.5.33V16a1 1 0 0 1 1-1h2.5v3.1ZM12 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-3.5-.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm10 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: primaryFill
  }));
};

export const Video36024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video36024FilledIcon, 'Video36024Filled');

const Video36024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm10 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2 6.32c0-1.45 1.32-2.5 2.7-2.3 1.57.22 4.1.48 7.3.48s5.73-.26 7.3-.48c1.38-.2 2.7.85 2.7 2.3v11.36c0 1.45-1.32 2.5-2.7 2.3a53.3 53.3 0 0 0-7.3-.48c-3.19 0-5.73.26-7.3.48-1.38.2-2.7-.86-2.7-2.3V6.32Zm2.48-.82c-.52-.07-.98.34-.98.82v11.36c0 .48.46.9.98.82l.52-.07V16a1 1 0 0 1 1-1h2.5v3.1l1.5-.07V15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3.03l1.5.07V15H18a1 1 0 0 1 1 1v2.43l.52.07c.52.07.98-.34.98-.82V6.32c0-.48-.46-.9-.98-.82-1.64.23-4.25.5-7.52.5-3.27 0-5.88-.27-7.52-.5Z",
    fill: primaryFill
  }));
};

export const Video36024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video36024RegularIcon, 'Video36024Regular');

const Video360Off20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l1.18 1.19A1.7 1.7 0 0 0 2 5.7v8.6a1.7 1.7 0 0 0 1.97 1.68 37.94 37.94 0 0 1 11.17-.13l2 2a.5.5 0 0 0 .71-.7l-15-15ZM14 14.7l-.99-.09v-.9l1 1Zm-1.99-2v1.85a38.84 38.84 0 0 0-4 0V12a1 1 0 0 1 1-1h1.3l1.7 1.7Zm-8 2.26V13a1 1 0 0 1 1-1h2v2.61c-1 .08-2 .2-3 .35ZM5.5 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8.62 1L6.46 4.34c3.19.3 6.4.2 9.57-.32A1.7 1.7 0 0 1 18 5.7v8.6c0 .44-.17.84-.44 1.14L16 13.88V13a1 1 0 0 0-1-1h-.88Zm.38-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const Video360Off20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video360Off20FilledIcon, 'Video360Off20Filled');

const Video360Off20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2.85 2.15a.5.5 0 1 0-.7.7l1.18 1.19A1.7 1.7 0 0 0 2 5.7v8.6a1.7 1.7 0 0 0 1.97 1.68c3.7-.6 7.46-.64 11.17-.13l2 2a.5.5 0 0 0 .71-.7l-1.18-1.19-6.12-6.12-1.39-1.39L6.01 5.3 4.86 4.15l-2-2ZM13 13.7v.9l-1-.06V12.7l1 1ZM10.3 11H9a1 1 0 0 0-1 1v2.55l-1 .06V12H5a1 1 0 0 0-1 1v1.96l-.19.03A.7.7 0 0 1 3 14.3V5.7a.7.7 0 0 1 .81-.7l.58.1 5.9 5.9Zm3.82 1L16 13.88V13a1 1 0 0 0-1-1h-.88Zm2.73 2.73.71.71c.27-.3.44-.7.44-1.14V5.7a1.7 1.7 0 0 0-1.97-1.68c-3.17.51-6.38.62-9.57.32l1.09 1.09c2.88.18 5.78.04 8.64-.42a.7.7 0 0 1 .81.69v8.6a.7.7 0 0 1-.15.43ZM14 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const Video360Off20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video360Off20RegularIcon, 'Video360Off20Regular');

const Video48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M31 15.25C31 11.8 28.2 9 24.75 9h-14.5A6.25 6.25 0 0 0 4 15.25v17.5C4 36.2 6.8 39 10.25 39h14.5C28.2 39 31 36.2 31 32.75v-17.5Zm2 14.28 6.96 5.44A2.5 2.5 0 0 0 44 33V15a2.5 2.5 0 0 0-4.04-1.97L33 18.47v11.06Z",
    fill: primaryFill
  }));
};

export const Video48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video48FilledIcon, 'Video48Filled');

const Video48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 9A6.25 6.25 0 0 0 4 15.25v17.5C4 36.2 6.8 39 10.25 39h17.5C31.2 39 34 36.2 34 32.75v-2.44l5.96 4.66A2.5 2.5 0 0 0 44 33V15a2.5 2.5 0 0 0-4.04-1.97L34 17.7v-2.44C34 11.8 31.2 9 27.75 9h-17.5ZM34 20.86 41.5 15v18L34 27.14v-6.28Zm-2.5-5.61v17.5a3.75 3.75 0 0 1-3.75 3.75h-17.5a3.75 3.75 0 0 1-3.75-3.75v-17.5a3.75 3.75 0 0 1 3.75-3.75h17.5a3.75 3.75 0 0 1 3.75 3.75Z",
    fill: primaryFill
  }));
};

export const Video48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Video48RegularIcon, 'Video48Regular');

const VideoAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 5.5A2.5 2.5 0 0 0 11.5 3h-6A2.5 2.5 0 0 0 3 5.5v3.1a5.5 5.5 0 0 1 7.8 6.4h.7a2.5 2.5 0 0 0 2.5-2.5v-7Zm1 1.43v4.15l2.76 2.35a.75.75 0 0 0 1.24-.57V5.2a.75.75 0 0 0-1.23-.57L15 6.93Zm-5 6.57a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V13H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H6v-1.5Z",
    fill: primaryFill
  }));
};

export const VideoAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoAdd20FilledIcon, 'VideoAdd20Filled');

const VideoAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 0 0 3 5.5v3.1c.32-.16.65-.3 1-.4V5.5C4 4.67 4.67 4 5.5 4h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-1.52c-.03.34-.1.68-.19 1h1.71a2.5 2.5 0 0 0 2.5-2.5v-1l2.4 1.8a1 1 0 0 0 1.6-.8v-7a1 1 0 0 0-1.6-.8L15 6.5v-1A2.5 2.5 0 0 0 12.5 3h-7ZM15 7.75l3-2.25v7l-3-2.25v-2.5Zm-5 5.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V13H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H6v-1.5Z",
    fill: primaryFill
  }));
};

export const VideoAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoAdd20RegularIcon, 'VideoAdd20Regular');

const VideoAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 16.25c0 1.8-1.46 3.25-3.25 3.25h-.06A6.5 6.5 0 0 0 2 12.81V7.75C2 5.95 3.46 4.5 5.25 4.5h7.5c1.8 0 3.25 1.46 3.25 3.25v8.5Zm5.76-10.36a1 1 0 0 1 .24.65v10.92a1 1 0 0 1-1.65.76L17 15.37V8.63l3.35-2.85a1 1 0 0 1 1.41.11ZM12 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM7 18v2.5a.5.5 0 1 1-1 0V18H3.5a.5.5 0 0 1 0-1H6v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H7Z",
    fill: primaryFill
  }));
};

export const VideoAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoAdd24FilledIcon, 'VideoAdd24Filled');

const VideoAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 4.5c1.8 0 3.25 1.46 3.25 3.25v.17l3.86-2.31a.75.75 0 0 1 1.14.64v11.5c0 .58-.64.94-1.14.64L17 16.07v.18c0 1.8-1.46 3.25-3.25 3.25h-1.06c.15-.48.25-.98.3-1.5h.76c.97 0 1.75-.78 1.75-1.75v-8.5c0-.97-.78-1.75-1.75-1.75h-8.5c-.97 0-1.75.78-1.75 1.75v3.98c-.55.29-1.06.65-1.5 1.08V7.75C2 5.95 3.46 4.5 5.25 4.5h8.5Zm6.75 3.07L17 9.67v4.66l3.5 2.1V7.57ZM12 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM7 18v2.5a.5.5 0 1 1-1 0V18H3.5a.5.5 0 0 1 0-1H6v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H7Z",
    fill: primaryFill
  }));
};

export const VideoAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoAdd24RegularIcon, 'VideoAdd24Regular');

const VideoBackgroundEffect16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.3 3h1.4L1 6.7V5.3L3.3 3ZM1 8.8v1.4l4.15-4.14a3 3 0 0 1 1.9-1.9L8.22 3H6.79L1 8.8Zm4.2-.71L1.1 12.2c.12.32.38.58.7.7l2.24-2.23a2 2 0 0 1 1.65-1.65l.06-.06a3 3 0 0 1-.54-.88Zm6.52 1.9c-.17-.3-.41-.54-.7-.71L15 5.29v1.42l-3.28 3.27ZM12 13h.2l2.8-2.8V8.8l-3 3V13ZM9.97 4.74a3 3 0 0 0-.88-.54l1.2-1.2h1.42L9.97 4.74Zm1.02 2.47a3 3 0 0 0-.17-1.24L13.79 3c.38.01.72.2.94.48L11 7.2ZM10 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-5 6v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2H5Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect16FilledIcon, 'VideoBackgroundEffect16Filled');

const VideoBackgroundEffect16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.3 3h1.4L1 6.7V5.3L3.3 3ZM1 8.8v1.4l4.15-4.14a3 3 0 0 1 1.9-1.9L8.22 3H6.79L1 8.8Zm4.2-.71L1.1 12.2c.12.32.38.58.7.7l2.24-2.23a2 2 0 0 1 1.65-1.65l.06-.06a3 3 0 0 1-.54-.88Zm6.52 1.9c-.17-.3-.41-.54-.7-.71L15 5.29v1.42l-3.28 3.27ZM12 13h.2l2.8-2.8V8.8l-3 3V13ZM9.97 4.74a3 3 0 0 0-.88-.54l1.2-1.2h1.42L9.97 4.74Zm1.02 2.47a3 3 0 0 0-.17-1.24L13.79 3c.38.01.72.2.94.48L11 7.2ZM8 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0 3a1 1 0 0 0-1 1v2h1v-2h4v2h1v-2a1 1 0 0 0-1-1H6Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect16RegularIcon, 'VideoBackgroundEffect16Regular');

const VideoBackgroundEffect20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 4 2 8.2V6.8L4.8 4h1.4Zm7 0-1.46 1.46a3.48 3.48 0 0 0-1.02-.39L11.79 4h1.42Zm-1.08 3.17a2.51 2.51 0 0 0-2.34-1.16 2.5 2.5 0 1 0 2.34 1.16Zm.72-.72c.2.29.37.6.48.94L16.69 4 16.5 4h-1.2l-2.46 2.45ZM7.5 12c-.08 0-.15 0-.22.02A1.5 1.5 0 0 0 6 13.5V16h8v-2.5a1.5 1.5 0 0 0-1.5-1.5h-5Zm5-1c.22 0 .43.03.63.08L18 6.2V5.5c0-.2-.04-.4-.12-.59l-4.5 4.5a3.5 3.5 0 0 1-.93 1.59h.05Zm1.9.88c.23.27.4.58.5.93L18 9.7V8.29l-3.6 3.6ZM15 16v-1.2l3-3v1.4L15.2 16H15Zm-10-.3v-1.4l-1.7 1.69.2.01h1.2l.3-.3Zm1.57-6.48c.08.36.21.7.4 1.02L2.11 15.1A1.5 1.5 0 0 1 2 14.5v-.7l4.57-4.58ZM9.71 4 2 11.7v-1.4L8.3 4h1.4Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect20FilledIcon, 'VideoBackgroundEffect20Filled');

const VideoBackgroundEffect20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 4 2 8.2V6.8L4.8 4h1.4ZM3.5 16H5v-1.7l-1.7 1.69.2.01Zm11.7 0H15v-1.2l3-3v1.4L15.2 16ZM18 9.7l-3.1 3.1a2.5 2.5 0 0 0-.5-.92L18 8.3v1.42ZM12.5 12a1.5 1.5 0 0 1 1.5 1.5V16h-1v-2.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V16H6v-2.5c0-.08 0-.15.02-.22A1.5 1.5 0 0 1 7.5 12h5Zm-2.78-1.02a2.49 2.49 0 0 1-2.21-2.7 2.5 2.5 0 1 1 2.21 2.7ZM10 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-7.88 5.09 4.84-4.85a3.48 3.48 0 0 1-.39-1.02L2 13.79v.71c0 .2.04.4.12.59Zm9.62-9.63a3.48 3.48 0 0 0-1.02-.39L11.79 4h1.42l-1.47 1.46Zm1.58 1.93a3.49 3.49 0 0 0-.48-.94L15.29 4h1.21l.2.01-3.38 3.38ZM12.45 11c.44-.43.76-.98.93-1.59l4.5-4.5c.08.18.12.38.12.59v.7l-4.87 4.88a2.5 2.5 0 0 0-.63-.08h-.05ZM2 11.7 9.7 4H8.3L2 10.3v1.4Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect20RegularIcon, 'VideoBackgroundEffect20Regular');

const VideoBackgroundEffect24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 16.94v2.12l-.94.94H2.94L6 16.94Zm16-2.5v2.12L18.56 20h-.57v-1.56l4.01-4ZM8.75 14h6.5c.91 0 1.67.7 1.74 1.6V20H7v-4.25c0-.92.7-1.67 1.6-1.74l.15-.01Zm-.73-3.58c.06.57.24 1.12.52 1.6L2 18.56v-2.12l6.02-6.02ZM22 9.93v2.13l-4 4v-.31l-.01-.17a2.73 2.73 0 0 0-.39-1.25l4.4-4.4ZM12.06 4 2 14.06v-2.12L9.94 4h2.12ZM22 5.43v2.13l-5.67 5.66a2.73 2.73 0 0 0-.86-.21l-.23-.01h-.6c.35-.3.64-.66.86-1.06l6.5-6.5ZM12 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM7.56 4 2 9.56V7.44L5.44 4h2.12Zm13.5 0L15.9 9.15a3.98 3.98 0 0 0-.65-1.47L18.93 4h2.13Zm-4.5 0L14 6.54a3.97 3.97 0 0 0-1.6-.52L14.45 4h2.12Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect24FilledIcon, 'VideoBackgroundEffect24Filled');

const VideoBackgroundEffect24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 16.94v2.12l-.94.94H2.94L6 16.94Zm16-2.5v2.12L18.56 20h-.57v-1.56l4.01-4ZM8.75 14h6.5c.91 0 1.67.7 1.74 1.6V20h-1.5v-4.25a.25.25 0 0 0-.19-.24l-.06-.01H8.75a.25.25 0 0 0-.24.2l-.01.05V20H7v-4.25c0-.92.7-1.67 1.6-1.74l.15-.01Zm-.73-3.58c.06.57.24 1.12.52 1.6L2 18.56v-2.12l6.02-6.02ZM22 9.93v2.13l-4 4v-.31l-.01-.17a2.73 2.73 0 0 0-.39-1.25l4.4-4.4ZM12.06 4 2 14.06v-2.12L9.94 4h2.12ZM22 5.43v2.13l-5.67 5.66a2.73 2.73 0 0 0-.86-.21l-.23-.01h-.6c.35-.3.64-.66.86-1.06l6.5-6.5ZM12 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM7.56 4 2 9.56V7.44L5.44 4h2.12Zm13.5 0L15.9 9.15a3.98 3.98 0 0 0-.65-1.47L18.93 4h2.13Zm-4.5 0L14 6.54a3.97 3.97 0 0 0-1.6-.52L14.45 4h2.12Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect24RegularIcon, 'VideoBackgroundEffect24Regular');

const VideoBackgroundEffect28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.44 4 2 8.44v2.12L8.56 4H6.44ZM2 13.94v2.12L14.06 4h-2.12L2 13.94Zm0 7.31c0 .1 0 .2.02.3L10 13.56a4.47 4.47 0 0 1-.48-1.64L2 19.44v1.81ZM14.42 7.02c.59.05 1.14.22 1.64.48l3.5-3.5h-2.12l-3.02 3.02ZM7 19.94 3.33 23.6c.42.25.9.39 1.42.39h.31L7 22.06v-2.12Zm11.92-4.3a3 3 0 0 0-.92-.14h-1.06l9.04-9.05.02.3v1.81l-7.08 7.08ZM21 19.06v-.56c0-.46-.1-.89-.28-1.28L26 11.94v2.12l-5 5ZM21 24h.56L26 19.56v-2.12l-5 5V24Zm-2.58-13.36a4.47 4.47 0 0 0-.6-1.52L22.94 4h.31c.52 0 1 .14 1.42.4l-6.25 6.24ZM8 18.5V24h12v-5.5a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2Zm6-3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect28FilledIcon, 'VideoBackgroundEffect28Filled');

const VideoBackgroundEffect28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.44 4 2 8.44v2.12L8.56 4H6.44ZM2 13.94v2.12L14.06 4h-2.12L2 13.94Zm0 7.31c0 .1 0 .2.02.3L10 13.56a4.47 4.47 0 0 1-.48-1.64L2 19.44v1.81ZM14.42 7.02c.59.05 1.14.22 1.64.48l3.5-3.5h-2.12l-3.02 3.02ZM7 19.94 3.33 23.6c.42.25.9.39 1.42.39h.31L7 22.06v-2.12Zm11.92-4.3a3 3 0 0 0-.92-.14h-1.06l9.04-9.05.02.3v1.81l-7.08 7.08ZM21 19.06v-.56c0-.46-.1-.89-.28-1.28L26 11.94v2.12l-5 5ZM21 24h.56L26 19.56v-2.12l-5 5V24Zm-2.58-13.36a4.47 4.47 0 0 0-.6-1.52L22.94 4h.31c.52 0 1 .14 1.42.4l-6.25 6.24ZM10 18a.5.5 0 0 0-.5.5V24H8v-5.5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2V24h-1.5v-5.5a.5.5 0 0 0-.5-.5h-8Zm2-6.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM14 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect28RegularIcon, 'VideoBackgroundEffect28Regular');

const VideoBackgroundEffect32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8.59 6.59 4H9.4L2 11.41V8.6Zm0 9.82V15.6L13.59 4h2.82l-3.06 3.06a6.52 6.52 0 0 0-3.29 3.3L2 18.4Zm0 4.18 7.76-7.76c.2.69.52 1.33.92 1.9l-2.52 2.53c-.35.25-.65.55-.9.9l-5.2 5.2c-.04-.2-.06-.4-.06-.61v-2.16ZM17.83 6.76c.69.2 1.33.52 1.9.92L23.41 4H20.6l-2.76 2.76Zm3.87 3.12c.36.65.6 1.36.72 2.11l6.83-6.82a3.25 3.25 0 0 0-1.75-1.08l-5.8 5.8ZM3.9 27.7 6.5 25.1v2.82l-.09.09H5.25c-.49 0-.95-.1-1.36-.3Zm17.61-9.2a4 4 0 0 1 1.22.2L30 11.4V8.6l-9.91 9.91h1.41Zm4 4v.41l4.5-4.5V15.6l-5 4.99c.32.57.5 1.22.5 1.92Zm1.25 5.5H25.5v-.91l4.5-4.5v2.16c0 .26-.03.51-.09.75l-2.4 2.41c-.25.06-.5.09-.76.09ZM8 22.5V28h16v-5.5a2.5 2.5 0 0 0-2.5-2.5h-11A2.5 2.5 0 0 0 8 22.5Zm8-4.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: primaryFill
  }));
};

export const VideoBackgroundEffect32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VideoBackgroundEffect32FilledIcon, 'VideoBackgroundEffect32Filled');